import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Box from '@mui/material/Box';
// @ts-ignore
// @ts-ignore
import { renderFormatted, ReportTable } from '../components/reportTable';
import { getDataSource } from '../api/ds';
// @ts-ignore
import { FindTextField } from '../components/FindTextField';
// @ts-ignore
// @ts-ignore
import { Tabs, Tab, styled, Typography, Button, TableHead, Checkbox, Card, CardContent, TextField, Dialog, IconButton, Menu, MenuItem, Tooltip, Drawer, Divider, Select, Grid, FormControlLabel, Popover, Switch } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
// @ts-ignore
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { colors } from '../styles/colors';
// @ts-ignore
import Paper from '@mui/material/Paper';
// @ts-ignore
import { styleTable } from '../components/reportTable';
import { TabPanel } from '../components/tabPanel';
// @ts-ignore
// @ts-ignore
import { useSelector } from 'react-redux';
import { get, getFile, post } from 'api/apiBridges/httpBridge';
// @ts-ignore
import SearchIcon from '@mui/icons-material/Search';
// @ts-ignore
import CloseIcon from '@mui/icons-material/Close';
import MuiInput from '@mui/material/Input';
import Loading from 'components/Load';
import Scrollbars from 'rc-scrollbars';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useLocalNotifications } from 'components/Events';
import handleConfirm from 'components/AlertMessage';
import usePreventDoubleClick from 'components/AntiDBC';
import Barcode from 'react-barcode';
import { ShowModal } from 'components/Modal';
import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print';
import useOn from 'components/socketLib/UseOn';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ElementInfo } from 'components/ElementInfo';
// @ts-ignore
import _, { bind, findIndex, replace } from 'lodash';
import { loginSelector } from 'store/slices/loginSlice';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CropFreeIcon from '@mui/icons-material/CropFree';
import CheckIcon from '@mui/icons-material/Check';
// @ts-ignore
import Column from 'rsuite/esm/Table/TableColumn';
import AddIcon from '@mui/icons-material/Add';
import { BCTab, DealTab, ProductMoreInfo, StatusPayChanged, StyledTab } from 'utils/formatters';
import TocIcon from '@mui/icons-material/Toc';
import EAC from '../images/others/EAC.png'


import numberToWordsRu from 'number-to-words-ru';

import FileUploadIcon from '@mui/icons-material/FileUpload';
import * as XLSX from 'xlsx';
// @ts-ignore
import ProductInfo from 'components/EIComponents/ProductInfo';
import ClassicSearch from 'components/classicSearch';
import { useParams } from 'react-router-dom';
import { CancelButton, DropdownMenu, NumInput, NumInputDesign, OKButton, TextInput } from 'components/EIComponents/LittleComponents';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import ExcelJS from 'exceljs';
import DownloadIcon from '@mui/icons-material/Download';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { getDocument } from 'pdfjs-dist';
import { AddProductsForAdmin } from 'components/AddProductsForAdmin';
import defectIcon from '../images/others/defectIcon.png'
import { genDoc } from 'components/genDoc';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { sortProducts } from 'utils/globalSorts';
import CheckList from 'components/TaskList';
import { el } from 'date-fns/locale';
import {Scanner, ScannerBind, ScannerSplit} from 'components/KIZScaner';
import { hoverStyle, hoverStyleTransformOnly } from 'styles/main';
import DraggableModal from 'components/DraggableModal';




// здесь всё по сделкам

function TableDeal({$data, setMainInfo, setSearch, dropLoad, inUse=false}) {

    // @ts-ignore
    const [loading, setLoading] = useState(true);
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    const [market, setMarket] = useState(undefined)
    const [isDefectDeal, setIsDefectDeal] = useState(false)
    /** @type {[Object<boolean, any>, Function]} */
    const [info, setInfo] = useState({ open: false, info: null});
    const [dealNumber, setDealNumber] = useState(null);
    const [FBSData, setFBSData] = useState(null);
    const [CliId, setCliId] = useState(null);
    const [isChanged, setIsChanged] = useState(false);
    const [canAdd, setCanAdd] = useState(false);
    const [canApproveServices, setCanApproveServices] = useState(false);
    const [dealWarehouse, setDealWarehouse] = useState(null);
    const [dealPickupDate, setDealPickupDate] = useState(null);
    const [dealShipmentDate, setDealShipmentDate] = useState(null);
    const [openFBSQRsList, setOpenFBSQRsList] = useState(false);

    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)
    const [allEtimated, setAllEtimated] = useState(0)
    const [allDefect, setAllDefect] = useState(0)

    /** @type {[any, Function]} */
    const [showList, setShowList] = useState(undefined)

    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            color: {name: "Цвет", active: true},
            size: {name: "Размер", active: true}
        }
    );

    const [addProductOpen, setAddProductOpen] = useState(false)

    const { showNotification } = useLocalNotifications();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { socket } = useContext(SocketContext);

    const ds = useMemo(() => {
        let keyword = "DealTable"
        if (market === "consum") {
            keyword = "DealTableConsume"
        }
        if (market === 'wb' && FBSData) {
            keyword = "DealTableFBSWB"
        }
        const $ds = getDataSource(keyword)
        $ds.descr.showDetails = (obj) => {
            console.log("obj", obj)
            setInfo({ open: true, info: {id: obj.id, other: data, set: (input) => {dropLoad([0,1,2], 0); setData(fixSort(input))}, market, close: handleCloseDrawer, isDefectDeal} });
        };
        return $ds;
    }, [data, setInfo, setData, market, isDefectDeal, FBSData]);

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ 
                            fontSize: '14pt', 
                            fontWeight: 'bold', 
                            margin: '5px 15px 5px 10px',
                            color: '#078376'
                        }}>
                        Номер сделки: {dealNumber}
                    </Typography>

                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'  }}>
                        SKU: {allSKU} шт.
                    </Typography>
                    {!isDefectDeal && <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'  }}>
                        Брак: <Typography component="span" sx={{ fontSize: '12pt', color: allDefect !== 0 ? 'red' : 'inherit' }}>{allDefect} шт.</Typography>
                    </Typography>}

                    {allEtimated > 0 &&
                        <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                            Заявлено: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated ? 'red' : 'inherit' }}>{allEtimated} шт.</Typography>
                        </Typography>
                    }
                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                        Фактически: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated && allEtimated > 0? 'red' : 'inherit' }}>{allProduct} шт.</Typography>
                    </Typography>
                    <div>
                        <IconButton
                            onClick={handleClick}
                            // size="large"
                            sx={{
                                width: '56px',
                                height: '36px',
                                backgroundColor: open ? '#F5F9FA' : 'transparent',
                                borderRadius: 1,
                                transition: 'background-color 0.2s ease',
                                // Если меню открыто – убираем скругления снизу, чтобы стыковаться с меню
                                ...(open && { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }),
                            }}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                            sx: {
                                boxShadow: 'none',
                                // border: '1px solid',
                                // borderColor: 'divider',
                                // borderRadius: 1,
                                // Убираем скругления сверху – стык с кнопкой
                                borderTopLeftRadius: 0,
                                borderTopRightRadius: 0,
                                // Небольшое перекрытие, чтобы скрыть возможную щель (пиксель границы)
                                mt: '-1px',
                                ml: "1px",
                                bgcolor: '#F5F9FA',
                                
                            },
                            }}
                            TransitionProps={{ timeout: 200 }}
                            // Изменяем точку привязки – теперь по центру кнопки
                            anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                            }}
                            transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                            }}
                        >
                            {canAdd && 
                                <MenuItem onClick={() => { setAddProductOpen(true); handleClose(); }}>
                                    <Tooltip title="Добавить товар">
                                        <AddIcon />
                                    </Tooltip>
                                </MenuItem>
                            }
                            {canApproveServices && 
                                <MenuItem onClick={() => { approveServices(); handleClose(); }}>
                                    <Tooltip title="Подтвердить обработку">
                                        <CheckIcon />
                                    </Tooltip>
                                </MenuItem>
                            }
                            <MenuItem onClick={() => { printPickUpList(); handleClose(); }}>
                                <Tooltip title="Лист приемки">
                                    <PrintIcon />
                                </Tooltip>
                            </MenuItem>
                            <MenuItem onClick={() => { printPackageList(); handleClose(); }}>
                                <Tooltip title="Лист упаковки">
                                    <PrintIcon />
                                </Tooltip>
                            </MenuItem>
                            {FBSData &&
                                <MenuItem onClick={showFbsQRs}>
                                    <Tooltip title={"QR-кода заказов"}>
                                        <DownloadIcon/>
                                    </Tooltip>
                                </MenuItem> 
                            }
                            {allDefect > 0  &&
                                <MenuItem onClick={defectToStorage}>
                                    <Tooltip title={"Отправить брак на хранение"}>
                                        <img src={defectIcon} style={{height: '24px', width: '24px'}}></img>
                                    </Tooltip>
                                </MenuItem> 
                            }
                        </Menu>
                    </div>
                </>
            )
        }
        if (inUse) {
            setMainInfo(getInfo())
        }
    }, [dealNumber, allSKU, allProduct, allEtimated, allDefect, inUse, open, anchorEl, FBSData, canAdd, canApproveServices]);

    useEffect(() => {
        const getSearch = () => {
            return (
                <>
                    <ClassicSearch 
                        setChecked={setChecked} 
                        setFilter={setFilter} 
                        checked={checked}
                        // @ts-ignore
                        fields={filterFields}
                        // @ts-ignore
                        setFields={setFilterFields}
                    />
                </>
            )
        }
        if (inUse) {
            setSearch(getSearch())
        }
    }, [checked, filterFields, setFilter, setChecked, setFilterFields, inUse]);


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    

    
    const fixSort = (input) => {
        return input.sort((a,b) => String(a.size.barcode).localeCompare(String(b.size.barcode)))
    }

    useOn('updateCountPages', ($data) => {
        let tmp = JSON.parse(JSON.stringify(data))
        if ($data) {
            const index = tmp.findIndex((el) => el.nmID === $data.nmID && el.size.barcode === $data.size);
            if (index !== -1 ) {
                // tmp[index].qrCount = $data.count;
                tmp[index].qrcode.count = $data.count;
                setData(fixSort(tmp));
            }
        }
    });

    const { company_id, user_id } = useSelector(
        loginSelector
    );

    const fetchData = useCallback(async () => {
        try{
            // todo проверка какой маркет выбран
            // добавленный товар исключать путем запроса
            setLoading(true);
    
            let dealRes = await get('Deal/get', {did:$data})
            let deal = dealRes.message
            let dealData = JSON.parse(deal.data)
        

            if (dealData && dealData.cdn) {
                setDealNumber(dealData.cdn);
            }

            if (dealData && dealData.logistic?.shipmentDate) {
                setDealShipmentDate(dealData.logistic.shipmentDate);
            }
            if (dealData && dealData.logistic?.pickupDate) {
                setDealPickupDate(dealData.logistic.pickupDate);
            }
            if (deal.warehouse_market) {
                setDealWarehouse(deal.warehouse_market);
            }

            //TODO
            if ((deal.type === "pik_goods" || deal.type === "moving_deals") && !dealData.movingGuide && !dealData.defect) {
                setCanAdd(true)
            }
            //TODO
            if (deal.type === "moving_deals") {
                setCanApproveServices(true)
            }
            
            setMarket(deal.market)

            let FBS_STATUSES = {}
            if (dealData && dealData.fbs && dealData.fbsdata) {
                setFBSData(dealData.fbsdata)
                if (deal.market == 'wb') {
                    //используем post для получения данных
                    let statuses = await post('WBAPI/getOrderStatuses', {uid:deal.client_id, list:dealData.fbsdata.list})
                    
                    for (let st of statuses) {
                        FBS_STATUSES[st.id] = {order: st.id, status: st.wbStatus}
                    }
                    
                }
                    
            }
            if (dealData && dealData.defect) {
                setIsDefectDeal(true)
            }

            const [res, cliRecvReq] = await Promise.all([
                get("Deal/GetDeliveryProductOnDeal", {did:$data}),
                get('UserRekv/get', {uid:deal.client_id})
            ])

            setCliId(deal.client_id)
            let cliRecv = {}
            if (cliRecvReq?.message) {
                cliRecv = JSON.parse(cliRecvReq.message.data)
            }
            let result = []

            for (let card of res) {                
                let obj = {
                    id:card.id,
                    nmID:card.nmID,
                    deal_id: card.deal_id,
                    data: {
                        market:deal.market,
                        vendorCode:card.vendorCode,
                        brand:card.brand,
                        title:card.title,
                        photo:card.photo,
                        color:card.color,
                        dimensions: card.dimensions,
                        material:card.material,
                        barcode:card.size.barcode,
                        sizeTitle:card.size.title,
                        vendor: cliRecv?.name,
                        expiration_date: card.expiration_date,
                        expiration_time: card.expiration_time,
                        nmID:card.nmID,
                        deal_id: card.deal_id,
                        user_id,
                        url: card.size.url,
                        urlID: card.size?.ozonID || card.nmID,
                        cli: deal.client_id,
                    },

                    countAllProduct:{
                        countProduct:card.countProduct,
                        countEtimated:card.countEtimated,
                        countDefect:card.countDefect,
                        countDefectHist:card.countDefectHist,
                        countProductHist:card.countProductHist
                    },

                    packageFeatures:{
                        labelsCount:card.labelsCount,
                        craftCount:card.craftCount,
                        bookletCount:card.bookletCount,
                        zapayka:card.zapayka
                    },

                    package:card.package,
                    inbox:card.inbox,
                    
                    services: card.services,
                    fixPrice: card.fixPrice || 0,

                    dimensions:card.dimensions,
                    size:card.size,
                    qrcode:{
                        id:card.id, 
                        qr: card.qr, 
                        nmID: card.nmID, 
                        size:card.size.barcode, 
                        count:card.qrCount,
                        //Ниже для логов
                        deal_id:card.deal_id, 
                        product: {
                            nmID: card.nmID,
                            barcode: card.size.barcode,
                            title: card.title,
                            vendorCode: card.vendorCode
                        },
                        user_id,
                        client_id: deal.client_id,
                        market:deal.market,
                        copyCount: card.size.techTask?.services?.find((fel) => fel.name === 'Маркировка товара (КИЗ)')?.data.count || 0,
                    } ,
                    // qrCount: card.qrCount,
                    bind:card.bind,

                    consumes: card.consumes,
                    addit_cons: card.addit_cons,
                    task_list: card.task_list
                }
                if (deal.market !== 'consum') {
                    obj.tz = {
                        ...card.size.techTask, 
                        TZV:card.size.techTask.version, 
                        barcode:card.size.barcode, 
                        title:card.title, 
                        vendorCode: card.vendorCode, 
                        nmID:card.nmID, 
                        deal_id: $data,
                        cli_id: deal.client_id,
                        fbs: card.size.techTask.fbs, 
                    }
                    obj.data.print = card.size.techTask?.print || "classic"
                    obj.data.bcCopy = card.size.techTask?.services?.find((fel) => fel.name === 'Маркировка товара (ШК)')?.data.count || 0
                    obj.data.tz = card.size.techTask.version
                    obj.size.techTask.market = deal.market
                    if (dealData?.fbs) {
                        if (dealData?.fbsdata?.order_barcodes) {
                            let obs = dealData.fbsdata.order_barcodes.filter((fel) => fel.barcode === card.size.barcode)
                            obj.fbsStatus = []
                            for (let ob of obs) {
                                let tmp = FBS_STATUSES[ob.order]
                                if (tmp) {
                                    obj.fbsStatus.push(tmp)   
                                }
                            }
                        }
                    }
                }
                console.log("obj", obj)
                result.push(obj)
            }

            console.log("result", result)

            
            setData(fixSort(result))
        }    
        catch (err) {}
        finally {setLoading(false);}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, []);

    console.log("data", data)

    const handleCloseDrawer = () => {
        if (isChanged) {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть окно без сохранения?</div>,
                async () => {
                    setIsChanged(false);
                    setInfo({ open: false, info: null });
                }
            );
        } else {
            setInfo({ open: false, info: null });
        }
    };

    

    const counttest = () =>{
        console.log("test", data)
        let allsku = 0
        let allproduct = 0
        let alletimated = 0
        let alldefect = 0

        if (data && data.length > 0){
            allsku = data.length
            for(let i = 0 ; i < data.length ; i++){
                allproduct += data[i].countAllProduct.countProduct;
                alletimated += data[i].countAllProduct.countEtimated;
                alldefect += data[i].countAllProduct.countDefect;
            }

            console.log('COUNT SKU', allsku);
            console.log('COUNT PRODUCT', alletimated);
        }
        
        setAllSKU(allsku)
        setAllEtimated(alletimated)
        setAllProduct(allproduct)
        setAllDefect(alldefect)
    }

    useEffect(() => {
        counttest()
    }, [data]); 

    const onChangeRow = (INdata) => {
        if (INdata.size) {
            updateFulfSize(INdata)
            return
        }
        if (INdata.changeTZMode) {
            activateTZEditMode(INdata)
            return
        }
        if (INdata.changeTZ) {
            changeUserTZ(INdata)
            return
        }
        if (INdata.saveTZ) {
            updateProductTZ(INdata)
            return
        }
        updateCountQrs(INdata)  
    }

    const activateTZEditMode = async (INdata) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === INdata.row.id)
        if (idx > -1) {
            let tz = await get("techTask/getOnProduct", {bar: tmp[idx].size.barcode, cid: CliId, market})
            tmp[idx].tz.versions = tz.versions || {}
            tmp[idx].tz.editMode = true
            delete tmp[idx].tz.editModeClose
            setData(fixSort(tmp))
        }      
    }

    const updateProductTZ = async (INdata) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === INdata.row.id)
        if (idx > -1) {
            let tz = {
                text: tmp[idx].tz?.versions?.[tmp[idx].tz.TZV].text || undefined,
                services: tmp[idx].tz.versions?.[tmp[idx].tz.TZV].services || undefined,
                print: tmp[idx].tz.versions?.[tmp[idx].tz.TZV].print || undefined,
                version: tmp[idx].tz.TZV
            }
            tmp[idx].size.techTask = tz
            tmp[idx].data.print = tz.print || 'classic'
            tmp[idx].data.tz = tz.version
            delete tmp[idx].tz.editMode
            tmp[idx].tz.editModeClose = true

            let ps = await get("product_settings/get", {bar:tmp[idx].size.barcode, cid:CliId, market, tz:tmp[idx].tz.TZV})
            tmp[idx].fixPrice = ps?.data?.price || 0

            await post("Deal/updateOnNmAndSize", {
                user_id: user_id,
                nmID:tmp[idx].nmID, 
                deal_id:$data,
                barcode:tmp[idx].size.barcode,
                tz,
                fixPrice: ps?.data?.price || 0
            })
            setData(fixSort(tmp))
        }   
    }

    const changeUserTZ = async (INdata) => {
        console.log("INdata", INdata)
        let tmp = JSON.parse(JSON.stringify(data))
        let found = tmp.findIndex((el) => String(el.id) === String(INdata.row.id))
        if (INdata.swap) {
            if (found !== -1) {
                tmp[found].tz.TZV = INdata.swap
                tmp[found].tz.text = tmp[found].tz.versions[INdata.swap]?.text || undefined
                tmp[found].tz.services = tmp[found].tz.versions[INdata.swap]?.services || undefined
                tmp[found].tz.print = tmp[found].tz.versions[INdata.swap]?.print || undefined
                tmp[found].tz.version = tmp[found].tz.versions[INdata.swap]?.version || undefined
            }
            setData(fixSort(tmp))
            return
        }
        if (found !== -1) {
            //запоминаем матаданные
            const barcode = tmp[found].tz.barcode;
            const title = tmp[found].tz.title
            const vendorCode = tmp[found].tz.vendorCode
            const nmID = tmp[found].tz.nmID
            
            //Проверяем, существовала ли ранее такая версия
            const isCreating = !tmp[found].tz || (
                !tmp[found].tz.versions[INdata.version]?.text &&
                !tmp[found].tz.versions[INdata.version]?.services &&
                !tmp[found].tz.versions[INdata.version]?.print
            )
            // Выполняем запрос на создание
            if (isCreating) {
                await post('techTask/create', {
                    barcode: barcode,
                    client_id: CliId,
                    market,
                    text: INdata.text,
                    services: INdata.services,
                    print: INdata.print,
                    version: INdata.version,
                    comment: INdata.comment,
                    fbs: INdata.fbs,
                });
                showNotification({
                    id: 'tzCreate', 
                    type: 'success', 
                    message: 'ТЗ успешно создано' 
                });
            } 
            else {
            //Проверяем, нет ли уже существующих сделок с этим тз
            let useInDeals = await get('Deal/checkTZ', {
                tz: INdata.version, 
                nmID: tmp[found].nmID,
                barcode: tmp[found].size.barcode,
                market,
                ignore: $data
                }
            )
            //Но если обновлен только комментарий, то просто обновляем
            if (
                useInDeals.message &&
                ( 
                INdata.text !== tmp[found].tz.versions[INdata.version]?.text ||
                INdata.services !== tmp[found].tz.versions[INdata.version]?.services ||
                INdata.print !== tmp[found].tz.versions[INdata.version]?.print
                )
            ) {
                INdata.version = `alt_${Object.keys(tmp[found].tz.versions).length+1}`
                await post('techTask/create', {
                    barcode: barcode,
                    client_id: CliId,
                    market,
                    text: INdata.text,
                    services: INdata.services,
                    print: INdata.print,
                    version: INdata.version,
                    comment: INdata.comment,
                    fbs: INdata.fbs,
                });
                showNotification({
                    id: 'fieldsErr', 
                    type: 'success', 
                    message: 'Альтернативаная версия ТЗ успешно создана' 
                });
            }
            else {
                await post('techTask/update', {
                    barcode: barcode,
                    client_id: CliId,
                    market,
                    text: INdata.text,
                    services: INdata.services,
                    print: INdata.print,
                    version: INdata.version,
                    comment: INdata.comment,
                    fbs: INdata.fbs,
                });
                showNotification({
                    id: 'fieldsErr', 
                    type: 'success', 
                    message: 'ТЗ успешно обновлено' 
                });
            }
            }
            
            let updatedData = await get("techTask/getOnProduct", {bar: barcode, cid: CliId, market})


            tmp[found].tz = {
                barcode: barcode,
                title: title,
                vendorCode:vendorCode,
                versions: updatedData.versions,
                TZV: INdata.version,
                nmID,
                deal_id: $data,
                cli_id: CliId,
                text: updatedData.versions[INdata.version].text,
                services: updatedData.versions[INdata.version].services,
                print: updatedData.versions[INdata.version].print,
                version: INdata.version
            };

            setData(fixSort(tmp));
        } 
    }

    const updateFulfSize = async (INdata) => {
        console.log("fsize", INdata)
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === INdata.row.id)
        if (idx > -1) {
            tmp[idx].size.fulf_size = INdata.dim
            await Promise.all([
                post("Deal/updateOnNmAndSize", {
                    user_id: user_id,
                    nmID:tmp[idx].nmID, 
                    deal_id:tmp[idx].deal_id,
                    barcode:tmp[idx].size.barcode,
                    dim: INdata.dim
                }),
                // post("fulfSize/update", {barcode: tmp[idx].size.barcode, client_id: CliId, market, dimensions: INdata.dim})
                await post("product_settings/update", {barcode: tmp[idx].size.barcode, client_id: tmp[idx].qrcode.client_id, market, tz: tmp[idx].size.techTask.version, data: {dimensions: INdata.dim}})
            ])
            setData(fixSort(tmp))
        }
    }

    const updateCountQrs = (INdata) => {
        console.log("INDATA", INdata)
        setData(prevData => {
            let tmp = JSON.parse(JSON.stringify(prevData))
            let idx = tmp.findIndex((el) => el.id === INdata.row.id)
            console.log("idx", idx)
            
            if (idx > -1) {
                // console.log("tmp[idx].qrCount", tmp[idx].qrCount)
                // console.log("INdata.data.len", INdata.data.len)
                
                if (INdata.data.act === "recover") {
                    // tmp[idx].qrCount = parseInt(tmp[idx].qrCount) + INdata.data.len
                    tmp[idx].qrcode.count = parseInt(tmp[idx].qrcode.count) + INdata.data.len
                } else {
                    // tmp[idx].qrCount = parseInt(tmp[idx].qrCount) - INdata.data.len
                    tmp[idx].qrcode.count = parseInt(tmp[idx].qrcode.count) - INdata.data.len
                }
                
                // console.log(INdata.data.act, tmp[idx].qrCount)
                return fixSort(tmp)
            }
            
            return fixSort(prevData)
        })
    }

    const showFbsQRs = () => {
        setOpenFBSQRsList(true)
        // ShowModal(
        //     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        //         <span>Печать QR-кодов</span>
        //     </div>, 
        //     <div style={{ height: '700px', width: '1000px', padding: '12px' }}>
        //         <FBSQRsModal data={FBSData} market={market} user={CliId}/>
        //     </div>, 
        //     undefined
        // );

        


    }

    const changeTaskList = async (id, list) => {
        
        setLoading(true)
        
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === id)
        
        if (idx > -1) {
            tmp[idx].task_list = list
            await post("Deal/updateOnNmAndSize", {
                user_id: user_id,
                nmID:tmp[idx].nmID, 
                deal_id:$data,
                barcode:tmp[idx].size.barcode,
                task_list: list
            })
            setData(fixSort(tmp))

            showNotification({
                id: 'task_list_ok', 
                type: 'success', 
                message: 'Состояние листа задач обновлено' 
            });

        }

        setShowList(undefined)

        setLoading(false)

    }

    const showTaskList = (item) => {
        console.log('item', item)
        setShowList(item)
    } 

    const approveServices = async () => {
        let fail = false
        let new_pay_list = []
        //"Это код где записывается обработка каждого товара в ручно режиме"
        // for (let item of data) {
        //     if (item.task_list) {
        //         for (let el of item.task_list) {
        //             if (!el.checked) {
        //                 fail = true
        //                 break
        //             }
        //         }
        //         //Для ручной цены
        //         new_pay_list.push({
        //             service: `Обработка товара ${item.data.title}`,
        //             count: item.countAllProduct.countProduct,
        //             price: item.fixPrice,
        //             type: 'hand'
        //         })
        //     }
        //     if (fail) {break}
        // }

        //Это код, где в ручном режими собирается единая услуга на весь товар
        new_pay_list.push({
            service: `Обработка товара`,
            count: 1,
            price: 0,
            type: 'hand'
        })
        for (let item of data) {
            if (item.task_list) {
                for (let el of item.task_list) {
                    if (!el.checked) {
                        fail = true
                        break
                    }
                }
                //Для ручной цены
                new_pay_list[0].price += item.fixPrice * item.countAllProduct.countProduct
            }
            if (fail) {break}
        }
        
        if (fail) {
            showNotification({
                id: 'check_task_list_fail', 
                type: 'error', 
                message: 'Не все товара обрыботаны до конца' 
            });
            return
        }
        
        await post("Deal/addPayServices", {id:$data, list: new_pay_list})
        showNotification({
            id: 'check_task_list_ok', 
            type: 'success', 
            message: 'Услуги добавлены' 
        });
    }



    const printPickUpList = () => {
        let items = []
        let all_count = 0
        data.map((el, index) => {
            let count = el.count || 1
            items.push({
                title: el.data.title,
                color: el.data.color,
                vendorCode: el.data.vendorCode,
                size: el.size.title,
                barcode: el.size.barcode,
                count: FBSData? el.countAllProduct.countProduct: el.countAllProduct.countEtimated

            })
            all_count += FBSData? el.countAllProduct.countProduct: el.countAllProduct.countEtimated
        })

        let obj = {
            pickup_date: dealPickupDate || "-",
            warehouse: dealWarehouse || "-",
            shipment_date: dealShipmentDate || "-",
            items,
            all_count,
            cdn: dealNumber

        }
        genDoc("template_list_priemki_classic", obj, `Лист приемки ${market} - ${dealNumber}`)
    }

    const printPackageList = () => {
        let items = []
        let all_count = 0
        data.map((el, index) => {
            let count = el.count || 1
            let tech_task = ""
            if (el.size.techTask?.text) {
                tech_task += `${el.size.techTask.text}, `
            }
            if (el.task_list) {
                tech_task += el.task_list.map((sel) => sel.serv).join(", ")
            }
            items.push({
                title: el.data.title,
                color: el.data.color,
                vendorCode: el.data.vendorCode,
                size: el.size.title,
                barcode: el.size.barcode,
                count: el.countAllProduct.countProduct, 
                tech_task

            })
            all_count += el.countAllProduct.countProduct
        })

        let obj = {
            pickup_date: dealPickupDate || "-",
            warehouse: dealWarehouse || "-",
            shipment_date: dealShipmentDate || "-",
            items,
            all_count

        }
        genDoc("template_list_upakovki", obj, `Лист упаковки ${market} - ${dealNumber}`)
    }

    const defectToStorage = async () => {
        setLoading(true)
        setAnchorEl(null);
        let tmp = JSON.parse(JSON.stringify(data)) 
        let list = []
        let units = 0
        let nms = []
        //Собираем список брака и изменяем докальные данные
        tmp.map((el) => {
            if (el.countAllProduct.countDefect> 0) {
                list.push(
                    {
                        client_id: CliId,
                        nmID: el.nmID,
                        countProduct: el.countAllProduct.countDefect,
                        vendorCode: el.data.vendorCode,
                        brand: el.data.brand,
                        title: el.data.title,
                        photo: el.data.photo,
                        material: el.data.material,
                        color: el.data.color,
                        size: {...el.size, techTask: {
                            text:"Брак",
                            services: undefined,
                            print: 'classic',
                            version: "defect"
                        }},
                        dimensions: el.data.dimensions
                    }
                
                )
                units += el.countAllProduct.countDefect
                el.countAllProduct.countDefectHist += el.countAllProduct.countDefect
                el.countAllProduct.countDefect = 0
                nms.push(el.nmID)
            }
        })

        //Перемещаем брак на хранение
        let oldDeal = await get('Deal/getCliStorageDefect', {cid: CliId, market})
        if (oldDeal.deal) {
            //Если сделка уже есть, то добавляем товар туда
            await post('Deal/addProductsToDeal', {list, deal_id: oldDeal.deal, replace: false})
        }
        //Иначе, 
        else {
            const cli = await get('Clients/get', {cid:CliId});
            let sku = list.length
            let nd = await post('Deal/create', 
                {
                    products: list, 
                    count_bale: 1, 
                    warehouse_tranzit: "", 
                    warehouse_market: "", 
                    date_shipment: new Date(), 
                    id_company: company_id, 
                    id_client: CliId, 
                    id_manager: Number(cli.message.manager_id), 
                    market: market, 
                    number_order: "",
                    status: 1, 
                    type: "products_storage",
                    data:{
                        sku,
                        units,
                        end_date:new Date(),
                        defect: true,
                    }
                }
            )
            if (nd?.id) {
                //Лог о содании сделки
                await post("Logs/create", {
                    deal_id:nd.id,
                    user_type:"ful",
                    user_id,
                    type: "create_deal",
                    data: {
                        sku,
                        units,
                    }
                })
                socket.emit('add_new_deal', {company_id, type: "products_storage", id:nd.id});
            }
        }
        /////

        //Обновляем товар в бд
        await Promise.all(tmp.map(async (el) => {
            if (nms.includes(el.nmID)) {
                await post("Deal/updateOnNmAndSize", {
                    user_id: user_id,
                    nmID:el.nmID, 
                    deal_id:el.deal_id,
                    barcode:el.size.barcode,
                    countDefect: el.countAllProduct.countDefect,
                    countDefectHist: el.countAllProduct.countDefectHist,
                })
            }
        }))
        ///
        showNotification({
            id: 'succesDefectToStorage', 
            type: 'success', 
            message: `Брак успешно перенесен на хранение`
        });
        setData(tmp)
        setLoading(false)
    }

    const updateFBSPrint = async (list) => {
        let tmpFBSDATA = JSON.parse(JSON.stringify(FBSData))
        tmpFBSDATA.printed = list
        setFBSData(tmpFBSDATA)
        await post("Deal/update", {id:$data, data: {fbsdata: tmpFBSDATA}})
    }


    return (
        <div style={{display: "flex", flexDirection: "column", height: "calc(94% - 50px )", width: "98%", margin: "0% 1% 1% 1%"}}>

            <div style={{
                width: '100%', 
                height: '100%', 
                overflow: 'hidden',
                borderRadius: "10px",
                borderTopLeftRadius: '0px',
                backgroundColor: 'white'
            }}>
                {loading? <Loading/>:
                <Scrollbars
                    style={{ width: '100%', height: "100%"}} 
                >
                    <ReportTable
                        ds={ds} 
                        data={!checked? sortProducts(data): sortProducts(data.filter((el) => {const tf = filter.toLowerCase(); 
                            return (
                                filterFields.title.active && 
                                    el.data.title &&
                                    String(el.data.title).toLowerCase().includes(tf) || 
                                filterFields.brand.active && 
                                    el.data.brand &&
                                    String(el.data.brand).toLowerCase().includes(tf) || 
                                filterFields.vendorCode.active && 
                                    el.data.vendorCode &&
                                    String(el.data.vendorCode).toLowerCase().includes(tf) ||
                                filterFields.color.active &&
                                    el.data.color &&
                                    el.data.color.join(" ").toLowerCase().includes(tf) ||
                                filterFields.size.active &&
                                    el.size.ttle &&
                                    String(el.size.title).toLowerCase().includes(tf) ||
                                filterFields.barcode.active && 
                                    el.size.barcode &&
                                    String(el.size.barcode).toLowerCase().includes(tf)
                            )}))}
                        autoPagination={15}
                        onFormatterChange={onChangeRow}
                        aditionalAction={
                            [
                                {
                                    action: (item) => { showTaskList(item) },
                                    ui: () => {
                                        return (
                                            <TocIcon 
                                                sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                                }
                                            }/>
                                        )
                                    }
                                }
                            ]
                        }
                    />       
                </Scrollbars>
                }
            </div>
            <Drawer
                anchor='right'
                open={info.open}
                onClose={handleCloseDrawer}
            >
                <ElementInfo 
                    ds={getDataSource('EIProduct')} 
                    data={info.info} 
                    // @ts-ignore
                    setChanged={setIsChanged}
                />
            </Drawer>  

            <Dialog
                open={addProductOpen}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setAddProductOpen(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    <AddProductsForAdmin cancel={setAddProductOpen} cli_id={CliId} deal_id={$data} market={market} usedBarcodes={data.map((el) => el.size.barcode)}></AddProductsForAdmin>
                </div>
            </Dialog>
            <Dialog
                open={showList !== undefined}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setShowList(undefined) }}
            >
                <div style={{ height: '700px', width: '500px', padding: '12px' }}>
                    <CheckList list={showList?.task_list || []} onChange={(nl) => {if (showList?.id) {changeTaskList(showList.id, nl)}}} onCancel={() => {setShowList(undefined)}}></CheckList>
                </div>
            </Dialog>
            <Dialog
                open={openFBSQRsList}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px", backgroundColor: 'transparent', boxShadow: 'none'} }}
                onClose={() => { setOpenFBSQRsList(false) }}
            >
                <div style={{ height: '800px', width: '500px', padding: '12px' }}>
                    <FBSQRsModal
                        fbsdata={FBSData} 
                        products={data} 
                        user={CliId} 
                        deal_id={$data} 
                        onClose={() => setOpenFBSQRsList(false)}
                        updateFBSPrinted={(list) => updateFBSPrint(list)}
                        market={market}
                        CDN={dealNumber}
                    />
                </div>
            </Dialog>
        </div>
    );
}

function FBSQRsModalWB({ fbsdata, products, user, onClose }) {
    /** @type {[Array<any>, Function]} */
    const [fileBlob, setFileBlob] = useState([]);
    /** @type {[any, Function]} */
    const [counter, setCounter] = useState({});
    /** @type {[Array<any>, Function]} */
    const [FIIndexes, setFIIndexes] = useState([]);
    
    
    /** @type {[any, Function]} */
    const [printTrigger, setPrintTrigger] = useState(undefined);
    /** @type {[Array<any>, Function]} */
    const [selected, setSelected] = useState([]);

    const [errorSel, setErrorSel] = useState(false);

    const [loading, setLoading] = useState(true);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [delOpen, setDelOpen] = useState(false);
    
    const $ds = useMemo(() => getDataSource('viewIMG'), []);

    const { showNotification } = useLocalNotifications();
    
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            let result = []
            let tmp = {
                all: 0,
                sku: 0,
                barcodes: {

                }
            }
            let files = await get("WBAPI/getOrdersBarcode", {uid:user, list:JSON.stringify(fbsdata.list)})
            if (files.length === 0) {
                showNotification({
                    id: 'ErrorgetOrdersBarcode', 
                    type: 'warning', 
                    message: 'Ни один баркод не найден'
                });
                return 
            }
            files.map((el) => {
                let obitem = fbsdata.order_barcodes.find((fel) => fel.order === el.orderId)
                result.push({
                    id: el.barcode,///Это не баркод товара
                    render: `data:image/png;base64,${el.file}`,
                    order: el.orderId,
                    product: products.find((fel) => fel.size.barcode === obitem.barcode),
                    barcode: obitem.barcode
                })
                tmp.all += 1
                if (tmp.barcodes[obitem.barcode]) {
                    tmp.barcodes[obitem.barcode] +=1
                }
                else {
                    tmp.barcodes[obitem.barcode] = 1
                }
            })
            tmp.sku = Object.keys(tmp.barcodes).length
            console.log("files", result)


            const getFirstOccurrenceIndices = (arr) => {
                const seen = new Map();
                const result = [];
                
                for (let i = 0; i < arr.length; i++) {
                    const barcode = arr[i].barcode;
                    
                    if (!seen.has(barcode)) {
                        seen.set(barcode, true);
                        result.push(i);
                    }
                }
                
                return result;
            }

            let sorted = result.sort((a,b) => a.barcode.localeCompare(b.barcode)) 
            setCounter(tmp)
            setFileBlob(sorted);
            setFIIndexes(getFirstOccurrenceIndices(sorted));
        } catch (error) {
            console.error("Global fetchData error:", error);
        } finally {
            setLoading(false);
        }
    }, [fbsdata]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);



    const printSelContainerRef = useRef(null);

    // Исправленный useReactToPrint с правильными настройками
    const startPrint = useReactToPrint({
        contentRef: printSelContainerRef,
        pageStyle: `
            @page { 
                size: 53mm 37mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important; 
                padding: 0 !important;
                -webkit-print-color-adjust: exact; 
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: auto !important;
                overflow: visible !important;
            }
            * {
                box-sizing: border-box;
            }
            .barcode-print-page {
                width: 53mm;
                height: 37mm;
                page-break-after: always;
                break-after: page;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
            }
            .barcode-print-page:last-child {
                page-break-after: auto;
                break-after: auto;
            }
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            setLoadingPrint(false);
            setDelOpen(true);
            setPrintTrigger(undefined);
        }
    });

    // Исправленный обработчик печати
    const handlePrint = () => {

        setPrintTrigger(fileBlob);
        setLoadingPrint(true);
    };

    // useEffect для запуска печати при изменении триггера
    useEffect(() => {
        if (!printTrigger) {
            return;
        }

        const runPrint = async () => {
            // Небольшая задержка нужна, чтобы React успел отрендерить все элементы
            await new Promise(resolve => setTimeout(resolve, 100));
            startPrint();
        };

        runPrint();
    }, [printTrigger, startPrint]);


    const BarcodeConstructor = ({scale, pr}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "2mm", marginTop:"1.2mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                        <div style={{zIndex: 1, marginLeft:"6mm", marginTop: "-1mm"}}>
                            <Barcode format='CODE128' value={pr.size.barcode} width={1.1} height={24} fontSize={16} textMargin={0} />
                        </div>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mt: "-3mm",
                            zIndex: 2
                        }}>
                            {pr.data?.vendor?.trim().split(/\s+/).filter(Boolean).map((word, i, arr) => i === 0 ? word : arr.length === 2 && i === 1 ? word[0] + '.' : arr.length === 3 && i > 0 ? word[0] + '.' : word).join(' ')}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {pr.data.title}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Бренд: ${pr.data.brand}`}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Цвет: ${pr.data.color.join(", ")}`}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Размер: ${pr.data.sizeTitle}`}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Артикул: ${pr.data.vendorCode}`}
                        </Typography>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };

    const BarcodeCount = ({scale, pr, count}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "3mm", marginTop:"1.2mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", marginLeft: "2mm"}}>
                        <Typography align={'left'} sx={{
                            fontSize: "5mm",
                            fontWeight: 'bold',
                            lineHeight: "5.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {count} ШТ.
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            fontWeight: 'bold',
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {pr.data.title}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Бренд: ${pr.data.brand}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Цвет: ${pr.data.color.join(", ")}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Размер: ${pr.data.sizeTitle}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Баркод: ${pr.size.barcode}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Артикул: ${pr.data.vendorCode}`}
                        </Typography>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };

    const BarcodeCountALL = ({scale}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "3mm", marginTop:"1.2mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", marginLeft: "2mm"}}>
                        <Typography align={'left'} sx={{
                            fontSize: "5mm",
                            fontWeight: 'bold',
                            lineHeight: "5.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mb: "2mm"
                        }}>
                            {fbsdata.date  || new Date().toLocaleDateString('ru-RU')}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            fontWeight: 'bold',
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            Поставка:
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mb: "2mm"
                        }}>
                            {`Поставка от ${fbsdata.date  || new Date().toLocaleDateString('ru-RU')}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mb: "2mm"
                        }}>
                            {`Товаров итого: ${counter?.all}`}
                        </Typography>

                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Артикулов итого: ${counter?.sku}`}
                        </Typography>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };


    if (loading) {
        return (<Loading></Loading>);
    }

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ height: '92%', display: 'flex', flexDirection: 'row' }}>
                <Scrollbars
                    style={{ width: '100%', height: '100%'}} 
                >
                    <div ref={printSelContainerRef} 
                        style={{
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center', 
                            width: "100%", 
                            gap: printTrigger? "0px": "10px"
                        }}>
                        <div
                            key={`bcc_main`}
                            className="barcode-print-page"
                        >
                            <BarcodeCountALL scale={1} />
                        </div>
                        {fileBlob.map((item, index) => (
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: printTrigger? "0px": "10px",}}>
                                {FIIndexes.includes(index) && //печатаем только в первый раз
                                    <div
                                        key={`bcc_${index}`}
                                        className="barcode-print-page"
                                    >
                                        <BarcodeCount scale={1} pr={item.product} count={counter.barcodes[item.product.size.barcode]}/>
                                    </div>
                                }
                                <div
                                    key={`bc_${index}`}
                                    className="barcode-print-page"
                                >
                                    <BarcodeConstructor scale={1} pr={item.product}/>
                                </div>
                                <div key={`print-${index}`} className="barcode-print-page" style={{ width: '58mm', height: '40mm'}}>
                                    <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm", padding: 0,}}>
                                        <CardContent sx={{padding: 0, marginTop:"1.2mm"}}>  
                                        <img 
                                            src={item.render} 
                                            style={{ 
                                                width: '53mm', 
                                                height: '37mm',
                                                objectFit: 'cover',
                                                display: 'block',
                                                margin: 0,
                                                padding: 0,
                                                marginLeft: '2.5mm'
                                            }} 
                                        />
                                        </CardContent>
                                    </Card>
                                </div>
                            </div>
                        ))}
                    </div>
                </Scrollbars>
            </div>
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    height: "8%",
                    width: "100%",
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                }}
            >
            
                <CancelButton action={onClose} text={"ЗАКРЫТЬ"}/>
                <OKButton action={handlePrint} text={"ПЕЧАТЬ"} />
                
            </Box>
        </div>
    );
}

const sortRules = [
  {key: "product.data.title", order: "asc"},
  {key: "product.data.vendorCode", order: "asc"},
  {key: "product.data.sizeTitle", order: "asc"},
  {key: "product.data.color", order: "asc"},
  {key: "product.size.barcode", order: "asc"},
]

function FBSQRsModal({ fbsdata, products, user, deal_id, onClose, updateFBSPrinted, market, CDN}) {
    /** @type {[Array<any>, Function]} */
    const [fileBlob, setFileBlob] = useState([]);
    /** @type {[any, Function]} */
    const [counter, setCounter] = useState({});
    /** @type {[Array<any>, Function]} */
    const [FIIndexes, setFIIndexes] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [printed, setPrinted] = useState([]);
    /** @type {[any, Function]} */
    const [selected, setSelected] = useState({});
    
    
    /** @type {[any, Function]} */
    const [printTrigger, setPrintTrigger] = useState(undefined);

    const [loading, setLoading] = useState(true);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [waiting, setWaiting] = useState(true);
    const [useCounter, setUseCounter] = useState(true);
    
    const [tabIdx, setTabIdx] = useState("actual");
    const handleChangeTab = (event, newValue) => {if (newValue === 'actual') {setSelected({})}; setTabIdx(newValue)};
    
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);

            const getFirstOccurrenceIndices = (arr) => {
                const seen = new Map();
                const result = [];
                
                for (let i = 0; i < arr.length; i++) {
                    const barcode = arr[i].barcode;
                    
                    if (!seen.has(barcode)) {
                        seen.set(barcode, true);
                        result.push(i);
                    }
                }
                
                return result;
            }

            switch (market) {
                case "wb": {
                    
                    let fbsprinted = new Set(fbsdata.printed)

                    let resultActual = []
                    let resultPrinted = []
                    let tmp = {
                        all: 0,
                        sku: 0,
                        barcodes: {

                        }
                    }
                    
                    let files = await get("WBAPI/getOrdersBarcode", {uid:user, list:JSON.stringify(fbsdata.list)})
                    files.map((el) => {
                        let obitem = fbsdata.order_barcodes.find((fel) => fel.order === el.orderId)
                        if (fbsprinted.has(`${el.orderId}_${obitem?.barcode}`)) {
                            resultPrinted.push({
                                id: el.barcode,///Это не баркод товара
                                render: `data:image/png;base64,${el.file}`,
                                order: el.orderId,
                                product: products.find((fel) => fel.size.barcode === obitem.barcode),
                                barcode: obitem.barcode
                            })
                        }
                        else {
                            resultActual.push({
                                id: el.barcode,///Это не баркод товара
                                render: `data:image/png;base64,${el.file}`,
                                order: el.orderId,
                                product: products.find((fel) => fel.size.barcode === obitem.barcode),
                                barcode: obitem.barcode
                            })
                            tmp.all += 1
                            if (tmp.barcodes[obitem.barcode]) {
                                tmp.barcodes[obitem.barcode] +=1
                            }
                            else {
                                tmp.barcodes[obitem.barcode] = 1
                            }
                        }
                    })
                    tmp.sku = Object.keys(tmp.barcodes).length


                    let sortedActual = sortProducts(resultActual, sortRules) 
                    let sortedPrinted = sortProducts(resultPrinted, sortRules)
                    setWaiting(false)//Это механика только для озона, так что сразу отрубаем
                    setCounter(tmp)
                    setFileBlob(sortedActual);
                    setPrinted(sortedPrinted);
                    setFIIndexes(getFirstOccurrenceIndices(sortedActual));
                    break
                }
                case "ozon": {
                    let file = undefined

                    let resp = await get("OZONAPI/getResultOfBarcodTasks", {uid:user, did: deal_id})
                    if (resp.status === 'ok') {
                        file = resp.file
                    }

                    if (!file) {
                        setWaiting(true)
                        return 
                    }
                    setWaiting(false)
                    
                    // file = "https://ir.ozone.ru/s3/ord-tmp-8/small_label/ticket-1195655-487803753-1791261671.pdf"

                    // fbsdata.posting_barcode = [
                    //     {"posting":"68201159-0049-1","barcode":"2044759555174"},{"posting":"34502646-0108-2","barcode":"2042163096436"},{"posting":"0135456587-0098-1","barcode":"2044759561540"},{"posting":"0164516477-0109-2","barcode":"2044759561533"},{"posting":"30796342-0450-2","barcode":"2055154864525"},{"posting":"30796342-0450-5","barcode":"2055154788142"}
                    // ]

                    let fbsprinted = new Set(fbsdata.printed)

                    let resultActual = []
                    let resultPrinted = []
                    let tmp = {
                        all: 0,
                        sku: 0,
                        barcodes: {

                        }
                    }

                    //Функция, которая пропускает дубликаты
                    function removeDuplicatePostingBarcode(data) {
                        const seen = new Set();
                        return data.filter(item => {
                            const key = `${item.posting}|${item.barcode}`;
                            if (seen.has(key)) {
                                return false;
                            }
                            seen.add(key);
                            return true;
                        });
                    }

                    //Это нужно на случай ошибок, если попали дубликаты, чтобы механизм печати не ломался
                    fbsdata.posting_barcode = removeDuplicatePostingBarcode(fbsdata.posting_barcode);

                    try {
                        /** @type {any} */
                        const pdf = await getDocument(file).promise;
                        let i = 2
                        while (i <= pdf.numPages) {

                            const pageQR = await pdf.getPage(i-1);
                            const viewportQR = pageQR.getViewport({ scale: 3.0 });
                            const canvasQR = document.createElement("canvas");
                            canvasQR.width = viewportQR.width;
                            canvasQR.height = viewportQR.height;
                            const contextQR = canvasQR.getContext("2d");
                            await pageQR.render({ canvasContext: contextQR, viewport: viewportQR }).promise;

                            const page = await pdf.getPage(i);
                            const viewport = page.getViewport({ scale: 3.0 });
                            const canvas = document.createElement("canvas");
                            canvas.width = viewport.width;
                            canvas.height = viewport.height;
                            const context = canvas.getContext("2d");
                            await page.render({ canvasContext: context, viewport }).promise;
                            const pinfo = await page.getTextContent();
                            let bc = pinfo.items[0].str//предположительно, это всегда barcode

                            console.log("bc", bc)
                            
                            
                            //Увеличиваем счетчик страниц нa 1 чтобы перейти к следующему баркодам
                            i+=2
                            
                            const render = canvasQR.toDataURL()
                            let pb = fbsdata.posting_barcode.find((fel) => fel.barcode === bc)
                            let pr = undefined
                            //На случай, когда баркоды заказа не совпадают с выбранным в системе
                            if (!pb) {
                                //Сохараняем в pr, чтобы заново не искать товар
                                pr = products.find((fel) => fel.size.barcodes.includes(bc))
                                if (!pr) {}
                                else {pb = fbsdata.posting_barcode.find((fel) => fel.barcode === pr.size.barcode)}
                            }
                            //Это значит, что баркод сразу совпал
                            if (!pr) {
                                products.find((fel) => fel.size.barcode === bc)
                            }

                            console.log("pr", pr)
                            let posting = pb?.posting || ""
                            if (fbsprinted.has(`${posting}_${bc}`)) {
                                resultPrinted.push({
                                    id: `item_${i}`,
                                    render,
                                    posting,
                                    product: pr,
                                    barcode: pr?.size?.barcode
                                })   
                            }
                            else {
                                resultActual.push({
                                    id: `item_${i}`,
                                    render,
                                    posting,
                                    product: pr,
                                    barcode: pr?.size?.barcode
                                })
                                tmp.all += 1
                                if (tmp.barcodes[pr?.size?.barcode]) {
                                    tmp.barcodes[pr?.size?.barcode] +=1
                                }
                                else {
                                    tmp.barcodes[pr?.size?.barcode] = 1
                                }   
                            }
                        }                
                    } catch (pdfError) {
                        console.error(`Ошибка обработки PDF: ${file}`, pdfError);
                    }


                    tmp.sku = Object.keys(tmp.barcodes).length

                    let sortedActual = sortProducts(resultActual, sortRules) 
                    let sortedPrinted = sortProducts(resultPrinted, sortRules)
                    // console.log("sorted", sorted)
                    // console.log("tmp", tmp)
                    setCounter(tmp)
                    setFileBlob(sortedActual);
                    setPrinted(sortedPrinted);
                    setFIIndexes(getFirstOccurrenceIndices(sortedActual));
                }
            }

        } catch (error) {
            console.error("Global fetchData error:", error);
        } finally {
            setLoading(false);
        }
    }, [fbsdata]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const updatePrinted = async () => {
        let tmp = fbsdata.printed || []
        let tmpPrinted = [...printed]
        switch (market) {
            case 'wb': {
                for (let el of fileBlob) {
                    tmp.push(`${el.order}_${el.barcode}`)
                    tmpPrinted.push(el)
                }
                break
            }
            case 'ozon': {
                for (let el of fileBlob) {
                    tmp.push(`${el.posting}_${el.barcode}`)
                    tmpPrinted.push(el)
                }
                break
            }

        }
        setFileBlob([])
        setPrinted(tmpPrinted)
        await updateFBSPrinted(tmp)
    }


    const printContainerRef = useRef(null);
    const printSelContainerRef = useRef(null);

    // Исправленный useReactToPrint с правильными настройками
    const startPrint = useReactToPrint({
        contentRef: tabIdx === 'actual'? printContainerRef: printSelContainerRef,
        pageStyle: `
            @page { 
                size: 58mm 40mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important; 
                padding: 0 !important;
                -webkit-print-color-adjust: exact; 
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: auto !important;
                overflow: visible !important;
            }
            * {
                box-sizing: border-box;
            }
            .barcode-print-page {
                width: 58mm;
                height: 40mm;
                page-break-after: always;
                break-after: page;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
            }
            .barcode-print-page:last-child {
                page-break-after: auto;
                break-after: auto;
            }
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            //Для использованных
            // if (tabIdx === 'actual') {
            //     updatePrinted()
            // }
            setPrintTrigger(undefined);
            setLoadingPrint(false)
        }
    });

    // Исправленный обработчик печати
    const handlePrint = () => {
        setLoadingPrint(true)
        setPrintTrigger(fileBlob);
    };

    // useEffect для запуска печати при изменении триггера
    useEffect(() => {
        if (!printTrigger) {
            return;
        }

        const runPrint = async () => {
            // Небольшая задержка нужна, чтобы React успел отрендерить все элементы
            await new Promise(resolve => setTimeout(resolve, 100));
            startPrint();
        };

        runPrint();
    }, [printTrigger, startPrint]);


    const BarcodeConstructor = ({scale, pr}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "2mm", marginTop:"1mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                        <div style={{zIndex: 1, marginLeft:"6mm", marginTop: "-1.2mm"}}>
                            <Barcode format='CODE128' value={pr?.size?.barcode} width={1.1} height={24} fontSize={16} textMargin={0} />
                        </div>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mt: "-1.5mm",
                            zIndex: 3
                        }}>
                            {pr?.data?.vendor?.trim().split(/\s+/).filter(Boolean).map((word, i, arr) => i === 0 ? word : arr.length === 2 && i === 1 ? word[0] + '.' : arr.length === 3 && i > 0 ? word[0] + '.' : word).join(' ')}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {pr?.data?.title}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Бренд: ${pr?.data?.brand}`}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Цвет: ${pr?.data?.color.join(", ")}`}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Размер: ${pr?.data?.sizeTitle}`}
                        </Typography>
                        <Typography align={'center'} sx={{
                            fontSize: "2.5mm",
                            lineHeight: "2.7mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Артикул: ${pr?.data?.vendorCode}`}
                        </Typography>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };

    const BarcodeCount = ({scale, pr, count}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "3mm", marginTop:"1.2mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", marginLeft: "2mm"}}>
                        <Typography align={'left'} sx={{
                            fontSize: "5mm",
                            fontWeight: 'bold',
                            lineHeight: "5.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {count} ШТ.
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            fontWeight: 'bold',
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {pr?.data?.title}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Бренд: ${pr?.data?.brand}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Цвет: ${pr?.data?.color.join(", ")}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Размер: ${pr?.data?.sizeTitle}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Баркод: ${pr?.size?.barcode}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "3mm",
                            lineHeight: "3.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Артикул: ${pr?.data?.vendorCode}`}
                        </Typography>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };

    const BarcodeCountALL = ({scale}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "3mm", marginTop:"1.2mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", marginLeft: "2mm"}}>
                        <Typography align={'left'} sx={{
                            fontSize: "5mm",
                            fontWeight: 'bold',
                            lineHeight: "5.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mb: "2mm"
                        }}>
                            {fbsdata.date  || new Date().toLocaleDateString('ru-RU')}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            fontWeight: 'bold',
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Сделка: ${CDN}`}
                        </Typography>
                        {/* <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            fontWeight: 'bold',
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            Поставка:
                        </Typography> */}
                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mb: "2mm"
                        }}>
                            {`Поставка от ${fbsdata.date  || new Date().toLocaleDateString('ru-RU')}`}
                        </Typography>
                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            mb: "2mm"
                        }}>
                            {`Товаров итого: ${counter?.all}`}
                        </Typography>

                        <Typography align={'left'} sx={{
                            fontSize: "4mm",
                            lineHeight: "4.2mm",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}>
                            {`Артикулов итого: ${counter?.sku}`}
                        </Typography>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };


    if (loading) {
        return (
            <div style={{width: '100%', height: 'calc(100% - 30px)', display: 'flex', flexDirection: 'column', backgroundColor: 'white', padding: "2%", borderRadius: "10px", borderTopLeftRadius: "10px"}}>
                <Loading/>
            </div>
        );
    }

    if (waiting) {
        return (
            <div style={{width: '100%', height: 'calc(100% - 30px)', display: 'flex', flexDirection: 'row', justifyContent: 'center', backgroundColor: 'white', padding: "2%", borderRadius: "10px", borderTopLeftRadius: "10px"}}>
                <Typography sx={{fontSize: "18px"}}>Этикетки еще формируются</Typography>
            </div>
        )
    }

    return (
        <div style={{width: '100%', height: "100%"}}>
            <Tabs value={tabIdx} onChange={handleChangeTab} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                height: "30px",
                minHeight: "30px"
            }}>
                <BCTab label='АКТУАЛЬНЫЕ' value={'actual'} />
                {/* <BCTab label='ИСПОЛЬЗОВАННЫЕ' value={'printed'} /> */}
            </Tabs>
            <div style={{width: '100%', height: 'calc(100% - 30px)', display: 'flex', flexDirection: 'column', backgroundColor: 'white', padding: "2%", borderRadius: "10px", borderTopLeftRadius: tabIdx === 'actual'? "0px": "10px"}}>
                <div style={{display: 'flex', flexDirection: 'row', width: "100%", height: "92%", justifyContent: 'space-between'}}>
                    <div style={{width: "98%", height: "100%",}}>
                        <TabPanel select={tabIdx} value={'actual'}>
                            <Scrollbars
                                style={{ width: '100%', height: 'calc(100% - 34px)'}} 
                            >
                                <div ref={printContainerRef} 
                                    style={{
                                        display: 'flex', 
                                        flexDirection: 'column', 
                                        alignItems: 'center', 
                                        width: "100%", 
                                        gap: printTrigger? "0px": "10px"
                                }}>
                                    {useCounter && <div
                                        key={`bcc_main`}
                                        className="barcode-print-page"
                                    >
                                        <BarcodeCountALL scale={1} />
                                    </div>}
                                    {fileBlob.map((item, index) => (
                                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: printTrigger? "0px": "10px",}}>
                                            {useCounter && FIIndexes.includes(index) && //печатаем только в первый раз
                                                <div
                                                    key={`bcc_${index}`}
                                                    className="barcode-print-page"
                                                >
                                                    <BarcodeCount scale={1} pr={item.product} count={counter.barcodes[item.product?.size?.barcode]}/>
                                                </div>
                                            }
                                            <div
                                                key={`bc_${index}`}
                                                className="barcode-print-page"
                                            >
                                                <BarcodeConstructor scale={1} pr={item.product}/>
                                            </div>
                                            <div key={`print-${index}`} className="barcode-print-page" style={{ width: '58mm', height: '40mm'}}>
                                                <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm", padding: 0,}}>
                                                    <CardContent sx={{padding: 0, marginTop:"1.2mm"}}>  
                                                    <img 
                                                        src={item.render} 
                                                        style={{ 
                                                            width: '53mm', 
                                                            height: '37mm',
                                                            objectFit: 'cover',
                                                            display: 'block',
                                                            margin: 0,
                                                            padding: 0,
                                                            marginLeft: '2.5mm'
                                                        }} 
                                                    />
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Scrollbars>
                        </TabPanel>
                        <TabPanel select={tabIdx} value={'printed'}>
                            <Scrollbars
                                style={{ width: '100%', height: 'calc(100% - 34px)'}} 
                            >
                                <div
                                    style={{
                                        display: 'flex', 
                                        flexDirection: 'column', 
                                        alignItems: 'center', 
                                        width: "100%", 
                                        gap: printTrigger? "0px": "10px"
                                }}>
                                    {printed.map((item, index) => (
                                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: printTrigger? "0px": "10px",}}>
                                            <div key={`print-${index}`} className="barcode-print-page" style={{ width: '58mm', height: '40mm'}} 
                                                onClick={() => {
                                                    setSelected((prev) => {
                                                        const next = { ...prev }
                                                        if (next[item.id]) {
                                                            delete next[item.id]
                                                        } else {
                                                            next[item.id] = item
                                                        }
                                                        return next
                                                    })
                                                }}
                                            >
                                                <Card 
                                                    sx={{ 
                                                        borderRadius: 3, 
                                                        width: "58mm", 
                                                        height: "40mm", 
                                                        padding: 0,
                                                        borderColor: '#065f52',
                                                        borderStyle: 'solid',
                                                        borderWidth: selected[item.id]? "2px": '0px'
                                                    }}
                                                >
                                                    <CardContent sx={{padding: 0, marginTop:"1.2mm"}}>  
                                                    <img 
                                                        src={item.render} 
                                                        style={{ 
                                                            width: '53mm', 
                                                            height: '37mm',
                                                            objectFit: 'cover',
                                                            display: 'block',
                                                            margin: 0,
                                                            padding: 0,
                                                            marginLeft: '2.5mm'
                                                        }} 
                                                    />
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Scrollbars>
                            
                        </TabPanel>
                    </div>
                </div>
                <div style={{height: "6%", width: "96%", margin: '0 2% 1% 3%',}}>
                    {tabIdx === 'actual' && <FormControlLabel
                        control={
                            <Switch
                                checked={useCounter}
                                onChange={(e) => setUseCounter(e.target.checked)}
                                size="small"
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#078376',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#078376',
                                    },
                                }}
                            />
                        }
                        label={<Typography sx={{ fontSize: '15px' }}>Печатать количество товара</Typography>}
                    />}
                </div>
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        height: "6%",
                        width: "96%",
                        margin: '0 2% 1% 2%',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end'
                    }}
                >
                
                    <CancelButton action={onClose} text={"ЗАКРЫТЬ"}/>
                    <OKButton action={() => handlePrint()} text={"ПЕЧАТЬ"} disabled={loadingPrint || (tabIdx === 'actual' && (fileBlob.length === 0)) || (tabIdx !== 'actual' && Object.keys(selected).length === 0 )}/>
                    
                </Box>
            </div>
            <div style={{ position: 'absolute', right: '9999px', top: 0 }}>
                <div ref={printSelContainerRef} >
                    {Object.values(selected).map((item, index) => (
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: printTrigger? "0px": "10px"}}>
                            <div key={`print-${index}`} className="barcode-print-page" style={{ width: '58mm', height: '40mm'}}>
                                <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm", padding: 0,}}>
                                    <CardContent sx={{padding: 0}}>  
                                    <img 
                                        src={item.render} 
                                        style={{ 
                                            width: '53mm', 
                                            height: '37mm',
                                            objectFit: 'cover',
                                            display: 'block',
                                            margin: 0,
                                            padding: 0,
                                            marginLeft: '2.5mm'
                                        }} 
                                    />
                                    </CardContent>
                                </Card>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}


export function mergeConsumFromDealArrays(arr1, arr2) {
    const map = new Map();

    // Вспомогательная функция для добавления элементов из массива
    const addItems = (arr) => {
        if (!arr) return;
        arr.forEach(item => {
            // Составной ключ из deal и box
            const key = `${item.deal}_${item.box}`;
            if (map.has(key)) {
                // Если уже есть — увеличиваем счётчик
                const existing = map.get(key);
                existing.count += item.count;
            } else {
                // Иначе сохраняем объект целиком
                map.set(key, { deal: item.deal, box: item.box, count: item.count });
            }
        });
    };

    console.log("A1", arr1)
    console.log("A2", arr2)

    addItems(arr1);
    addItems(arr2);

    // Возвращаем массив значений (объектов)
    console.log("Array.from(map.values())", Array.from(map.values()))
    return Array.from(map.values());
}

const BoxPalletSwitch = styled(Switch)(({ theme }) => ({
    width: '120px',
    height: 30,
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: '45%',
        // Начальный отступ слева (2 пикселя)
        transform: 'translateX(2px) translateY(-50%)',

        '&.Mui-checked': {
            // Отступ справа тоже 2 пикселя: 120 - 60 - 2 = 58px смещения
            transform: 'translateX(58px) translateY(-50%)',
            color: '#fff',

            '& .MuiSwitch-thumb:before': {
                content: "'Паллет'",
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
        },
    },

    '& .MuiSwitch-track': {
        borderRadius: 10,
        margin: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,

        '&::before, &::after': {
            position: 'absolute',
            top: '45%',
            transform: 'translateY(-50%)',
            lineHeight: 1,
        },
        '&::before': {
            content: "'Короб'",
            left: 4,
        },
        '&::after': {
            content: "'Паллет'",
            right: 4,
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        backgroundColor: colors.status.high,
        opacity: 1,
        width: 60,
        height: 25,
        marginBlock: 0,
        padding: 0,
        borderRadius: 10,

        '&::before': {
            position: 'absolute',
            top: '45%',
            left: 6,
            transform: 'translateY(-50%)',
            lineHeight: 1,
            content: "'Короб'",
        },
    },
}));

const BoxProductSwitch = styled(Switch)(({ theme }) => ({
    width: '120px',
    height: 30,
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: '45%',
        // Начальный отступ слева (2 пикселя)
        transform: 'translateX(2px) translateY(-50%)',

        '&.Mui-checked': {
            // Отступ справа тоже 2 пикселя: 120 - 60 - 2 = 58px смещения
            transform: 'translateX(58px) translateY(-50%)',
            color: '#fff',

            '& .MuiSwitch-thumb:before': {
                left:8,
                content: "'Товар'",
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
        },
    },

    '& .MuiSwitch-track': {
        borderRadius: 10,
        margin: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,

        '&::before, &::after': {
            position: 'absolute',
            top: '45%',
            transform: 'translateY(-50%)',
            lineHeight: 1,
        },
        '&::before': {
            content: "'Короб'",
            left: 4,
        },
        '&::after': {
            content: "'Товар'",
            right: 4,
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        backgroundColor: colors.status.high,
        opacity: 1,
        width: 60,
        height: 25,
        marginBlock: 0,
        padding: 0,
        borderRadius: 10,

        '&::before': {
            position: 'absolute',
            top: '45%',
            left: 6,
            transform: 'translateY(-50%)',
            lineHeight: 1,
            content: "'Короб'",
        },
    },
}));

function BindDeal({$data, setInfo, setSearch, inUse=false}) {
    
    // console.log('BindDeal render');
    const [loading, setLoading] = useState(false);
    const [dOpen, setDOpen] = useState(false);
    const [noPalletOpen, setNoPalletOpen] = useState(true);
    /** @type {[any, Function]} */
    const [data, setData] = useState({});
    const [tab, setTab] = useState('main');
    /** @type {[Array<any>, Function]} */
    const [MW, setMW] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [avaibleWarehouses, setAvaibleWarehouses] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [boxes, setBoxes] = useState([]);
    const [boxesCount, setBoxesCount] = useState(0);
    const [palletCount, setPalletCount] = useState(0);
    const [notAdaptedBoxesCount, setNotAdaptedBoxesCount] = useState(0);
    /** @type {[Array<any>, Function]} */
    const [changed, setChanged] = useState([]);
    const [selBox, setSelBox] = useState(undefined);
    const [addBoxCount, setAddBoxCount] = useState(1);
    const [addPalletCount, setAddPalletCount] = useState(1);
    /** @type {[any, Function]} */
    const [deal, setDeal] = useState({});
    /** @type {[any, Function]} */
    const [cli, setCli] = useState({});
    /** @type {[any, Function]} */
    const [cliRekv, setCliRekv] = useState({});
    const [shipmentCode, setShipmentCode] = useState("");
    const [shipmentNumber, setShipmentNumber] = useState("");

    /** @type {[any, Function]} */
    const [BCS, setBCS] = useState([]);

    const [blocked, setBlocked] = useState(false);

    const $ds = useMemo(() => blocked? getDataSource('BindProductsBlocked'):getDataSource('BindProducts'), [blocked]);
    const nbds = useMemo(() => getDataSource('NotBindProducts'), []);
    const mwds = useMemo(() => getDataSource('multiWayDelivery'), []);


    /** @type {[any, Function]} */
    const [anchorSettings, setAnchorSettings] = useState(false);// якорь для  меню настроек
    const [dealNumber, setDealNumber] = useState(null);
    const [startData, setStartData] = useState({})
    const [addrs, setAddrs] = useState([]);
    const [idSortOrder, setIdSortOrder] = useState(localStorage.getItem('bindDeal_sortOrder') || 'asc')
    const [dealWarehouseTransit, setDealWarehouseTransit] = useState(null);
    const [dealWarehouse, setDealWarehouse] = useState(null);
    const [dealPickupDate, setDealPickupDate] = useState(null);
    const [dealShipmentDate, setDealShipmentDate] = useState(null);

    const [allCountBinded, setAllCountBinded] = useState(0);
    const [allSkuBinded, setAllSkuBinded] = useState(0);
    const [allSKU, setAllSKU] = useState(0)
    const [allDefect, setAllDefect] = useState(0)
    const [boxed, setBoxed] = useState(0)
    const [unboxed, setUnboxed] = useState(0)
    const [inPalletCount, setInPalletCount] = useState({})
    const [openBindScanner, setOpenBindScanner] = useState(false)
    

    const [anchorBP, setAnchorBP] = useState(null); // якорь для Popover
    const handleOpenBP = (event) => {
        setAnchorBP(event.currentTarget); // привязываем окно к кнопке
    };
    const handleCloseBP = () => {
        setAnchorBP(null);
    };
    const openBP = Boolean(anchorBP);
    const [addTypeBP, setAddTypeBP] = useState(true); 

    /** @type {[any, Function]} */
    const [FBSData, setFBSData] = useState(null);
    /** @type {[any, Function]} */
    const [market, setMarket] = useState(undefined);
    const [CliId, setCliId] = useState(null);


    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            color: {name: "Цвет", active: true},
            size: {name: "Размер", active: true}
        }
    );
    /** @type {[Array<any>, Function]} */
    const [finded, setFinded] = useState([]);


    const [checkedSub, setCheckedSub] = useState(false);
    /** @type {[any, Function]} */
    const [filterSub, setFilterSub] = useState(null);
    const [filterFieldsMW, setFilterFieldsMW] = useState(
        {
            barcode: {name: "ШК", active: true},
            warehouse: {name: "Склад", active: true},
        }
    );
    /** @type {[any, Function]} */
    const [filterWarehouse, setFilterWarehouse] = useState(undefined);

    const [BoxNBarCodeOpen, setBoxNBarCodeOpen] = useState(false)
    const [openFBSBoxesBarcodeWB, setOpenFBSBoxesBarcodeWB] = useState(false)
    /** @type {[any, Function]} */
    const [openKIZ, setOpenKIZ] = useState(undefined)
    const [QRListChange, setQRListChange] = useState(false)
    

    const { user_id, company_id } = useSelector(
        loginSelector
    );

    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{
                        fontSize: '14pt',
                        fontWeight: 'bold',
                        margin: '5px 15px 5px 10px',
                        color: '#078376'
                    }}>
                        Номер сделки: {dealNumber}
                    </Typography>

                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px' }}>
                        SKU: {allSKU} шт.
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'  }}>
                        Брак: <Typography component="span"
                            sx={{ fontSize: '12pt', color: allDefect !== 0 ? 'red' : 'inherit' }}>{allDefect} шт.</Typography>
                    </Typography>

                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                        Не распределено: <Typography component="span">{unboxed} шт.</Typography>
                    </Typography>
                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                        Распределено: <Typography component="span">{boxed} шт.</Typography>
                    </Typography>
                </>
            )
        }
        if (inUse) {
            setInfo(getInfo())
        }   
    }, [dealNumber, allSKU, allDefect, unboxed, boxed, inUse]);

    useEffect(() => {
        const getSearch = () => {
            return (
                <ClassicSearch 
                    setChecked={setChecked} 
                    setFilter={setFilter} 
                    checked={checked}
                    // @ts-ignore
                    fields={filterFields}
                    // @ts-ignore
                    setFields={setFilterFields}
                />
            )
        }
        if (inUse) {
            setSearch(getSearch())
        }
    }, [checked, filterFields, setFilter, setChecked, setFilterFields, inUse]);

    const boxSort = (list) => {
        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';

        return list.sort((a, b) => {
            const partsA = a.title.split('_');
            const partsB = b.title.split('_');

            for (let i = 0; i < partsA.length; i+=2) {//+2 делается, чтобы не сравнивать по клиенту, он всегда одинаковый
            // Извлекаем число из каждой части (предполагается, что часть содержит цифры)
            const numA = parseInt(partsA[i].match(/\d+/)?.[0] || '0', 10);
            const numB = parseInt(partsB[i].match(/\d+/)?.[0] || '0', 10);

            if (numA !== numB) {
                // Числовое сравнение
                return currentSort === 'asc' ? numA - numB : numB - numA;
            }
            // Если числа равны, переходим к следующей части
            }
            // Все части совпадают — объекты эквивалентны
            return 0;
        });
    };

    const fetchData = useCallback(async () => {

        try {
            setLoading(true);
            const [res, res2, dealRes, respb, DNDtables] = await Promise.all([
                get("Deal/GetProductsWithBoxOnDeal", {did:$data}),
                get("Deal/GetDeliveryProductOnDeal", {did:$data}),
                get("Deal/get", {did:$data}),
                get("Boxes/GetOnDeal", {did:$data}),
                get('dndTables/get', {cid:company_id, type: "adrr_storage"})
            ])
            console.log('START RES', res2)
            if (res2) {
                setStartData(res2)
            }

            let deal = dealRes.message
            deal.data = JSON.parse(deal.data)

            setShipmentCode(deal.data.shipmentCode)
            setShipmentNumber(deal.data.shipmentNumber)
            setDealNumber(deal.data.cdn);

            if (deal.data && deal.data.logistic?.shipmentDate) {
                setDealShipmentDate(deal.data.logistic.shipmentDate);
            }
            if (deal.data && deal.data.logistic?.pickupDate) {
                setDealPickupDate(deal.data.logistic.pickupDate);
            }
            if (deal.warehouse_market) {
                setDealWarehouse(deal.warehouse_market);
            }
            if (deal.warehouse_market) {
                setDealWarehouseTransit(deal.warehouse_tranzit);
            }
            
            const mr = deal.market
            const tmpMW = deal.data?.MW || []

            setBlocked(deal.type === 'products_storage' && mr !== 'consum')

            setMarket(mr)

            if (deal.data && deal.data.fbs && deal.data.fbsdata) {
                setFBSData(deal.data.fbsdata)
            }
            setCliId(deal.client_id)

            let skulist = []
            let result = {}
            for (let card of res) {
                let obj = {
                    ...card,
                    data: {
                        market: mr,
                        vendorCode:card.vendorCode,
                        brand:card.brand,
                        title:card.title,
                        photo:card.photo,
                        color:card.color,
                        dimensions: card.dimensions,
                        material:card.material,
                        barcode:card.size.barcode,
                        sizeTitle:card.size.title,
                        url: card.size.url,
                        nmID: card.size?.ozonID || card.nmID
                    },
                }
                if (Object.keys(result).includes(""+card.box_id)) {
                    result[card.box_id].push(obj)
                }
                else {result[card.box_id] = [{...obj}]}
                if (card.box_id !== 0 && !skulist.includes(obj.data.barcode)) {skulist.push(obj.data.barcode)}
            }
            Object.keys(result).forEach(boxId => {
                result[boxId].sort((a, b) => {
                    const barcodeA = String(a.data.barcode || '');
                    const barcodeB = String(b.data.barcode || '');
                    
                    // Сначала сортируем по баркоду товара
                    if (barcodeA !== barcodeB) {
                        return barcodeA.localeCompare(barcodeB);
                    }
                    
                    // Если баркоды совпадают, сортируем по id для абсолютной стабильности
                    return (a.id || 0) - (b.id || 0);
                });
            });
            setData(result)
            setBCS([...new Set(Object.values(result).map((el) => el.map((subel) => subel.size.barcode)).flat())])
            let resb = []
            let AC = 0
            respb.map((el) => {
                resb.push({...el, open:false, openMenu: null, openSelectPallet: null})
                // AC += parseInt(el.count)
                AC += parseFloat(el.count)
            })
            
            setAllCountBinded(AC)
            setAllSkuBinded(skulist.length)
            
            setBoxes(boxSort(resb));
            
            setDeal(deal)


            const [resCli, resCliRekv] = await Promise.all([
                get("Clients/get", {cid: deal.client_id}),
                get('UserRekv/get', {uid:deal.client_id})
            ])
            setCli(resCli.message)
            if (resCliRekv?.message) {
                setCliRekv(JSON.parse(resCliRekv.message.data) || {})
            }

            setMW(tmpMW.sort((a,b) => a.barcode.localeCompare(b.barcode)))

            let tmpAW = []
            tmpMW.map((sel) => {if (!tmpAW.includes(sel.warehouse)) {tmpAW.push(sel.warehouse)}})
            setAvaibleWarehouses(tmpAW)
            
            
            DNDtables.map((t) => {
                t.items.map((subt) => {
                    subt.name = `${subt.status.replaceAll('_', '-')}`
                })
                t.items = t.items.sort((a, b) => parseInt(a.status.split('_')[1]) - parseInt(b.status.split('_')[1]))
            })
            setAddrs(
                DNDtables.sort((a, b) => {
                    // Разделяем строку status на букву и число
                    const [aLetter, aNumStr] = a.status.split('-');
                    const [bLetter, bNumStr] = b.status.split('-');
                    
                    const aNum = parseInt(aNumStr, 10);
                    const bNum = parseInt(bNumStr, 10);
                    
                    // Функция проверки, является ли буква русской (заглавные А-Я, включая Ё)
                    const isRussian = (ch) => /[А-ЯЁ]/.test(ch);
                    
                    const aIsRussian = isRussian(aLetter);
                    const bIsRussian = isRussian(bLetter);
                    
                    // Сначала сортируем по языку: русские раньше английских
                    if (aIsRussian !== bIsRussian) {
                    return aIsRussian ? -1 : 1;
                    }
                    
                    // Если язык одинаковый — сортируем по букве
                    if (aLetter !== bLetter) {
                    return aLetter < bLetter ? -1 : 1;
                    }
                    
                    // Если буквы одинаковые — сортируем по числу
                    return aNum - bNum;
                })
            )
            recalcMW(tmpMW, resb, result)
        }
        catch {}
        finally {setLoading(false);}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, []);

    const recalcMW = (TMW, TB, TD) => {
        console.log("RELAX0", TMW)
        let tmp = JSON.parse(JSON.stringify(TMW))
        tmp.map((el) => {
            console.log()
            let tmpBoxes = TB.filter((fel) => fel.subWarehouse === el.warehouse)
            let c = 0
            tmpBoxes.map((b) => {
                if (TD[b.id]) {
                    c+=TD[b.id].find((fel) => fel.size.barcode === el.barcode)?.countProduct || 0
                }
            })
            el.showCount = `${c}/${el.count}`
        })
        console.log("RELAX", tmp)
        setMW(tmp.sort((a,b) => a.barcode.localeCompare(b.barcode)))
    }

    useEffect(() => {
        recalcMW(MW, boxes, data)
    }, [boxes, data]);
    
    console.log("MW", MW)

    const handleClick = (id) => {
        setScrollPosition()
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        tmp[idx].open = !tmp[idx].open
        setBoxes(boxSort(tmp))
    };

    const handleClickMenuOpen = (event, id) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        tmp[idx].openMenu = event.currentTarget
        setBoxes(boxSort(tmp))
    }

    const handleClickMenuClose = (id) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        tmp[idx].openMenu = null
        tmp[idx].openSelectPallet = null
        setBoxes(boxSort(tmp))
    }

    const handleClickOpenSelectPallet = (event, id) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        console.log("idx", idx)
        tmp[idx].openSelectPallet = event.currentTarget
        setBoxes(boxSort(tmp))
    }


    

    const addProductCalc = async ($selBox, targetBox, products, workData) => {
        console.log("ADD PTOCALC MAIN", $selBox, targetBox, products, workData)
        
        let reserv = JSON.parse(JSON.stringify(workData))
        let TSproductUpdate = [] //post("products/update",
        let TSboxUpdate = [] //post('Boxes/update',
        let TSCreatedProducts = [] //Товары, которые были созданы
        let GlobalErr = false
        
        let tmp = JSON.parse(JSON.stringify(workData))
        let logsData = []
        let ECBuf = 0 //Переменная нужная для учета отрицательного количества заявленных товаров при удалении старого товара
        for (let card of products){
            console.log("APC", tmp, card.box_id, card.id)
            let idx = tmp[card.box_id].findIndex((el) => el.id === card.id)
            console.log("APC2", idx)
            let needAddToFromDealPackage = {}
            let needAddToFromDealConsumes = {}
            let needAddToFromDealAdditConsumes = {}
            let del = false
            if (tmp[card.box_id][idx].countProduct === card.countProduct) {
                //весь товар распределен
                ECBuf = tmp[card.box_id][idx].countEtimated - card.countProduct
                del = true

                // post("products/delete", [tmp[card.box_id][idx].id])
                //Вместо удаления имеет смысл оставлять в нулевом коробе с нулевыми количествами, так как при других изменениях это все равно будет работать так
                //Если мы удаляем товар из нулевого короба полностью, то нас не интересует, сколько там оставалось расходников
                TSproductUpdate.push(
                    {old: 
                        {
                            id:reserv[card.box_id][idx].id, 
                            countProduct:reserv[card.box_id][idx].countProduct, 
                            countEtimated:reserv[card.box_id][idx].countEtimated,
                            countProductHist:reserv[card.box_id][idx].countProductHist, 
                            package:reserv[card.box_id][idx].package || [],
                            consumes:reserv[card.box_id][idx].consumes || [],
                            addit_cons:reserv[card.box_id][idx].addit_cons || []
                        },
                    new:
                        {
                            id:tmp[card.box_id][idx].id, 
                            countProduct:0, 
                            countEtimated:0,
                            countProductHist:0, 
                            package:[],
                            consumes:[],
                            addit_cons:[]
                        }
                    }
                )
            }
            else {
                //распределена часть товара
                tmp[card.box_id][idx].countProduct -= card.countProduct
                tmp[card.box_id][idx].countEtimated -= card.countProduct//Вычитается столько, сколько мы хотим добавить
                if (tmp[card.box_id][idx].countProductHist) {
                    tmp[card.box_id][idx].countProductHist -= card.countProduct
                }
                else {tmp[card.box_id][idx].countProductHist = tmp[card.box_id][idx].countProduct}
                console.log("Добавляемый товар", card)
                //Тут нам надо посчитать сколько расходников останется
                //Для упаковки
                if (tmp[card.box_id][idx].package) {
                    tmp[card.box_id][idx].package.map((cons) => {
                        if (cons.fromDeal) {
                            let consumNeedCountDel = cons.count * card.countProduct
                            if (!needAddToFromDealPackage[cons.id]) {
                                needAddToFromDealPackage[cons.id] = []
                            }
                            cons.fromDeal.map((ofd) => {
                                if (consumNeedCountDel > 0) {
                                    if (ofd.count >= consumNeedCountDel) {
                                        let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealPackage[cons.id].push(fdtmp)
                                        ofd.count = ofd.count - consumNeedCountDel
                                        consumNeedCountDel = 0
                                    }
                                    else {
                                        if (ofd.count > 0) {
                                            let fdtmp = {deal:ofd.deal, count:ofd.count}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealPackage[cons.id].push(fdtmp)
                                            consumNeedCountDel = consumNeedCountDel - ofd.count
                                            ofd.count = 0
                                        }
                                    }
                                }
                            })
                        }
                    })
                }
                //Для комплектации
                if (tmp[card.box_id][idx].consumes) {
                    tmp[card.box_id][idx].consumes.map((cons) => {
                        if (cons.fromDeal) {
                            let consumNeedCountDel = cons.count * card.countProduct
                            if (!needAddToFromDealConsumes[cons.id]) {
                                needAddToFromDealConsumes[cons.id] = []
                            }
                            cons.fromDeal.map((ofd) => {
                                if (ofd.count >= consumNeedCountDel) {
                                    let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                    if (ofd.box) {fdtmp.box = ofd.box}
                                    needAddToFromDealConsumes[cons.id].push(fdtmp)
                                    ofd.count = ofd.count - consumNeedCountDel
                                    consumNeedCountDel = 0
                                }
                                else {
                                    if (ofd.count > 0) {
                                        let fdtmp = {deal:ofd.deal, count:ofd.count}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealConsumes[cons.id].push(fdtmp)
                                        consumNeedCountDel = consumNeedCountDel - ofd.count
                                        ofd.count = 0
                                    }
                                }
                            })
                        }
                    })
                }
                //Для расходников
                if (tmp[card.box_id][idx].addit_cons) {
                    tmp[card.box_id][idx].addit_cons.map((cons) => {
                        if (cons.fromDeal) {
                            let consumNeedCountDel = cons.count * card.countProduct
                            if (!needAddToFromDealAdditConsumes[cons.id]) {
                                needAddToFromDealAdditConsumes[cons.id] = []
                            }
                            cons.fromDeal.map((ofd) => {
                                if (ofd.count >= consumNeedCountDel) {
                                    let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                    if (ofd.box) {fdtmp.box = ofd.box}
                                    needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                    ofd.count = ofd.count - consumNeedCountDel
                                    consumNeedCountDel = 0
                                }
                                else {
                                    if (ofd.count > 0) {
                                        let fdtmp = {deal:ofd.deal, count:ofd.count}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                        consumNeedCountDel = consumNeedCountDel - ofd.count
                                        ofd.count = 0
                                    }
                                }
                            })
                        }
                    })
                }
                ///
                // post("products/update", {
                //     id:tmp[card.box_id][idx].id, 
                //     countProduct:tmp[card.box_id][idx].countProduct, 
                //     countEtimated:tmp[card.box_id][idx].countEtimated,
                //     countProductHist:tmp[card.box_id][idx].countProductHist, 
                //     package:tmp[card.box_id][idx].package || [],
                //     consumes:tmp[card.box_id][idx].consumes || [],
                //     addit_cons:tmp[card.box_id][idx].addit_cons || []
                // })
                TSproductUpdate.push(
                    {old: 
                        {
                            id:reserv[card.box_id][idx].id, 
                            countProduct:reserv[card.box_id][idx].countProduct, 
                            countEtimated:reserv[card.box_id][idx].countEtimated,
                            countProductHist:reserv[card.box_id][idx].countProductHist, 
                            package:reserv[card.box_id][idx].package || [],
                            consumes:reserv[card.box_id][idx].consumes || [],
                            addit_cons:reserv[card.box_id][idx].addit_cons || []
                        },
                    new:
                        {
                            id:tmp[card.box_id][idx].id, 
                            countProduct:tmp[card.box_id][idx].countProduct, 
                            countEtimated:tmp[card.box_id][idx].countEtimated,
                            countProductHist:tmp[card.box_id][idx].countProductHist, 
                            package:tmp[card.box_id][idx].package || [],
                            consumes:tmp[card.box_id][idx].consumes || [],
                            addit_cons:tmp[card.box_id][idx].addit_cons || []
                        }
                    }
                )
            }
            let tmpPack = undefined
            //Считаем значения расходников для товара, который добавляется в короб
            if (tmp[card.box_id][idx].package) {
                tmpPack = JSON.parse(JSON.stringify(tmp[card.box_id][idx].package))
                Object.keys(needAddToFromDealPackage).map((k) => {
                    let npidx = tmpPack.findIndex((fel) => fel.id === Number(k))
                    if (npidx > -1) {
                        tmpPack[npidx].fromDeal = needAddToFromDealPackage[k]
                    }
                })
            }
            
            let tmpConsum = undefined
            if (tmp[card.box_id][idx].consumes) {
                tmpConsum = JSON.parse(JSON.stringify(tmp[card.box_id][idx].consumes))
                Object.keys(needAddToFromDealConsumes).map((k) => {
                    let npidx = tmpConsum.findIndex((fel) => fel.id === Number(k))
                    if (npidx > -1) {
                        tmpConsum[npidx].fromDeal = needAddToFromDealConsumes[k]
                    }
                })
            }

            let tmpAdditConsum = undefined
            if (tmp[card.box_id][idx].addit_cons) {
                tmpAdditConsum = JSON.parse(JSON.stringify(tmp[card.box_id][idx].addit_cons))
                Object.keys(needAddToFromDealAdditConsumes).map((k) => {
                    let npidx = tmpAdditConsum.findIndex((fel) => fel.id === Number(k))
                    if (npidx > -1) {
                        tmpAdditConsum[npidx].fromDeal = needAddToFromDealAdditConsumes[k]
                    }
                })
            }
            ///

            ///Если товар надо удалить, то делаем это
            if (del) {tmp[card.box_id] = tmp[card.box_id].filter((el) => el.id !== card.id)}

            if (Object.keys(tmp).includes(""+$selBox)) {
                idx = tmp[$selBox].findIndex((el) => el.nmID === card.nmID && el.size.barcode === card.size.barcode)
                if (idx >-1) {
                    //в этом коробе уже есть такой же товар
                    tmp[$selBox][idx].countProduct = parseFloat(tmp[$selBox][idx].countProduct) + parseFloat(card.countProduct)
                    tmp[$selBox][idx].countEtimated = parseFloat(tmp[$selBox][idx].countEtimated) + parseFloat(card.countProduct) + ECBuf
                    tmp[$selBox][idx].countProductHist = parseFloat(tmp[$selBox][idx].countProductHist) + parseFloat(card.countProduct)

                    //для расходников
                    if (tmp[$selBox][idx].package) {
                        tmp[$selBox][idx].package.map((cons) => {
                            let npidx = tmpPack.findIndex((fel) => fel.id === cons.id)
                            cons.fromDeal = mergeConsumFromDealArrays(tmpPack[npidx].fromDeal, cons.fromDeal)
                        })
                    }
                    if (tmp[$selBox][idx].consumes) {
                        tmp[$selBox][idx].consumes.map((cons) => {
                            let npidx = tmpConsum.findIndex((fel) => fel.id === cons.id)
                            cons.fromDeal = mergeConsumFromDealArrays(tmpConsum[npidx].fromDeal, cons.fromDeal)
                        })
                    }
                    if (tmp[$selBox][idx].addit_cons) {
                        tmp[$selBox][idx].addit_cons.map((cons) => {
                            let npidx = tmpAdditConsum.findIndex((fel) => fel.id === cons.id)
                            cons.fromDeal = mergeConsumFromDealArrays(tmpAdditConsum[npidx].fromDeal, cons.fromDeal)
                        })
                    }
                    ////

                    // post("products/update", {
                    //     id:tmp[$selBox][idx].id, 
                    //     countProduct:tmp[$selBox][idx].countProduct, 
                    //     countEtimated:tmp[$selBox][idx].countEtimated,
                    //     countProductHist:tmp[$selBox][idx].countProductHist, 
                    //     package:tmp[$selBox][idx].package || [],
                    //     consumes:tmp[$selBox][idx].consumes || [],
                    //     addit_cons:tmp[$selBox][idx].addit_cons || []
                    // })
                    TSproductUpdate.push(
                        {
                        old:
                            {
                                id:reserv[$selBox][idx].id, 
                                countProduct:reserv[$selBox][idx].countProduct, 
                                countEtimated:reserv[$selBox][idx].countEtimated,
                                countProductHist:reserv[$selBox][idx].countProductHist, 
                                package:reserv[$selBox][idx].package || [],
                                consumes:reserv[$selBox][idx].consumes || [],
                                addit_cons:reserv[$selBox][idx].addit_cons || []
                            },
                        new:
                            {
                                id:tmp[$selBox][idx].id, 
                                countProduct:tmp[$selBox][idx].countProduct, 
                                countEtimated:tmp[$selBox][idx].countEtimated,
                                countProductHist:tmp[$selBox][idx].countProductHist, 
                                package:tmp[$selBox][idx].package || [],
                                consumes:tmp[$selBox][idx].consumes || [],
                                addit_cons:tmp[$selBox][idx].addit_cons || []
                            }   
                        }
                    )
                    targetBox.count += parseFloat(card.countProduct)
                    // post('Boxes/update', {id:targetBox.id, count:targetBox.count})
                    TSboxUpdate.push(targetBox.id)
                }
                //в этом коробе ранее не было такого товара
                else {
                    let obj = {...card, 
                        box_id: $selBox, 
                        countEtimated: card.countProduct + ECBuf,
                        countProductHist: card.countProduct,
                        package:tmpPack || [],
                        consumes:tmpConsum || [],
                        addit_cons:tmpAdditConsum || []
                    }
                    delete obj.id
                    delete obj.data
                    let nc = await post("products/create", obj)
                    if (nc.id) {
                        tmp[$selBox].push(
                            {
                                ...card, 
                                box_id: $selBox, 
                                id: nc?.id || undefined,
                                countEtimated: card.countProduct + ECBuf,
                                countProductHist: card.countProduct,
                                package:tmpPack || [],
                                consumes:tmpConsum || [],
                                addit_cons:tmpAdditConsum || []
                            }
                        )
                        targetBox.count += parseFloat(card.countProduct)
                        targetBox.sku += 1
                        // post('Boxes/update', {id:targetBox.id, sku: targetBox.sku, count:targetBox.count})
                        TSboxUpdate.push(targetBox.id)
                        TSCreatedProducts.push(nc.id)
                    }
                    else {
                        GlobalErr = true
                        break
                    }
                    
                }
            }
            //Ранее короб не заполнялся
            else {
                let obj = {...card, 
                    box_id: $selBox, 
                    countEtimated: card.countProduct + ECBuf,
                    countProductHist: card.countProduct,
                    package:tmpPack || [],
                    consumes:tmpConsum || [],
                    addit_cons:tmpAdditConsum || []
                }
                delete obj.id
                delete obj.data
                let nc = await post("products/create", obj)
                if (nc.id) {
                    tmp[$selBox] = [
                        {
                            ...card, 
                            box_id: $selBox, 
                            id: nc?.id || undefined,
                            countEtimated: card.countProduct + ECBuf,
                            countProductHist: card.countProduct,
                            package:tmpPack || [],
                            consumes:tmpConsum || [],
                            addit_cons:tmpAdditConsum || []
                        }
                    ]
                    targetBox.count += parseFloat(card.countProduct)
                    targetBox.sku += 1
                    // post('Boxes/update', {id:targetBox.id, sku: targetBox.sku, count:targetBox.count})
                    TSboxUpdate.push(targetBox.id)
                    TSCreatedProducts.push(nc.id)
                }
                else {
                    GlobalErr = true
                    break
                }
                
            }
            const oldBox = boxes.find((b) => b.id === $selBox)?.title || "Неизвестный короб"

            logsData.push(
                {
                    nmID: card.nmID,
                    barcode: card.data.barcode,
                    title: card.data.title,
                    count: card.countProduct,
                    vendorCode: card.vendorCode,
                    oldBox: oldBox
                }
            )
        }

        //Выносим серверную часть отдельно, мониторим каждое действие
        //Проверяем на наличие ошибок при создании
        if (GlobalErr) {
            //Если во время создания возникли ошибки, то нужно откатить созданные товары
            if (TSCreatedProducts.length > 0) {
                await post("products/delete", TSCreatedProducts)
            }
            showNotification({
                id: 'ErrorAddProduc', 
                type: 'error', 
                message: 'Ошибка при добавлении товаров'
            });
            let btmp = JSON.parse(JSON.stringify(boxes))
            return {data:reserv, boxes:btmp}
        }
        //Если ранее ошибки не было
        else {
            //Сначала нужно пройтись по товарам, которые нужно обновить
            // await Promise.all(TSproductUpdate.map(async (el) => {
            //     let resp = await post("products/update", el.new)
            //     if (resp.message !== 'ok') {
            //         GlobalErr = true
            //     }
            // }))
            let resp = await post("products/updateList", {list: TSproductUpdate.map((el) => el.new)})
            if (resp.message !== 'ok') {
                GlobalErr = true
            }
            //Если возникла глобальная ошибка, то нужно откатить обновлнения
            if (GlobalErr) {
                await Promise.all(TSproductUpdate.map(async (el) => {
                    await post("products/update", el.old)
                })) 
                showNotification({
                    id: 'ErrorAddProduc', 
                    type: 'error', 
                    message: 'Ошибка при добавлении товаров'
                });
                let btmp = JSON.parse(JSON.stringify(boxes))
                return {data:reserv, boxes:btmp}
            }
            else {
                //Если все ок, то действуем дальше
                await post('Boxes/recalcProductsMany', {bids:TSboxUpdate})

                let boxidx = boxes.findIndex((fel) => fel.id === $selBox)
                let logBox = undefined
                if (boxidx > -1) {
                    logBox = boxes[boxidx].title
                }
                console.log('FIND DATA', logsData)
                await post("Logs/create", {
                    deal_id:$data,
                    user_type:"ful",
                    user_id,
                    type: "move_to_box",
                    data: {
                        products: logsData,
                        box:logBox || targetBox?.title || $selBox
                    }
                })
                console.log("TMP", tmp)
                let btmp = JSON.parse(JSON.stringify(boxes))
                let bidx = btmp.findIndex((el) => el.id === targetBox.id)
                console.log("bidx", bidx)
                if (bidx > -1) {btmp[bidx] = targetBox} else{btmp.push(targetBox)}
                return {data:tmp, boxes:btmp}
            }
        }
    }

    const onAddProduct = async (products, box=undefined) => {
        setScrollPosition()
        console.log("products", products)
        console.log("box", box)
        console.log("data", JSON.parse(JSON.stringify(data)))
        console.log("boxes", JSON.parse(JSON.stringify(boxes)))
        // @ts-ignore
        let $selBox = box? box.id: selBox
        console.log("$selBox", $selBox)
        let targetBox = box? JSON.parse(JSON.stringify(box)): JSON.parse(JSON.stringify(boxes)).find((el) => el.id === $selBox)
        console.log("targetBox", targetBox)
        if (!$selBox || !targetBox) { 
            showNotification({
                id: 'ErrorAddProduc', 
                type: 'error', 
                message: 'Ошибка добавления товара' 
            });
            return
        }
        setLoading(true)
        let tmp = JSON.parse(JSON.stringify(data))
        // let Btmp = JSON.parse(JSON.stringify(boxes))
        let res = await addProductCalc($selBox, targetBox, products, tmp)
        setData(res.data)
        setBoxes(boxSort(res.boxes))
        // setData(tmp)
        // setBoxes(btmp.sort((a, b) => (a.id < b.id ? -1 : b.id > a.id ? 1 : 0)))
        setLoading(false)
        showNotification({
            id: 'SuccessAddProduc', 
            type: 'success', 
            message: 'Товар успешно добавлен'
        });
    }


    const onAddProductMany = async (products, $boxes) => {
        console.log("iproducts", products)
        console.log("iboxes", $boxes)
        setScrollPosition()
        setLoading(true)
        let tmp = JSON.parse(JSON.stringify(data))
        console.log("boxes", boxes)
        let boxres = JSON.parse(JSON.stringify(boxes))
        console.log("boxres 1", JSON.parse(JSON.stringify(boxres)))
        for (let box of $boxes) {
            let targetBox = JSON.parse(JSON.stringify(box))
            let res = await addProductCalc(box.id, targetBox, products[box.id], tmp)
            console.log("res", res)
            tmp = JSON.parse(JSON.stringify(res.data))
            let idx = boxres.findIndex((fel) => fel.id === box.id)
            if (idx > -1) {
                boxres[idx] = res.boxes[res.boxes.length -1]
            }
            else {
                boxres.push(res.boxes[res.boxes.length -1])
            }
        }
        setData(tmp)
        let res = boxres.sort((a, b) => (a.id < b.id ? -1 : b.id > a.id ? 1 : 0))
        setBoxes(boxSort(res))
        setLoading(false)
        return res
        
    }


    const copyBox = async (box, parent_id = undefined, boxCount = 1)  => {
        setScrollPosition()
        if (box) {

            let tmp = JSON.parse(JSON.stringify(data))
            let need_products = tmp[box] || []
            let $products = []
            for (let el of need_products) {
                let idx = tmp[0]?.findIndex((fel) => fel.nmID === el.nmID && fel.size.barcode === el.size.barcode)
                if (idx > -1) {
                    if (tmp[0][idx].countProduct >= el.countProduct*boxCount) {
                        $products.push({...tmp[0][idx], countProduct:el.countProduct})
                    }else {break}
                }else {break}
            }

            if (need_products.length !== $products.length) {
                showNotification({
                    id: 'cantcopy', 
                    type: 'error', 
                    message: 'Нераспределенных товаров недостаточно для копирования' 
                });
                return
            }
            else {

                let tmpboxes = JSON.parse(JSON.stringify(boxes)).filter((fel) => fel.type === "box" && fel.title.startsWith(`С${dealNumber}`))
                console.log("tmpboxes", tmpboxes)
                let idx = tmpboxes.sort((a, b) => 
                    (parseInt(b.title.slice(b.title.lastIndexOf('К')+1)) - parseInt(a.title.slice(a.title.lastIndexOf('К')+1))))[0]?.title.lastIndexOf('К')
                // @ts-ignore
                let s = tmpboxes[0].title.slice(idx+1)
                let BN = parseInt(s)
                let boxTitles = []
                for (let index = 1; index <= boxCount; index++) {
                    boxTitles.push(`${BN+index}`)
                }

                // @ts-ignore
                let resBoxes = await addBox(boxTitles.length, boxTitles, "box", parent_id)
                let pobj = {}
                for (let index = 0; index < resBoxes.length; index++) {
                    pobj[resBoxes[index].id] = $products
                }
                let updated = await onAddProductMany(pobj, resBoxes)

                if (parent_id) {
                    let bc = await post("Boxes/recalcBoxCount", {bid:parent_id})
                    idx = updated.findIndex((el) => el.id === parent_id)
                    updated[idx].box_count = bc.count
                    setBoxes(boxSort(updated))
                }

                showNotification({
                    id: 'copysuccess', 
                    type: 'success', 
                    message: `Копирование успешно завершено ${resBoxes.length}/${boxCount}` 
                });
            }

        }
            
        
    }

    const changeBoxWarehouse = (bid, val) => {
        let tmp = JSON.parse(JSON.stringify(boxes))
        let idx = tmp.findIndex((fel) => fel.id === bid)
        if (idx >-1) {
            tmp[idx].subWarehouse = val
            post('Boxes/update', {id:tmp[idx].id, subWarehouse: val})
            setBoxes(boxSort(tmp))
        }
    }

    const openAddProduct = (bid) => {
        setSelBox(bid)
        setDOpen(true)
    }

    // const handleBlur = () => {
    //     if (addBoxCount < 1) {
    //         setAddBoxCount(1);
    //     } 
    // };
    

    const addBox = async (boxCount = undefined, boxTitles = undefined, type = 'box', parent_id = undefined, addr=undefined) => {
        setScrollPosition()
        // setLoading(true) 
        
        let res = []
        let $addBoxCount = boxCount || (type === "box" ? addBoxCount : addPalletCount)
        
        for (let i = 1; i <= $addBoxCount; i++) {
            let BN = undefined
            if (boxTitles) {
                BN = boxTitles[i-1]
            } else {
                let tmpboxex = JSON.parse(JSON.stringify(boxes)).filter((fel) => fel.type === type && fel.title.startsWith(`С${dealNumber}`))
                if (tmpboxex.length > 0) {
                    let idx = tmpboxex.sort((a, b) => (parseInt(b.title.slice(b.title.lastIndexOf(type === 'box'? 'К': "П")+1)) - parseInt(a.title.slice(a.title.lastIndexOf(type === 'box'? 'К': "П")+1))))[0]?.title.lastIndexOf(type === 'box'? 'К': "П") || -1
                    if (idx > -1) {
                        let s = tmpboxex[0].title.slice(idx+1)
                        BN = parseInt(s)+i
                    } else { BN = 1 }
                } else {
                    BN = i
                }
            }   

            let obj = {
                deal_id:$data, 
                title: `С${deal.data.cdn}_к${cli.id}_${type === 'box'? 'К': "П"}${BN}`, 
                sku: 0, 
                count:0, 
                box_count:0, 
                type, 
                parent_id
            }
            if (addr) {obj.addr = addr}
            // @ts-ignore
            let nb = await post("Boxes/create", obj)

            if (nb.message.id) {
                if (addr) {
                    socket.emit("dnd_change_addr", {id:nb.message.id, type:'adrr_storage', company_id})
                }
                res.push({
                    ...nb.message,
                    open: false,
                    openMenu: null,
                    openSelectPallet: null
                })
            }
            else {
                console.log(nb.message)
                showNotification({
                    id: 'addFail', 
                    type: 'error', 
                    message: `Ошибка создания С${deal.data.cdn}_к${cli.id}_${type === 'box'? 'К': "П"}${BN}` 
                });
            }

        }   
        if (res.length > 0 ) {
            let tmp = JSON.parse(JSON.stringify(boxes))
        
            // Пересчет количества привязанных коробов
            if (parent_id) {
                let bc = await post("Boxes/recalcBoxCount", {bid:parent_id})
                let idx = tmp.findIndex((el) => el.id === parent_id)
                tmp[idx].box_count = bc.count
            }
            
            const newBoxes = boxSort(tmp.concat(res));
            
            setBoxes(newBoxes)
            showNotification({
                id: 'addSuccess', 
                type: 'success', 
                message: `${type === 'box'? "Короб": "Паллет"} успешно создан` 
            });
        }
        return res;
    }
    
    

    const editCount = async (idata, box_id) => {
        console.log("editCount", idata, box_id)
        if (idata?.row?.id && idata.count && box_id) {
            //Копируем список изменений
            let tmp = [...changed]
            let idx = tmp.findIndex((el) => el.id === idata.row.id)
            
            let idx2 = data[box_id].findIndex((el) => el.id === idata.row.id)
            console.log("data[box_id][idx2]", data[box_id][idx2])

            // if (idx === -1 && idata.count < data[box_id][idx2].countProduct) {
            //     tmp.push({box:box_id, id:idata.row.id, count: idata.count})
            // }
            // else {
            //     if (idata.count < data[box_id][idx2].countProduct) {
            //         tmp[idx].count = idata.count
            //     }
            //     if (idata.count >= data[box_id][idx2].countProduct) {
            //         tmp.splice(idx, 1)
            //     }
            // }
            if (idx === -1) {
                if (idata.count !== data[box_id][idx2].countProduct) {
                    console.log("v1")
                    tmp.push({box:box_id, id:idata.row.id, count: idata.count})
                }
            }
            else {
                if (idata.count === data[box_id][idx2].countProduct) {
                    console.log("v2")
                    tmp.splice(idx, 1)
                }
                else {
                    console.log("v3")
                    tmp[idx].count = idata.count
                }
            }
            console.log("editCount post",tmp)
            setChanged(tmp)
        }
    }
    console.log("changed", changed)    

    const counttest = () =>{
        if (!startData) return;

        let startKeys = Object.keys(startData)
        let allproduct = 0
        let alldefect = 0
        let allsku = startKeys.length
        let boxed = 0
        let unboxed = 0

        if (boxes && boxes.length > 0) {
            for (let box of boxes){
                boxed += box.count || 0
            }
        }

        for (let key of startKeys){
            let dataprod = startData[key]
            allproduct += dataprod.countProduct || 0
        }

        unboxed = allproduct - boxed
        
        setAllSKU(allsku)
        setAllDefect(alldefect)
        setUnboxed(unboxed)
        setBoxed(boxed)
    }

    useEffect(() => {
        counttest()
    }, [data, boxes, startData]);


    const reculcSku = () => {
        let sku = []
        let count = 0
        let tmpPallets = {}
        Object.keys(data).filter((el) => el != "0").map((box) => {
            let boxObj = boxes.find((fel) => fel.id === Number(box))
            console.log("boxObj", boxObj)
            data[box].map((item) => {
                if (!sku.includes(item.data.barcode)) {sku.push(item.data.barcode)}
                count += parseFloat(item.countProduct)
                if (boxObj?.parent_id) {
                    if (tmpPallets[boxObj.parent_id]) {
                        if (!tmpPallets[boxObj.parent_id].sku.includes(item.data.barcode)) {
                            tmpPallets[boxObj.parent_id].sku.push(item.data.barcode)
                        }
                        tmpPallets[boxObj.parent_id].count += item.countProduct
                    }
                    else {
                        tmpPallets[boxObj.parent_id] = {sku: [item.data.barcode], count: item.countProduct}
                    }
                }
            })
        })
        setAllSkuBinded(sku.length)
        setAllCountBinded(count)
        setInPalletCount(tmpPallets)
    }

    useEffect(() => {
        reculcSku()
    }, [data, boxes]);

    console.log("inPalletCount", inPalletCount)
    

    const save = async (inchanged = undefined) => {
        setScrollPosition()
        setLoading(true)
        let tmp = JSON.parse(JSON.stringify(data))
        console.log(tmp, tmp)
        let Btmp = [...boxes]
        let changedList = inchanged || changed
        console.log("changedList", changedList)
        let logsData = []
        let changedBoxes = []
        for (let card of changedList) {
            // console.log("card", card)
            let idx = tmp[card.box].findIndex((el) => el.id === card.id)

            let bidx = Btmp.findIndex((el) => el.id === card.box)
            if (!changedBoxes.includes(card.box)) {changedBoxes.push(card.box)}

            let needAddToFromDealPackage = {}
            let needAddToFromDealConsumes = {}
            let needAddToFromDealAdditConsumes = {}
            if (idx >- 1) {
                //Увеличение
                if (tmp[card.box][idx].countProduct <= card.count) {
                    // card.count = tmp[card.box][idx].countProduct
                    let addErr = false
                    if (tmp[0]) {
                        let nulIdx = tmp[0].findIndex((el) => el.size.barcode === tmp[card.box][idx].size.barcode)
                        console.log("nulidx", nulIdx)
                        if (nulIdx > -1) {
                            console.log("fff", tmp[0][nulIdx].countProduct, card.count-tmp[card.box][idx].countProduct)
                            if (tmp[0][nulIdx].countProduct >= card.count-tmp[card.box][idx].countProduct)//Далем вычитание, чтобы понимать именно разницу
                            {
                                // await onAddProduct([{...tmp[0][nulIdx], countProduct: card.count-tmp[card.box][idx].countProduct}], Btmp[bidx])
                                let addRes = await addProductCalc(Btmp[bidx].id, Btmp[bidx], [{...tmp[0][nulIdx], countProduct: card.count-tmp[card.box][idx].countProduct}], tmp)
                                tmp = addRes.data
                                Btmp = addRes.boxes
                            }
                            else {addErr = true}
                        }
                        else {addErr = true}
                    }
                    else {addErr = true}
                    if (addErr) {
                        card.count = tmp[card.box][idx].countProduct
                        showNotification({
                            id: 'dontCanAddMoreProduct',
                            type: 'warning', 
                            message: `Недостаточно нераспределенного товара ${tmp[card.box][idx].size.barcode}` 
                        });
                    }   

                }
                else {
                    ///Инфа для логов
                    const oldBox = Btmp.find((b) => b.id === card.box)?.title || "Неизвестный короб"
                    logsData.push(
                        {
                            nmID: tmp[card.box][idx].nmID,
                            barcode: tmp[card.box][idx].data.barcode,
                            title: tmp[card.box][idx].data.title,
                            count: parseFloat(tmp[card.box][idx].countProduct) - card.count,
                            vendorCode: tmp[card.box][idx].vendorCode,
                            oldBox: oldBox
                        }
                    )

                    ///тут по образу и подобию прибавления, считаем вычитание
                    //todo есть смысл потом переписать для оптимизации
                    //Для упаковки
                    if (tmp[card.box][idx].package) {
                        tmp[card.box][idx].package.map((cons) => {
                            if (cons.fromDeal) {
                                let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                if (!needAddToFromDealPackage[cons.id]) {
                                    needAddToFromDealPackage[cons.id] = []
                                }
                                cons.fromDeal.map((ofd) => {
                                    if (consumNeedCountDel > 0) {
                                        if (ofd.count >= consumNeedCountDel) {
                                            let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealPackage[cons.id].push(fdtmp)
                                        }
                                        else {
                                            if (ofd.count > 0) {
                                                let fdtmp = {deal:ofd.deal, count:ofd.count}
                                                if (ofd.box) {fdtmp.box = ofd.box}
                                                needAddToFromDealPackage[cons.id].push(fdtmp)
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                    //Для комплектации
                    if (tmp[card.box][idx].consumes) {
                        tmp[card.box][idx].consumes.map((cons) => {
                            if (cons.fromDeal) {
                                let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                if (!needAddToFromDealConsumes[cons.id]) {
                                    needAddToFromDealConsumes[cons.id] = []
                                }
                                cons.fromDeal.map((ofd) => {
                                    if (ofd.count >= consumNeedCountDel) {
                                        let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealConsumes[cons.id].push(fdtmp)
                                    }
                                    else {
                                        if (ofd.count > 0) {
                                            let fdtmp = {deal:ofd.deal, count:ofd.count}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealConsumes[cons.id].push(fdtmp)
                                        }
                                    }
                                })
                            }
                        })
                    }
                    //Для расходников
                    if (tmp[card.box][idx].addit_cons) {
                        tmp[card.box][idx].addit_cons.map((cons) => {
                            if (cons.fromDeal) {
                                let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                if (!needAddToFromDealAdditConsumes[cons.id]) {
                                    needAddToFromDealAdditConsumes[cons.id] = []
                                }
                                cons.fromDeal.map((ofd) => {
                                    if (ofd.count >= consumNeedCountDel) {
                                        let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                    }
                                    else {
                                        if (ofd.count > 0) {
                                            let fdtmp = {deal:ofd.deal, count:ofd.count}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                        }
                                    }
                                })
                            }
                        })
                    }
                    //Считаем значения расходников для товара, который добавляется в короб
                    let tmpPack = JSON.parse(JSON.stringify(tmp[card.box][idx].package))
                    Object.keys(needAddToFromDealPackage).map((k) => {
                        let npidx = tmpPack.findIndex((fel) => fel.id === Number(k))
                        if (npidx > -1) {
                            tmpPack[npidx].fromDeal = needAddToFromDealPackage[k]
                        }
                    })
                    
                    let tmpConsum = JSON.parse(JSON.stringify(tmp[card.box][idx].consumes))
                    Object.keys(needAddToFromDealConsumes).map((k) => {
                        let npidx = tmpConsum.findIndex((fel) => fel.id === Number(k))
                        if (npidx > -1) {
                            tmpConsum[npidx].fromDeal = needAddToFromDealConsumes[k]
                        }
                    })

                    let tmpAdditConsum = JSON.parse(JSON.stringify(tmp[card.box][idx].addit_cons))
                    Object.keys(needAddToFromDealAdditConsumes).map((k) => {
                        let npidx = tmpAdditConsum.findIndex((fel) => fel.id === Number(k))
                        if (npidx > -1) {
                            tmpAdditConsum[npidx].fromDeal = needAddToFromDealAdditConsumes[k]
                        }
                    })

                    if (Object.keys(tmp).includes("0")) {
                        //Если нулевой короб уже есть
                        let idx2 = tmp[0].findIndex((el) => el.nmID === tmp[card.box][idx].nmID && el.size.barcode === tmp[card.box][idx].size.barcode)
                        if (idx2 >-1) {
                            //в нулевом коробе уже есть такой же товар
                            tmp[0][idx2].countProduct = parseFloat(tmp[0][idx2].countProduct) + (parseFloat(tmp[card.box][idx].countProduct) - card.count)
                            tmp[0][idx2].countEtimated = parseFloat(tmp[0][idx2].countEtimated) + (parseFloat(tmp[card.box][idx].countEtimated) - card.count)
                            tmp[0][idx2].countProductHist = parseFloat(tmp[0][idx2].countProductHist) + (parseFloat(tmp[card.box][idx].countProductHist) - card.count)

                            //для расходников
                            tmp[0][idx2].package.map((cons) => {
                                let npidx = tmpPack.findIndex((fel) => fel.id === cons.id)
                                cons.fromDeal = mergeConsumFromDealArrays(tmpPack[npidx].fromDeal, cons.fromDeal)
                            })
                            tmp[0][idx2].consumes.map((cons) => {
                                let npidx = tmpConsum.findIndex((fel) => fel.id === cons.id)
                                cons.fromDeal = mergeConsumFromDealArrays(tmpConsum[npidx].fromDeal, cons.fromDeal)
                            })
                            tmp[0][idx2].addit_cons.map((cons) => {
                                let npidx = tmpAdditConsum.findIndex((fel) => fel.id === cons.id)
                                cons.fromDeal = mergeConsumFromDealArrays(tmpAdditConsum[npidx].fromDeal, cons.fromDeal)
                            })
                            ////

                            await post("products/update", {
                                id:tmp[0][idx2].id, 
                                countProduct:tmp[0][idx2].countProduct,
                                countProductHist:tmp[0][idx2].countProductHist,
                                countEtimated:tmp[0][idx2].countEtimated,
                                package:tmp[0][idx2].package,
                                consumes:tmp[0][idx2].consumes,
                                addit_cons:tmp[0][idx2].addit_cons
                            })
                        }
                        //в 0 коробе ранее не было такого товара
                        else {
                            let obj = {...tmp[card.box][idx], 
                                box_id: 0, 
                                countProduct: parseFloat(tmp[card.box][idx].countProduct) - card.count,
                                countEtimated: parseFloat(tmp[card.box][idx].countEtimated) - card.count,
                                countProductHist: parseFloat(tmp[card.box][idx].countProductHist) - card.count,
                                package:tmpPack,
                                consumes:tmpConsum,
                                addit_cons:tmpAdditConsum
                            }
                            delete obj.id
                            delete obj.data
                            let nc = await post("products/create", obj)
                            if (nc.id) {
                                tmp[0].push({...tmp[card.box][idx], 
                                    box_id: 0, 
                                    countProduct: parseFloat(tmp[card.box][idx].countProduct) - card.count, 
                                    countEtimated: parseFloat(tmp[card.box][idx].countEtimated) - card.count,
                                    countProductHist: parseFloat(tmp[card.box][idx].countProductHist) - card.count, 
                                    package:tmpPack,
                                    consumes:tmpConsum,
                                    addit_cons:tmpAdditConsum,
                                    id: nc?.id
                                })
                            }
                            
                        }
                    }
                    else {
                        //елс нулевого короба еще нет
                        let obj = {...tmp[card.box][idx], 
                            box_id: 0, 
                            countProduct: parseFloat(tmp[card.box][idx].countProduct) - card.count,
                            countEtimated:parseFloat(tmp[card.box][idx].countEtimated) - card.count,
                            countProductHist: parseFloat(tmp[card.box][idx].countProductHist) - card.count,
                            package:tmpPack,
                            consumes:tmpConsum,
                            addit_cons:tmpAdditConsum
                        }
                        delete obj.id
                        delete obj.data
                        let nc = await post("products/create", obj)
                        if (nc.id) {
                            tmp[0] = [{...tmp[card.box][idx], 
                                box_id: 0, 
                                countProduct: parseFloat(tmp[card.box][idx].countProduct) - card.count,
                                countEtimated: parseFloat(tmp[card.box][idx].countEtimated) - card.count,
                                countProductHist: parseFloat(tmp[card.box][idx].countProductHist) - card.count,
                                package:tmpPack,
                                consumes:tmpConsum,
                                addit_cons:tmpAdditConsum,
                                id: nc?.id
                            }]
                        }
                    }


                    if (parseFloat(card.count) > 0) {
                        //после изменения товара он еще остается в коробе
                        if (bidx>-1) {                            
                            Btmp[bidx].count -= parseFloat(tmp[card.box][idx].countProduct) - parseFloat(card.count)
                            // await post('Boxes/update', {id:Btmp[bidx].id, count:Btmp[bidx].count})
                        }
                        //Тут нам надо посчитать сколько расходников останется
                        //Для упаковки
                        if (tmp[card.box][idx].package) {
                            tmp[card.box][idx].package.map((cons) => {
                                if (cons.fromDeal) {
                                    let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                    cons.fromDeal.map((ofd) => {
                                        if (consumNeedCountDel > 0) {
                                            if (ofd.count >= consumNeedCountDel) {
                                                ofd.count = ofd.count - consumNeedCountDel
                                                consumNeedCountDel = 0
                                            }
                                            else {
                                                if (ofd.count > 0) {
                                                    consumNeedCountDel = consumNeedCountDel - ofd.count
                                                    ofd.count = 0
                                                }
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        //Для комплектации
                        if (tmp[card.box][idx].consumes) {
                            tmp[card.box][idx].consumes.map((cons) => {
                                if (cons.fromDeal) {
                                    let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                    cons.fromDeal.map((ofd) => {
                                        if (ofd.count >= consumNeedCountDel) {
                                            ofd.count = ofd.count - consumNeedCountDel
                                            consumNeedCountDel = 0
                                        }
                                        else {
                                            if (ofd.count > 0) {
                                                consumNeedCountDel = consumNeedCountDel - ofd.count
                                                ofd.count = 0
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        //Для расходников
                        if (tmp[card.box][idx].addit_cons) {
                            tmp[card.box][idx].addit_cons.map((cons) => {
                                if (cons.fromDeal) {
                                    let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                    cons.fromDeal.map((ofd) => {
                                        if (ofd.count >= consumNeedCountDel) {
                                            ofd.count = ofd.count - consumNeedCountDel
                                            consumNeedCountDel = 0
                                        }
                                        else {
                                            if (ofd.count > 0) {
                                                consumNeedCountDel = consumNeedCountDel - ofd.count
                                                ofd.count = 0
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        ///
                        tmp[card.box][idx].countProduct = parseFloat(card.count)
                        tmp[card.box][idx].countEtimated = parseFloat(card.count)
                        tmp[card.box][idx].countProductHist = parseFloat(card.count)
                        await post("products/update", {
                            id:tmp[card.box][idx].id, 
                            countProduct:tmp[card.box][idx].countProduct,
                            countEtimated:tmp[card.box][idx].countEtimated,
                            countProductHist:tmp[card.box][idx].countProductHist,
                            package:tmp[card.box][idx].package,
                            consumes:tmp[card.box][idx].consumes,
                            addit_cons:tmp[card.box][idx].addit_cons
                        })
                    }                
                    else {
                        //после изменения товара в коробе не осталось
                        if (bidx>-1) {
                            Btmp[bidx].count -= parseFloat(tmp[card.box][idx].countProduct)
                            Btmp[bidx].sku -= 1
                            // post('Boxes/update', {id:Btmp[bidx].id, sku: Btmp[bidx].sku, count:Btmp[bidx].count})
                            // await post("Boxes/recalcProducts", {bid: Btmp[bidx].id})
                        }
                        await post("products/delete", [card.id])
                        tmp[card.box] = tmp[card.box].filter((el) => el.id !== card.id)
                        
                    }
                }
            }
        }
        await post("Boxes/recalcProductsMany", {bids: changedBoxes})
        setData(tmp)
        setBoxes(boxSort(Btmp))
        if (logsData.length > 0){
            post("Logs/create", {
                deal_id:$data,
                user_type:"ful",
                user_id,
                type: "move_to_box",
                data: {
                    products: logsData,
                    box: "Нераспределенный товар"
                }
            })
        }
        console.log("SAVE", tmp)
        if (!inchanged) {setChanged([])} else {
            //Так можно сделать, ибо inchanged хоть и массив, но только из 1 элемента
            // @ts-ignore
            let tmpChanged = JSON.parse(JSON.stringify(changed)).filter((el) => el.id != inchanged[0].id) 
            console.log("tmpChanged", tmpChanged)
            setChanged(tmpChanged)
        }
        setLoading(false)
    }


    console.log("data", data)

    


    const delBox = async (bid, parent = undefined) => {

        const del = async (isOk) => {
            if (isOk) {

                let boxIDX = boxes.findIndex((fel) => fel.id === bid)

                if (boxes[boxIDX].market_code_fbs) {
                    //Удаляем короб от поставки вб фбс
                    //FBS_COM
                    let resp = await post("WBAPI/delBoxes", {uid:CliId, supply_id: FBSData.supply_id, market_codes_fbs: [boxes[boxIDX].market_code_fbs]})
                    if (resp.message === 'FAIL') {
                        showNotification({
                            id: 'errordelBoxes', 
                            type: 'warning', 
                            message: 'Не удалось отвязать короб от FBS поставки WB' 
                        });
                    }
                }

                let tmp = boxes.filter((el) => el.id !== bid)

                await post("Boxes/delete", {bid})
                if (parent) {
                    let bc = await post("Boxes/recalcBoxCount", {bid:parent})
                    let idx = tmp.findIndex((fel) => fel.id === parent)
                    tmp[idx].box_count = bc.count
                }
                setBoxes(boxSort(tmp))
                showNotification({
                    id: 'db', 
                    type: 'success', 
                    message: 'Короб удален' 
                });
            }
        }

        if (data[bid] && data[bid].length > 0) {
            showNotification({
                id: 'dberr', 
                type: 'error', 
                message: 'В коробе есть товары' 
            });
        }
        else {
            handleConfirm('Вы уверены, что хотите удалить короб?', del);
        }
    }

    const delBoxes = async () => {
        
        const del = async (isOk) => {
            if (isOk) {
                let list = []
                let parents = []
                for (let b of boxes) {
                    if (b.type === 'box') {
                        if (data[b.id] && data[b.id].length > 0) {
                            showNotification({
                                id: 'dberr', 
                                type: 'error', 
                                message: `В коробе ${b.title} есть товары`
                            });
                        }
                        else {
                            list.push(b.id)
                            if (b.parent_id && !parents.includes(b.parent_id)) {parents.push(b.parent_id)}
                        }
                    }                    
                }
                if (list.length > 0) {
                    let tmpBoxes = boxes.filter((el) => list.includes(el.id))
                    let market_codes_fbs = []
                    tmpBoxes.map((el) => {
                        if (el.market_code_fbs && el.market_code_fbs !== '') {
                            market_codes_fbs.push(el.market_code_fbs)
                        }
                    })

                    //Удаляем короб от поставки вб фбс
                    if (market_codes_fbs.length > 0) {
                        //FBS_COM
                        let resp = await post("WBAPI/delBoxes", {uid:CliId, supply_id: FBSData.supply_id, market_codes_fbs})
                        if (resp.message === 'FAIL') {
                        showNotification({
                            id: 'errordelBoxes', 
                            type: 'warning', 
                            message: 'Не удалось отвязать короб от FBS поставки WB' 
                        });
                    }
                    }

                    let tmp = boxes.filter((el) => !list.includes(el.id))

                    await post("Boxes/delete", {bid:list})

                    await Promise.all(parents.map(async (el) => {
                        let bc = await post("Boxes/recalcBoxCount", {bid:el})
                        let idx = tmp.findIndex((fel) => fel.id === el)
                        tmp[idx].box_count = bc.count
                    }))
                    setBoxes(boxSort(tmp))
                    let tmpFBSDATA = JSON.parse(JSON.stringify(FBSData))
                    tmpFBSDATA.boxCount = 0
                    setFBSData(tmpFBSDATA)
                    await post("Deal/update", {id:$data, data: {fbsdata: tmpFBSDATA}})
                    showNotification({
                        id: 'db', 
                        type: 'success', 
                        message: 'Короба удалены' 
                    });

                }
            }
        }

        handleConfirm('Вы уверены, что хотите удалить все короба?', del);
    }

    ///Этот метод только отвязывает короба от вб, но не удаляет
    const delBoxesFBS = () => {
        const del = async (isOk) => {
            if (isOk) {
                let market_codes_fbs = []
                await Promise.all(boxes.map( async (el) => {
                    if (el.market_code_fbs && el.market_code_fbs !== '') {
                        market_codes_fbs.push(el.market_code_fbs)
                        post('Boxes/update', {id:el.id, market_code_fbs: ""})
                    }
                }))

                //Удаляем короб от поставки вб фбс
                if (market_codes_fbs.length > 0) {
                    //FBS_COM
                    let resp = await post("WBAPI/delBoxes", {uid:CliId, supply_id: FBSData.supply_id, market_codes_fbs})
                    if (resp.message === 'FAIL') {
                        showNotification({
                            id: 'errordelBoxes', 
                            type: 'warning', 
                            message: 'Не удалось отвязать короб от FBS поставки WB' 
                        });
                    }
                    let tmp = JSON.parse(JSON.stringify(FBSData))
                    tmp.boxCount = 0
                    setFBSData(tmp)
                    await post("Deal/update", {id:$data, data: {fbsdata: tmp}})
                    showNotification({
                        id: 'db', 
                        type: 'success', 
                        message: 'Короба отвязаны от FBS поставки' 
                    });
                }
                else {
                    showNotification({
                        id: 'dbwarn', 
                        type: 'warning', 
                        message: 'Привязанных коробов не найдено' 
                    });
                }
            }
        }

        handleConfirm('Отвязать короба от FBS поставки?', del);
    }

    
    const delPallet = async (bid) => {

        const del = async (isOk) => {
            if (isOk) {
                let tmp = boxes.filter((el) => el.id !== bid)
                post("Boxes/delete", {bid})
                setBoxes(boxSort(tmp))
                showNotification({
                    id: 'db', 
                    type: 'success', 
                    message: 'Паллет удален' 
                });
            }
        }

        if (data[bid] && data[bid].length > 0) {
            showNotification({
                id: 'dberr', 
                type: 'error', 
                message: 'На паллете есть товары' 
            });
            return 
        }

        let idx = boxes.findIndex((fel) => fel.parent_id === bid)
        if (idx > -1) {
            showNotification({
                id: 'dberr', 
                type: 'error', 
                message: 'На паллете есть короба' 
            });
            return 
        }

        handleConfirm('Вы уверены, что хотите удалить паллет?', del);
    }
    
    const delPallets = async () => {
        
        const del = async (isOk) => {
            if (isOk) {
                let list = []
                let parents = []
                let tmpBoxes = boxes.filter((el) => el.type === 'box')
                for (let b of boxes) {
                    if (b.type === 'pallet') {
                        let idx = tmpBoxes.findIndex((fel) => fel.parent_id === b.id)
                        if (idx > -1) {
                            showNotification({
                                id: 'dberr', 
                                type: 'error', 
                                message: `В паллете ${b.title} есть короба`
                            });
                            return
                        }
                        if (data[b.id] && data[b.id].length > 0) {
                            showNotification({
                                id: 'dberr', 
                                type: 'error', 
                                message: `На паллете ${b.title} есть товары`
                            });
                            return 
                        }
                        list.push(b.id)
                    }                    
                }
                if (list.length > 0) {
                    let tmp = boxes.filter((el) => !list.includes(el.id))
                    await post("Boxes/delete", {bid:list})

                    setBoxes(boxSort(tmp))
                    showNotification({
                        id: 'db', 
                        type: 'success', 
                        message: 'Паллеты удалены' 
                    });

                }
            }
        }

        handleConfirm('Вы уверены, что хотите удалить все паллеты?', del);
    }

    const setPallet = async (bid, pid) => {
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === bid)
        tmp[idx].openMenu = null
        tmp[idx].openSelectPallet = null
        tmp = JSON.parse(JSON.stringify(tmp))
        let old_parent = tmp[idx].parent_id
        tmp[idx].parent_id = pid
        await post('Boxes/update', {id:bid, parent_id:pid})
        //Пересчитываем количество коробов
        if (old_parent) {
            let bc = await post("Boxes/recalcBoxCount", {bid:old_parent})
            idx = tmp.findIndex((el) => el.id === old_parent)
            tmp[idx].box_count = bc.count
        }
        let bc = await post("Boxes/recalcBoxCount", {bid:pid})
        idx = tmp.findIndex((el) => el.id === pid)
        tmp[idx].box_count = bc.count
        setBoxes(boxSort(tmp))
    }

    const toShortFormat = (s) => {
        return s.split('_').filter((_, i, a) => i === 0 || i === a.length-1).join('_')
    }

    const exportList = async (event, selectedWH = 'Все') => {
        if (event) {
            event.preventDefault(); // Предотвращаем действие по умолчанию
            event.stopPropagation(); // Останавливаем всплытие события
        }
        // 1. Создаем новую книгу и лист
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        let filename = `Привязка ${dealNumber}`;

        const DataArray = []; // Ваши данные здесь


        worksheet.columns = [
            { header: 'Паллет', key: 'pallet'},
            { header: 'Короб', key: 'box'},
            { header: 'Баркод товара', key: 'barcode'},
            { header: 'Кол-во товаров', key: 'count'},
            { header: 'ШК короба', key: 'market_code'},
        ];


        for (let box of boxes) {
            let list = data[box.id]
            if (list) {
                if (box.type === 'box') {
                    let pallet = box.parent_id? boxes.find((fel) => fel.id === box.parent_id).title: '-'
                    for (let product of list) {
                        DataArray.push({pallet: toShortFormat(pallet), box: toShortFormat(box.title), barcode: product.size.barcode, count:product.countProduct, market_code:box.market_code})
                    }
                }
                else {
                    for (let product of list) {
                        DataArray.push({pallet: toShortFormat(box.title), box: '-', barcode: product.size.barcode, count:product.countProduct, market_code:box.market_code})
                    }
                }
            }
        }        

        
        console.log("DataArray", DataArray)
        worksheet.addRows(DataArray);

        // 4. Генерируем файл как буфер
        const buffer = await workbook.xlsx.writeBuffer();

        // 5. Создаем Blob и скачиваем файл
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        

        const blobUrl = URL.createObjectURL(blob);

        // alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${filename}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

    }

    const ShowBarcode = (title, bid) => {
        let cInd = title.indexOf("к")
        let bInd = title.lastIndexOf("К")
        let d = title.slice(1, cInd-1)
        let c = title.slice(cInd+1, bInd-1)
        let b = title.slice(bInd+1, title.length)
        ShowModal('Штрих код', <BoxBarCode D={d} B={b} C={c} id={bid} deal_id={$data} user_id={user_id} WH={dealWarehouse}></BoxBarCode>, undefined);
        
    }

    const ShowMarketBarcode = (mc, title, cbc) => {
        let cInd = title.indexOf("к")
        let bInd = title.lastIndexOf("К")
        let d = title.slice(1, cInd-1)
        let c = title.slice(cInd+1, bInd-1)
        let b = title.slice(bInd+1, title.length)
        if (!cbc) {
            ShowModal('Штрих код', <MarketBarCode code={mc} BOX={b} DEAL={d} CLI={c} deal_id={$data} user_id={user_id}></MarketBarCode>, undefined);
        }
        else {
            ShowModal('Штрих код', <CustomMarketBarCode path={cbc} BOX={b} DEAL={d} CLI={c} deal_id={$data} user_id={user_id}/>, undefined);
        }
    }


    const ShowShipmentBarcode = () => {
        ShowModal('Штрих код', <ShipmentBarCode code={shipmentCode} deal_id={$data} user_id={user_id} warehouse={dealWarehouse} shipmentNumber={shipmentNumber}></ShipmentBarCode>, undefined);
    }

    const ShowAllBarcode = useCallback(async () => {
        let tmp = []
        boxes
            .filter((fel) => fel.type === "box")
            .map((el) => {
                let cInd = el.title.indexOf("к")
                let bInd = el.title.lastIndexOf("К")
                let d = el.title.slice(1, cInd-1)
                let c = el.title.slice(cInd+1, bInd-1)
                let b = el.title.slice(bInd+1, el.title.length)
                tmp.push({D:d, C:c, B:b, id:el.id})
        })
        ShowModal('Штрих код', <BoxAllBarCode boxes={tmp} deal_id={$data} user_id={user_id} WH={dealWarehouse}></BoxAllBarCode>, undefined);
    }, [boxes]);

    
    const ShowBoxNBarCode = useCallback(async () => {
        setBoxNBarCodeOpen(true)
    }, []);

    const ShowAllBarcodePallet = useCallback(async (palletId) => {
        let tmp = []
        
        boxes
            .filter((fel) => fel.type === "box" && fel.parent_id === palletId)
            .map((el) => {
                let cInd = el.title.indexOf("к")
                let bInd = el.title.lastIndexOf("К")
                let d = el.title.slice(1, cInd-1)
                let c = el.title.slice(cInd+1, bInd-1)
                let b = el.title.slice(bInd+1, el.title.length)
                tmp.push({D:d, C:c, B:b, id:el.id})
        })

        // Небольшое улучшение: проверяем, есть ли вообще короба в паллете, 
        // чтобы не открывать пустую модалку
        if (tmp.length > 0) {
            ShowModal('Штрих код', <BoxAllBarCode boxes={tmp} deal_id={$data} user_id={user_id} WH={dealWarehouse}></BoxAllBarCode>, undefined);
        } else {
            showNotification({ id: 'emptyPallet', type: 'warning', message: 'В паллете нет коробов' });
        }
    }, [boxes]);


    const ShowAllMarketBarcode = useCallback(async () => {
        let tmp = []
        boxes
            .filter((fel) => fel.type === "box")
            .map((el) => {
                if (el.market_code) {
                    let cInd = el.title.indexOf("к")
                    let bInd = el.title.lastIndexOf("К")
                    let d = el.title.slice(1, cInd-1)
                    let c = el.title.slice(cInd+1, bInd-1)
                    let b = el.title.slice(bInd+1, el.title.length)
                    tmp.push({DEAL:d, CLI:c, BOX:b, code:el.market_code, cbc:el.marcket_bc_path})
                }
        })
        ShowModal('Штрих код', <MarketAllBarCode boxes={tmp} deal_id={$data} user_id={user_id}></MarketAllBarCode>, undefined);
    }, [boxes]);


    const cleanBoxes = async () => {
        setScrollPosition()
        const isConfirmed = window.confirm('Вы уверены, что хотите очистить все короба?');
        if (!isConfirmed){return;}
        setLoading(true)
        const updates = [];
        const dataKeys = Object.keys(data).filter((fel) => fel !== "0");
        dataKeys.sort((a, b) => Number(a) - Number(b)); 

        for (let i = 0; i < dataKeys.length; i++){
            const boxItems = data[dataKeys[i]];
            if (Array.isArray(boxItems)) {
                for(const item of boxItems){
                    updates.push({
                        box: item.box_id, 
                        id: item.id,     
                        count: 0         
                    });
                }
            }
        }

        console.log("updates", updates)
        setLoading(false)
        if (updates.length > 0) {
            // @ts-ignore
            await save(updates);
            showNotification({
                id: 'cleanSuccess', 
                type: 'success', 
                message: 'Все короба очищены'}
            )
        } else {
            showNotification({
                id: 'cleanEmpty', 
                type: 'warning', 
                message: 'В коробах нет товаров'}
            )
        }
    };

    const openSettings = Boolean(anchorSettings);// открыт ли Popover настроек
    //Функции для открытия и закрытия настроек
    const openMenuSettigs = (event) => {
        setAnchorSettings(event.currentTarget);
    }

    const handleCloseSettings = () => {
        setAnchorSettings(null);
    };

    const handleFileUpload = async (event) => {
        // console.log('uploadPDF', event.target.files, socket.id);
        let file = Array.from(event.target.files)[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            // @ts-ignore
            const $data = new Uint8Array(e.target.result);
            // Чтение рабочей книги из бинарных данных:cite[1]:cite[6]
            const workbook = XLSX.read($data, { type: 'array' });
            
            // Получение имени первого листа:cite[1]
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // Преобразование листа в JSON:cite[1]
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            const $boxes = jsonData
                .map(row => row[0]) // Берем третий элемент каждой строки
                .filter(value => value !== undefined)
                .splice(1); // Игнорируем пустые ячейки

            console.log("$boxes", $boxes)

            const $barcodes = jsonData
                .map(row => row[1]) 
                .filter(value => value !== undefined).splice(1);

            console.log("$barcodes", $barcodes)
            
            const $counts = jsonData
                .map(row => row[2]) 
                .filter(value => value !== undefined).splice(1);
            
            console.log("$counts", $counts)

            let boxTitles = []
            let boxProducts = {}
            let tmp = JSON.parse(JSON.stringify(data))
            for (let index = 0; index < $boxes.length; index++) {
                //Проверка наличия бокса, на всякий случай
                if ($boxes[index]) {
                    //Назодим в нулевом коробе товар
                    let idx = tmp[0].findIndex((fel) => fel.size.barcode === String($barcodes[index]))

                    //Получаем нужное количество 
                    let count = parseFloat($counts[index])
                    if (idx > -1 && count >0) {
                        if (!boxTitles.includes($boxes[index])) {
                            //проверяем, что количество достаточное
                            if (parseFloat(tmp[0][idx].countProduct) >= count) {
                                //Добавляем короб в список
                                boxTitles.push($boxes[index])
                                //Записываем продукты
                                boxProducts[$boxes[index]] = [{...tmp[0][idx], countProduct: count}]
                                //Вычитаем из локальных данных, для правильной проверки
                                tmp[0][idx].countProduct = parseFloat(tmp[0][idx].countProduct) - count
                            }else {boxTitles = []; break;}
                        }
                        else {
                            if (parseFloat(tmp[0][idx].countProduct) >= count) {
                                let checkidx = boxProducts[$boxes[index]].findIndex((fel) => fel.size.barcode === String($barcodes[index]))
                                if (checkidx === -1) {
                                    boxProducts[$boxes[index]].push({...tmp[0][idx], countProduct: count})
                                    //Вычитаем из локальных данных, для правильной проверки
                                    tmp[0][idx].countProduct = parseFloat(tmp[0][idx].countProduct) - count
                                }
                                else {boxTitles = []; break;}
                            }
                            else {boxTitles = []; break;}
                        }
                    }
                }
            }
            console.log("RESULT", boxTitles, boxProducts)
            if (boxTitles.length > 0) {
                // @ts-ignore
                let resBoxes = await addBox(boxTitles.length, boxTitles)
                let $keys = Object.keys(boxProducts)
                let $products = {}
                for (let i=0; i < $keys.length; i++) {
                    $products[resBoxes[i].id] = boxProducts[boxTitles[i]]
                }
                await onAddProductMany($products, resBoxes)
                showNotification({
                    id: 'fileSucces', 
                    type: 'success', 
                    message: 'Привязка из файла синхронизирована' 
                })
            }
            else {
                showNotification({
                    id: 'fileError', 
                    type: 'error', 
                    message: 'Количество товара и файл привязки не совпадают' 
                });
            }

            
        };
        reader.readAsArrayBuffer(file); // Чтение файла как ArrayBuffer:cite[1]:cite[6]
        event.target.value = null;
    }

    /** @type {any} */
    let scrollRef = useRef(null)

    const [scroll, setScroll] = useState(0);

    const setScrollPosition = () => {
        if (scrollRef.current) {
            const values = scrollRef.current.getValues();
            setScroll(values.scrollTop)
            return values.scrollTop;
        }
        return 0;
    };

    useEffect(() => {
        console.log("scroll", scroll)
        if (scrollRef.current && scroll > 0) {
            scrollRef.current.scrollTop(scroll)
        }
    }, [data, boxes]); 

    const { socket } = useContext(SocketContext);

    const handleInputChangeAddr = async (id, val) => {
        let tmp = JSON.parse(JSON.stringify(boxes))
        let idx = tmp.findIndex((fel) => fel.id === id)
        tmp[idx].addr = val
        await post('Boxes/update', {id, addr: val})
        socket.emit("dnd_change_addr", {id, type:'adrr_storage', company_id})
        setBoxes(boxSort(tmp))
      };
    
    
    const delStartPallets = async () => {
        let tmp = JSON.parse(JSON.stringify(boxes))
        let ids = []
        tmp.filter((fel) => fel.type === "start_pallet").map((el) => {
            ids.push(el.id)
        })
        console.log("ids", ids)
        await post("Boxes/delete", {bid:ids})
        socket.emit("dnd_del_addr", {ids, type:'adrr_storage', company_id})
        tmp = tmp.filter((fel) => fel.type !== "start_pallet")
        setBoxes(boxSort(tmp))
    };

    const handleIdSort = () => {
        const nextOrder = idSortOrder === 'asc' ? 'desc' : 'asc';
        setIdSortOrder(nextOrder);
        
        // Сохраняем в localStorage
        localStorage.setItem('bindDeal_sortOrder', nextOrder);

        setBoxes(boxSort([...boxes]))
    };

    /** @type {[any, Function]} */
    const [state, setState] = useState({
        right: false,
        id: 0
    });


    const toggleDrawer = (anchor, open, idcard = null) => (event) => {
        console.log('TOGGLE DRAWER INFO', idcard, data, $data)
        if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        if (!open) {
            idcard = null;
        }

        setState(prev => ({
            ...prev,
            [anchor]: open,
            id: idcard
        }));
    };

    // @ts-ignore
    const changeTab = (event, newValue) => setTab(newValue);
    

    useEffect(() => {
        let tmp = [...boxes]
        tmp.map((el) => el.open = false)
        if (checked) {
            let tmpFinded = []
            tmp.map((el, index) => {
                if (data[el.id]) {
                    console.log(data[el.id])
                    let idx = data[el.id].findIndex((el) => {
                      const tf = filter.toLowerCase();
                      return (
                        filterFields.title.active &&
                          el.data.title &&
                          String(el.data.title).toLowerCase().includes(tf) ||
                        filterFields.brand.active &&
                          el.data.brand &&
                          String(el.data.brand).toLowerCase().includes(tf) ||
                        filterFields.vendorCode.active &&
                          el.data.vendorCode &&
                          String(el.data.vendorCode).toLowerCase().includes(tf) ||
                        filterFields.color.active &&
                          el.data.color &&
                          el.data.color.join(" ").toLowerCase().includes(tf) ||
                        filterFields.size.active &&
                          el.size.ttle &&
                          String(el.size.title).toLowerCase().includes(tf) ||
                        filterFields.barcode.active &&
                          el.size.barcode &&
                          el.size.barcode.toLowerCase().includes(tf)
                      )
                    })
                    if (idx > -1) {
                        tmp[index].open = true
                        if (!tmpFinded.includes(data[el.id][idx].id)) {tmpFinded.push(data[el.id][idx].id)}
                        if (tmp[index].parent_id) {
                            let pidx = boxes.findIndex((fel)=> fel.id === tmp[index].parent_id)
                            tmp[pidx].open = true
                        }
                        else {
                            setNoPalletOpen(true)
                        }
                    }
                }
            })
            setFinded(tmpFinded)
        }
        else {
            setFinded([])
        }
        setBoxes(boxSort(tmp))
    }, [checked]); 
    
    console.log("CHECKED", checked)

    const setFBSBoxesWB = async () => {

        ///создаем копию коробов
        let tmpBoxes = JSON.parse(JSON.stringify(boxes)).sort((a, b) => a.id - b.id)
        //Считаем, сколько коробов нужно добавить в поставку
        let count = boxes.filter((fel) => fel.type === 'box' && !fel.market_code_fbs).length
        //Кидаем запрос на вб, для создания коробов
        //FBS_COM
        let fbsboxes = await post("WBAPI/setSuppluBoxes", {uid:CliId, supply_id: FBSData.supply_id, count})
        if (fbsboxes.length === 0) {
            showNotification({
                id: 'errorsetSuppluBoxes', 
                type: 'warning', 
                message: 'Не удалось привязать короба к поставке WB' 
            });
            return 
        }
        //Создаем копию данных фбс
        let tmp = JSON.parse(JSON.stringify(FBSData))
        //обновляем данные в локальной копии данных фбс
        tmp.boxCount = tmp.boxCount? tmp.boxCount + count: count
        tmp.boxes = tmp.boxes? tmp.boxes.concat(fbsboxes): fbsboxes
        setFBSData(tmp)

        //Прописываем коробвм у которых не было кода fbs соответвенно код fbs
        let bToUp=[]
        let bi = 0
        let ci = 0
        while (bi < tmpBoxes.length && ci < fbsboxes.length) {
            if (tmpBoxes[bi].type === 'box' && !tmpBoxes[bi].market_code_fbs) {
                tmpBoxes[bi].market_code_fbs = fbsboxes[ci]
                ci+=1
                bToUp.push(tmpBoxes[bi])
            }
            bi+=1
        }

        //Обновляе мкороба локально 
        setBoxes(boxSort(tmpBoxes))

        //Обновляе короба в бд
        await Promise.all(bToUp.map(async (el) => {
            await post('Boxes/update', {id:el.id, market_code_fbs:el.market_code_fbs})
        }))
        //обновляем данные фбс в бд
        await post("Deal/update", {id:$data, data: {fbsdata: tmp}})
        showNotification({
            id: 'scsetSuppluBoxes', 
            type: 'success', 
            message: 'Короба привязаны к FBS поставке WB' 
        });
    }

    const setFBSQRS = async () => {

        showNotification({
            id: 'qrlistfbsstart', 
            type: 'info', 
            message: `Передаем список КИЗов на ${market}` 
        });
        let tmpFBSData = JSON.parse(JSON.stringify(FBSData))
        let count = 0
        for (let k of Object.keys(data)) {
            for (let el of data[k]) {
                count += el.countProduct
            }
        }

        let status = false
        switch (market) {
            case "wb": {
                let orders = []
                
                for (let item of Object.values(FBSData.qrList).flat()) {
                    orders.push({
                        orderId: item.order,
                        sgtins: [item.code]
                    })
                }
                let tmp = await post("WBAPI/setQRS", {uid:CliId, orders})
                if (tmp.message === "OK") {
                    status = true
                }
                break
            }
            case "ozon": {
                showNotification({
                    id: 'DEBU', 
                    type: 'warning', 
                    message: `МЕТОД В РАЗРАБОТКЕ` 
                });
                return 
                // if (tmpFBSData.qrList.length !== count) {
                //     showNotification({
                //         id: 'qrlistfbsWarn', 
                //         type: 'warning', 
                //         message: `Количество загруженный qr не соответвует количеству товаров` 
                //     });
                //     return 
                // }
                // let postings = []
                // FBSData.list.map(async (el) => {
                //     postings.push(el.posting_number)
                // })
                // let tmp = await post("OZONAPI/setQRS", {uid:CliId, postings, list: tmpFBSData.qrlist})
                // if (tmp.message === "OK") {
                //     status = true
                // }
                // break
            }
        }
        if (status) {
            
            tmpFBSData.sendedQR = true
            setFBSData(tmpFBSData)
            await post("Deal/update", {id:$data, data: {fbsdata: tmpFBSData}})
            showNotification({
                id: 'qrlistfbssuccces', 
                type: 'success', 
                message: `Список КИЗов передан` 
            });
        }
        else {
            showNotification({
                id: 'qrlistfbsfail', 
                type: 'error', 
                message: `Приозошла ошибка, сообщите администратору` 
            });
        }

    }

    const showFBSBoxesBarcodesWB = async () => {
        setOpenFBSBoxesBarcodeWB(true)
        // ShowModal(
        //     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        //         <span>Печать QR-кодов</span>
        //     </div>, 
        //     <div style={{ height: '700px', width: '1000px', padding: '12px' }}>
        //         <FBSWBBoxesQRsModal data={FBSData} user={CliId}></FBSWBBoxesQRsModal>
        //     </div>, 
        //     undefined
        // );
    }

    const showFBSBarcodesWB = async () => {
        ShowModal(
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span>Печать QR-кодов</span>
            </div>, 
            <div style={{ height: '700px', width: '1000px', padding: '12px' }}>
                <FBSWBSupplyQRsModal data={FBSData} user={CliId}></FBSWBSupplyQRsModal>
            </div>, 
            undefined
        );
    }

    const FBSToSupplyWB = async () => {

        const checkQRStatuses = async (orders) => {
            if (market !== "wb") return;
            const res = await post("WBAPI/getSupplyQRS", { uid: cli, orders });
            const result = {fail: 0, wait: 0, ok: 0};
            Object.keys(res).forEach((k) => {
                switch (res[k]) {
                    case "filled":
                    case "optional":
                    case "sgtinSoldB2B":
                    case "sgtinIntroduced":
                        result.ok +=1
                    break;
                    case "deadlineExceeded":
                    case "pending":
                        result.wait +=1
                        break;
                    default:
                        result.fail +=1
              }
            });
            return result
        }

        //Важно держать закомментированным
        //FBS_COM
        const send = async (isOk) => {
            if (isOk) {
                showNotification({
                    id: 'supplyToDeliverStart', 
                    type: 'info', 
                    message: 'Проверяем данные' 
                });       
                if (Object.keys(FBSData.qrList).length > 0) {
                    let checkRes = await checkQRStatuses(FBSData.list)
                    // @ts-ignore
                    if (checkRes.wait > 0 ) {
                        showNotification({
                            id: 'waitingCheckQRS', 
                            type: 'warning', 
                            message: `Не все КИЗЫ проверены` 
                        });
                        return
                    }
                    // @ts-ignore
                    if (checkRes.fail > 0 ) {
                        showNotification({
                            id: 'waitingCheckQRS', 
                            type: 'warning', 
                            message: `Некоторые КИЗЫ не прошли проверку` 
                        });
                        return
                    }
                }
                const resp = await post("WBAPI/supplyToDeliver", {uid:CliId, supply_id: FBSData.supply_id})
                if (resp.message === "FAIL") {
                    showNotification({
                        id: 'errorsupplyToDeliver', 
                        type: 'warning', 
                        message: `Не удалось перевести в статус "В доставке"` 
                    });
                    return
                }
                let tmp = JSON.parse(JSON.stringify(FBSData))
                tmp.closed = true
                setFBSData(tmp)
                await post("Deal/update", {id:$data, data: {fbsdata: tmp}})
                showNotification({
                    id: 'SCsupplyToDeliver', 
                    type: 'success', 
                    message: 'FBS поставка переведена в статус "В доставке"' 
                });
            }
        }
        
        handleConfirm('Вы уверены, что хотите перевести поставку в статус "В доставке"?', send);
    }

    const printPickUpListMulti = () => {
        let bchash = {}
        let global_items = []
        console.log("MW", MW)
        console.log("data", data)
        let warehouses = !filterWarehouse?avaibleWarehouses: avaibleWarehouses.filter((fel) => fel === filterWarehouse)
        warehouses.map((wh, index) => {
            let items = []
            let all_count = 0
            MW.filter((fel) => fel.warehouse === wh).map((el) => {
                console.log("el", el)
                let pr = undefined
                if (bchash[el.barcode]) {
                    pr = bchash[el.barcode]
                }
                else {
                    let result = null;
                    for (const boxId in data) {            // перебираем ключи (номера коробок)
                        const items = data[boxId];
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            if (item.size && item.size.barcode === el.barcode) {
                            result = item;
                            break;                           // выходим из внутреннего цикла
                            }
                        }
                        if (result) break;                   // выходим из внешнего цикла
                    }
                    pr = result
                    bchash[el.barcode] = result
                }
                items.push({
                    title: pr.data.title,
                    color: pr.data.color,
                    vendorCode: pr.data.vendorCode,
                    size: pr.size.title,
                    barcode: pr.size.barcode,
                    count: el.count,
                    warehouse: el.warehouse
                })
                all_count += el.count
            })
            console.log("WH", wh)
            global_items.push(
                {
                    pickup_date: dealPickupDate || "-",
                    warehouse: dealWarehouse || "-",
                    shipment_date: dealShipmentDate || "-",
                    items,
                    all_count,
                    cdn: dealNumber,
                    location: wh,
                    notFirst: index !== 0

                },
            )
        })
        let obj = {
            global_items
        }
        genDoc("template_list_priemki_multi", obj, `Лист приемки ${market} - ${dealNumber}`)
    }

    const downloadTransitList = (pid) => {
        let pallet = boxes.find((fel) => fel.id === pid)
        if (pallet) {
            let obj = {
                num: pallet.title.slice(pallet.title.indexOf('П')+1),
                all: palletCount,
                boxes: boxes.filter((box) => box.parent_id === pid).length,
                shipment: shipmentNumber,
                cli: `${cliRekv.type} ${cliRekv.name}`,
                transit_wh: dealWarehouseTransit,
                wh: dealWarehouse,
                date: dealShipmentDate

            }
            genDoc("template_tranzitny_list", obj, `Транзитный лист ${market} - ${dealNumber}`)
        }
    }
    const downloadTransitListMulti = () => {
        let pallets = boxes.filter((fel) => fel.type === 'pallet').sort((a,b) => a.id - b.id)
        let global_items = []
        let gind = 0
        pallets.map((pallet) => {
            let obj = {
                num: pallet.title.slice(pallet.title.indexOf('П')+1),
                all: palletCount,
                boxes: boxes.filter((box) => box.parent_id === pallet.id).length,
                shipment: shipmentNumber,
                cli: `${cliRekv.type} ${cliRekv.name}`,
                transit_wh: dealWarehouseTransit,
                wh: dealWarehouse,
                date: dealShipmentDate,
                notFirst: gind !== 0
            }
            gind += 1
            global_items.push(obj)
        })
        let freeBoxes = boxes.filter((fel) => fel.type === 'box' && !fel.parent_id).sort((a,b) => a.id - b.id)
        if (freeBoxes.length>0) {
            global_items.push({
                num: "Короба без паллета",
                all: "-",
                boxes: freeBoxes.length,
                shipment: shipmentNumber,
                cli: `${cliRekv.type} ${cliRekv.name}`,
                transit_wh: dealWarehouseTransit,
                wh: dealWarehouse,
                date: dealShipmentDate,
                notFirst: gind !== 0
            })
            gind += 1
        }

        let obj = {
            global_items
        }
        genDoc("template_tranzitny_list_multi", obj, `Транзитный лист ${market} - ${dealNumber}`)
    }

    useEffect(() => {
        setBoxesCount(boxes.filter(box => box.type === 'box').length)
        setPalletCount(boxes.filter(box => box.type === 'pallet').length)
        setNotAdaptedBoxesCount(boxes.filter((fel) => !fel.title.startsWith(`С${dealNumber}`)).length)
    }, [data, boxes]); 

    const adaptTitles = async () => {
        setLoading(true)
        let bup = []
        let tmp = [...boxes]
        let c = 0

        let BN = 0
        let PN = 0

        //Определяем стартовый номер паллеты
        let tmpboxex = JSON.parse(JSON.stringify(boxes)).filter((fel) => fel.title.startsWith(`С${dealNumber}`) && fel.type === 'pallet')
        if (tmpboxex.length > 0) {
            let idx = tmpboxex.sort((a, b) => (parseInt(b.title.slice(b.title.lastIndexOf('П')+1)) - parseInt(a.title.slice(a.title.lastIndexOf('П')+1))))[0]?.title.lastIndexOf("П") || -1
            if (idx > -1) {
                let s = tmpboxex[0].title.slice(idx+1)
                PN = parseInt(s)+1
            } else { PN = 1 }
        } else {
            PN = 1
        }

        //Определяем стартовый номер короба
        tmpboxex = JSON.parse(JSON.stringify(boxes)).filter((fel) => fel.title.startsWith(`С${dealNumber}`)  && fel.type === 'box')
        if (tmpboxex.length > 0) {
            let idx = tmpboxex.sort((a, b) => (parseInt(b.title.slice(b.title.lastIndexOf('К')+1)) - parseInt(a.title.slice(a.title.lastIndexOf('К')+1))))[0]?.title.lastIndexOf("К") || -1
            if (idx > -1) {
                let s = tmpboxex[0].title.slice(idx+1)
                BN = parseInt(s)+1
            } else { BN = 1 }
        } else {
            BN = 1
        }

        tmp.filter((fel) => !fel.title.startsWith(`С${dealNumber}`)).map((el) => {
            let oldTitle = el.title.split('_')
            let num = ""
            if (el.type === 'box') {
                num = `К${BN}`
                BN +=1
            }
            else {
                num = `П${PN}`
                PN += 1
            }
            let new_title = `С${dealNumber}_${oldTitle[1]}_${num}`
            bup.push({id: el.id, oldTitle: el.title, title:new_title})
            el.title = new_title
            c+=1
        })
        await post('Boxes/adaptTitles', {list: bup})
        await post("Logs/create", {
            deal_id:$data,
            user_type:"ful",
            user_id,
            type: "rename_boxes",
            data: {list: bup}
        })
        showNotification({
            id: 'succesRename', 
            type: 'success', 
            message: `Короба успешно переименованы (${c})` 
        });
        setBoxes(boxSort(tmp))
        setLoading(false)
    }

    const PalletAddPopover = ({ parel, onAddBox, onAddProduct, blocked}) => {
        const [open, setOpen] = useState(false);
        const [anchorTPBP, setAnchorTPBP] = useState(null);
        const [addTPTypeBP, setAddTPTypeBP] = useState(false);
        const [addBoxCountLocal, setAddBoxCountLocal] = useState(1);

        const handleOpen = (event) => {
            event.stopPropagation();
            setAnchorTPBP(event.currentTarget);
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
            setAnchorTPBP(null);
            // сброс внутренних значений при закрытии (опционально)
            setAddTPTypeBP(false);
            setAddBoxCount(1);
        };

        const handleAdd = (event) => {
            event.stopPropagation();
            if (parel.box_count > 0) {
                onAddBox(parel.id, addBoxCountLocal);
            } else {
                if (!addTPTypeBP) onAddBox(parel.id,addBoxCountLocal);
                else onAddProduct(parel.id);
            }
            handleClose();
        };

        return (
            <>
            <Tooltip title={parel.box_count > 0 ? `Добавить короб${blocked? " (заблокировано в хранении)": ""}` : `Добавить короб/товар${blocked? " (заблокировано в хранении)": ""}`}>
                <IconButton onClick={handleOpen} sx={{ position: 'relative' }} disabled={blocked}>
                <AddIcon sx={{ transition: 'all 0.3s ease', '&:hover': hoverStyle, color: parel.open ? 'white' : "black" }} />
                </IconButton>
            </Tooltip>

            <Popover
                open={open}
                anchorEl={anchorTPBP}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{ sx: { mt: 1, p: 1 } }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 160, alignItems: 'center' }}>
                {parel.box_count === 0 && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <FormControlLabel
                            label={undefined}
                            sx={{ padding: 0, margin: 0 }}
                            onClick={(e) => {e.stopPropagation();}}
                            control={
                            <BoxProductSwitch
                                defaultChecked={addTPTypeBP}
                                onChange={(e) => setAddTPTypeBP(e.target.checked)}
                            />
                            }
                        />
                    </div>
                )}
                <MuiInput
                    sx={{
                    ':after': { borderBottomColor: '#005b52' },
                    width: '120px',
                    fontSize: '12px',
                    textAlign: 'center',
                    '& input': { textAlign: 'center' }
                    }}
                    value={addBoxCountLocal}
                    size="medium"
                    disabled={addTPTypeBP && parel.box_count === 0}
                    onClick={(e) => {e.stopPropagation();}}
                    onChange={(event) => {
                        const val = event.target.value;
                        if (val === '') setAddBoxCountLocal(1);
                        else {
                            const num = parseInt(val, 10);
                            if (!isNaN(num)) setAddBoxCountLocal(num);
                        }
                    }}
                    inputProps={{ 'aria-labelledby': 'input-count' }}
                />
                <Button variant='text' onClick={(e) => {preventDoubleClick(handleAdd(e))}} sx={{ fontSize: '12px', borderRadius: '10px', height: '20px' }}>
                    Добавить
                </Button>
                </Box>
            </Popover>
            </>
        );
        };

    const productItem = (el, datael) => {
        return (
            <div key={`pritem${datael.id}`} style={{width: '48%', margin: "5px 1% 0px 1%", display: 'flex', flexDirection: 'column', backgroundColor: (finded || []).includes(datael.id)? 'rgba(189, 219, 221, 0.4)': "white"}}>
                <ProductMoreInfo value={datael.data}/>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <NumInputDesign 
                        title={"Количество"} 
                        val={changed.find((fel) => fel.id === datael.id)?.count || datael.countProduct}
                        onChange={
                            (v) => {
                                const val = v
                                if (!val || val === '') editCount({row: {id: datael.id}, count: 0}, el.id)
                                else {
                                    // const num = parseInt(val, 10);
                                    let num = parseFloat(val)
                                    if (!isNaN(num)) editCount({row: {id: datael.id}, count: num}, el.id)
                                }
                            }
                        }
                        float={market === 'consum'}
                        editable={!blocked}
                    />
                    <IconButton 
                        aria-label="menu" 
                        // @ts-ignore
                        onClick={() => { save([{ box: el.id, id: datael.id, count: 0 }]) }}

                        sx={{marginRight: '20px'}}
                        disabled={blocked}
                    >
                        <DeleteForeverIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                </div>
            </div>
        )
    }

    const getAddProducts = () => {
        console.log("AAAAA", selBox)
        let res = JSON.parse(JSON.stringify(data["0"] || []))
        let idx = boxes.findIndex((fel) =>fel.id === selBox)
        if (idx > -1) {
            if (boxes[idx].subWarehouse) {
                let tmp = MW.filter((fel) => fel.warehouse === boxes[idx].subWarehouse)
                console.log("tmp", tmp)
                // res = res.filter((fel) => tmp.findIndex((subfel) => subfel.barcode === fel.size.barcode) > -1)
                res = res.reduce((acc, fel) => {
                    const matched = tmp.find((subfel) => subfel.barcode === fel.size.barcode);
                    if (matched) {
                        // изменяем поле прямо перед добавлением
                        let ncp = matched.count - parseInt(matched.showCount.split('/')[0])
                        const modified = { ...fel, countProduct: ncp};
                        acc.push(modified);
                    }
                    return acc;
                }, []);
            }
        }
        return res
    }

    const saveQrList = async (box, list) => {
        setLoading(true)
        let err = false
        if (box === 0) {
            console.log("list", list)
            let tmp = JSON.parse(JSON.stringify(FBSData))
            tmp.qrList = list
            setFBSData(tmp) 
            let res = await post("Deal/update", {id:$data, data: {fbsdata: tmp}})
            if (res.success) {
                showNotification({
                    id: 'succesSaveQR', 
                    type: 'success', 
                    message: `Данные сохранены` 
                });
                localStorage.removeItem(`SCANDATAFBS${$data}`)
            }
            else {
                showNotification({
                    id: 'errorSaveQR', 
                    type: 'error', 
                    message: `Произошла ошибка, не удалось сохранить данные` 
                });
                err = true
            }

        }
        else {
            await post("Boxes/update", {id: box, qrList: list})
            let tmp = [...boxes]
            let idx = tmp.findIndex((fel) => fel.id === box)
            tmp[idx].qrList = list
            setBoxes(boxSort(tmp))
        }

        if (!err) {
            setOpenKIZ(undefined)
            setQRListChange(false)
        }
        setLoading(false)
    }

    const closeQRList = () => {
        if (!QRListChange) {
            setOpenKIZ(undefined)
        }
        else {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные изменения. Вы уверены, что хотите закрыть окно?</div>,
                async () => {
                    setQRListChange(false)
                    setOpenKIZ(undefined)
                    localStorage.removeItem(`SCANDATAFBS${$data}`)
                }
            );
            return;
        }
    }

    const openPalletOnScan = (adr) => {
        console.log("adr", adr)
        setScrollPosition()
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.addr === adr)
        if (idx > -1) {
            tmp[idx].open = true
            setBoxes(boxSort(tmp))
        }
        else {
            addBox(undefined, undefined, "pallet", undefined, adr)
        }
    }

    const openBoxOnScan = (adr, bt) => {
        console.log("adr, box", adr, bt)
        let numbers = bt.match(/[0-9]+/g).map(Number)
        if (parseInt(numbers[0]) === dealNumber && parseInt(numbers[1]) === CliId) {
            setScrollPosition()
            let tmp = [...boxes]
            let adr_idx = tmp.findIndex((el) => el.addr === adr)
            let title_idx = tmp.findIndex((el) => el.title === bt)
            if (title_idx > -1) {
                if (tmp[title_idx].parent_id === tmp[adr_idx].id) {
                    tmp[adr_idx].open = true
                    tmp[title_idx].open = true
                    setBoxes(boxSort(tmp))
                    return undefined
                }
                else {
                    return "Короб находится в другой ячейке"
                }
            }
            else {
                console.log("Создаем")
                // addBox(undefined, undefined, "box", tmp[adr_idx].id)
                return undefined
            }
        }
        return 'Короб относится к другой сделке'
    }

    
    const addToBoxOnScan = (adr, bt, bc) => {
        console.log("adr, box, bc", adr, bt, bc)
        let tmp = [...boxes]
        if (adr) {
            let adr_idx = tmp.findIndex((el) => el.addr === adr)
            //Выбраны ячейка и короб
            if (bt) {
                let title_idx = tmp.findIndex((el) => el.title === bt)
                let tmpdata = JSON.parse(JSON.stringify(data["0"] || [])).filter((fel) => fel.size.barcode === bc)
                if (tmpdata.length > 0) {
                    let obj = JSON.parse(JSON.stringify(tmpdata[0]))
                    obj.countProduct = 1
                    onAddProduct([obj], tmp[title_idx])
                    return undefined
                }                   
                else {
                    return "Товара недостаточно"
                } 
            }
            //Выбран только короб
            else {
                if (tmp.filter((fel) => fel.parent_id === tmp[adr_idx].id).length > 0) {
                    return "Нельзя добавлять товар и короба одновременно"
                }
                else {
                    let tmpdata = JSON.parse(JSON.stringify(data["0"] || [])).filter((fel) => fel.size.barcode === bc)
                    if (tmpdata.length > 0) {
                        let obj = JSON.parse(JSON.stringify(tmpdata[0]))
                        obj.countProduct = 1
                        onAddProduct([obj], tmp[adr_idx])
                        return undefined
                    }                   
                    else {
                        return "Товара недостаточно"
                    } 
                }
            }
        }

    }

    console.log('BOXES 00000000', boxes)
    console.log('data 00000000', data)
    console.log('MW 00000000', MW)
    console.log('finded 00000000', finded)
    console.log('FBSData', FBSData)
    console.log('ADDR', addrs)
    

    return (
        <div style={{display: "flex", flexDirection: "column", height: "calc(94% - 50px )", margin: '0% 1% 1% 1%', width: '98%'}}>
            <Dialog
                open={dOpen}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setDOpen(false) }}
            >
                <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                    <AddProductToBox data={getAddProducts()} cancel={setDOpen} onSave={onAddProduct} float={market === 'consum'}></AddProductToBox>
                </div>

            </Dialog>
            <Dialog
                open={BoxNBarCodeOpen}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setBoxNBarCodeOpen(false) }}
            >
                <div style={{ height: '520px', width: '550px', padding: '12px', }}>
                    <BoxNBarCode DEAL={deal?.data?.cdn} CLI={cli.id} deal_id={$data} user_id={user_id}></BoxNBarCode>
                </div>

            </Dialog>
            <Dialog
                open={openFBSBoxesBarcodeWB}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenFBSBoxesBarcodeWB(false) }}
            >
                <div style={{ height: '520px', width: '600px', padding: '12px', }}>
                    <FBSWBBoxesQRsModal data={FBSData} user={CliId} onClose={() => {setOpenFBSBoxesBarcodeWB(false)}}></FBSWBBoxesQRsModal>
                </div>

            </Dialog>
            <Dialog
                open={openKIZ !== undefined}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { closeQRList() }}
            >
                <div style={{ height: '620px', width: '1100px', padding: '12px', }}>
                    {openKIZ !== 0? 
                        <Scanner inputCodes={!openKIZ? []:boxes.find((fel) => fel.id === openKIZ).qrList || []} onCancel={() => {setOpenKIZ(undefined)}} onSave={(list) => {saveQrList(openKIZ, list)}} onChange={(v) => {setQRListChange(v)}}/>
                    :
                        <ScannerSplit 
                            inputCodes={FBSData.qrList || []} bclist={BCS} 
                            onCancel={() => {setOpenKIZ(undefined)}} 
                            onSave={(list) => {saveQrList(openKIZ, list)}} 
                            onChange={(v) => {setQRListChange(v)}}
                            order_barcodes={FBSData.order_barcodes}
                            cli={CliId}
                            market={market}
                            autoSaveKey={`SCANDATAFBS${$data}`}
                        />
                    }
                </div>

            </Dialog>
            <DraggableModal
                open={openBindScanner}
                onClose={() => setOpenBindScanner(false)}
                title="Сканнер"
            >
                <ScannerBind 
                    openPallet={openPalletOnScan} 
                    openBox={openBoxOnScan} 
                    addToBox={addToBoxOnScan}
                    addrs={
                        // @ts-ignore
                        addrs.flatMap(obj => obj.items.map((i) => i.name) ?? [])
                    }/>
            </DraggableModal>

            <div style={{ display: 'flex', flexDirection: "row", height: "100%", justifyContent: 'space-between', width: '100%'}}>

                <Card sx={{ borderRadius: 3, boxShadow: 0, width: "64%", height: "100%" }}>
                    <div style={{ marginTop: "15px", marginLeft: "15px", marginRight: "31px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography variant='h3' align='left'>Распределение товара:</Typography>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: "15px"}}>
                            <IconButton 
                                onClick={() => setOpenBindScanner(true)}
                                sx={{ 
                                    position: 'relative',
                                    backgroundColor: "#078476",
                                    borderRadius: '50%',
                                    }}
                                disabled={blocked}
                                disableRipple
                            >
                                <CropFreeIcon
                                    sx={{
                                        color: 'white',
                                        transition: 'all 0.3s ease',
                                        position: 'relative',
                                        '&:hover': hoverStyleTransformOnly,
                                    }}
                                />
                            </IconButton>
                            <Tooltip title={`Добавить короба/паллеты${blocked? " (заблокировано в хранении)": ""}`}>
                                <IconButton 
                                    onClick={handleOpenBP}
                                    sx={{ 
                                        position: 'relative',
                                        backgroundColor: "#078476",
                                        borderRadius: '50%',
                                     }}
                                    disabled={blocked}
                                    disableRipple
                                >
                                    <AddIcon
                                        sx={{
                                            color: 'white',
                                            transition: 'all 0.3s ease',
                                            position: 'relative',
                                            '&:hover': hoverStyleTransformOnly,
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                            <Popover
                                open={openBP}
                                anchorEl={anchorBP}
                                onClose={handleCloseBP}
                                anchorOrigin={{
                                    vertical: 'bottom',   // появляется снизу от кнопки
                                    horizontal: 'left',   // выравнивание по левому краю (можно 'center')
                                }}
                                transformOrigin={{
                                    vertical: 'top',      // верхний край окна привязан к anchorOrigin
                                    horizontal: 'left',
                                }}
                                PaperProps={{
                                    sx: { mt: 1, p: 1 }, // небольшой отступ сверху и внутренние поля
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 160, alignItems: 'center'}}>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        <FormControlLabel label={undefined} sx={{ padding: 0, margin: 0, display: 'flex', flexDirection: 'row', justifyContent: 'center'}}
                                            control={<BoxPalletSwitch defaultChecked={addTypeBP} onChange={(e) => setAddTypeBP(e.target.checked)} />}
                                        />
                                    </div>
                                    <MuiInput
                                        sx={{ ':after': { borderBottomColor: '#005b52' }, width: '120px', fontSize: '12px', textAlign: 'center', '& input': { textAlign: 'center' }}}
                                        value={addPalletCount}
                                        size="medium"
                                        onChange={(event) => {
                                            if (event.target.value === '') {
                                                setAddPalletCount(1);
                                            }
                                            else {
                                                let tmp = parseInt(event.target.value, 10)
                                                if (!isNaN(tmp)) {
                                                    setAddPalletCount(tmp);
                                                }
                                            }
                                        }}
                                        inputProps={{
                                            'aria-labelledby': 'input-count',
                                        }}
                                    />
                                    <Button variant='text' 
                                        onClick={() => {
                                            // @ts-ignore
                                            if (!addTypeBP) {preventDoubleClick(addBox(addPalletCount, undefined, "box"))}
                                            else {preventDoubleClick(addBox(undefined, undefined, "pallet"))}
                                        }}
                                        sx={{fontSize: '12px', borderRadius: '10px', height: '20px'}}
                                    >
                                        Добавить
                                    </Button>
                                </Box>
                            </Popover>
                        </div>
                    </div>

                    <div style={{ marginTop: "5px", marginLeft: "25px", marginRight: "15px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant='body1' align='left'>
                                {allSkuBinded} SKU {allCountBinded} шт. {boxesCount} коробов
                            </Typography>
                            
                            <Tooltip title="Сортировать паллеты по ID">
                                <IconButton size="small" onClick={handleIdSort} sx={{ ml: 1 }} disableRipple>
                                    {idSortOrder === 'asc' && <NorthIcon fontSize="small" color="primary" sx={{'&:hover': hoverStyle}}/>}
                                    {idSortOrder === 'desc' && <SouthIcon fontSize="small" color="primary" sx={{'&:hover': hoverStyle}}/>}
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "16px" }}>
                            {dealWarehouseTransit && <Typography
                                variant="subtitle2"
                                align="left"
                                sx={{ mr: "5px" }} // небольшой отступ справа
                            >
                                {dealWarehouseTransit}
                            </Typography>}
                            {dealWarehouseTransit && dealWarehouse && <ArrowRightAltIcon style={{height: '24px', width: '24px', marginRight: "5px"}}/>}                                
                            {dealWarehouse && <Typography
                                variant="subtitle2"
                                align="left"
                                sx={{ mr: "5px" }} // небольшой отступ справа
                            >
                                {dealWarehouse}
                            </Typography>}
                            <Typography
                                variant="subtitle2"
                                align="left"
                                sx={{ mr: "5px" }} // небольшой отступ справа
                            >
                                {shipmentNumber && shipmentNumber !== ""
                                    ? `№ ${shipmentNumber}`
                                    : "№ поставки отсутствует"}
                            </Typography>
                            <Typography variant='subtitle2' align='left'>{(shipmentCode && shipmentCode != "") ? shipmentCode : "Код отсутствует"}</Typography>
                            <input
                                type="file"
                                accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                style={{ display: "none" }}
                                id="upload-excel"
                                onChange={handleFileUpload}
                            />
                            <Tooltip title="Настройки">
                                <IconButton aria-label="itemMenu" onClick={openMenuSettigs} disableRipple>
                                    <MoreVertIcon
                                        sx={{
                                            transition: 'all 0.3s ease',
                                            '&:hover': hoverStyle
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id="basic-menu"
                                // @ts-ignore
                                anchorEl={anchorSettings}
                                open={openSettings}
                                onClose={handleCloseSettings}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={ShowAllBarcode} disabled={boxesCount === 0}>Распечатать ШК коробов</MenuItem>
                                <MenuItem onClick={ShowBoxNBarCode}>Предварительно распечатать ШК коробов</MenuItem>
                                <MenuItem onClick={ShowAllMarketBarcode} disabled={boxesCount === 0}>Распечатать все ШК маркетплейса</MenuItem>
                                <MenuItem onClick={ShowShipmentBarcode} disabled={!shipmentCode}>Распечатать ШК поставки</MenuItem>
                                <label htmlFor="upload-excel"style={{margin: 0,padding: 0,}}>
                                    <MenuItem disabled={blocked || boxesCount !== 0}>Загрузить привязку из файла{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                </label>
                                <MenuItem onClick={cleanBoxes} disabled={blocked || boxesCount === 0}>Очистить все короба{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                <MenuItem onClick={delBoxes} disabled={blocked || boxesCount === 0}>Удалить короба{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                {market === "wb" && FBSData && <MenuItem onClick={delBoxesFBS} >Отвязать короба от FBS поставки</MenuItem>}
                                <MenuItem onClick={delPallets}  disabled={blocked || palletCount === 0}>Удалить паллеты{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                <MenuItem onClick={exportList}  disabled={boxesCount === 0}>Скачать таблицу привязки</MenuItem>
                                <MenuItem onClick={downloadTransitListMulti}>Скачать транзитные листы</MenuItem>
                                <MenuItem onClick={adaptTitles} disabled={notAdaptedBoxesCount === 0}>Адаптировать старые названия коробов</MenuItem>
                                {market === "wb" && FBSData && <MenuItem onClick={(event) => { event.stopPropagation(); setOpenKIZ(0); handleCloseSettings()}}>КИЗы</MenuItem>}
                                {market === "wb" && FBSData && <MenuItem  onClick={setFBSQRS}>Отправить список КИЗов на маркетплейс</MenuItem>}
                                {market === "wb" && FBSData && <MenuItem onClick={setFBSBoxesWB}>Привязать короба к поставке WB (FBS)</MenuItem>}
                                {market === "wb" && FBSData && <MenuItem disabled={!FBSData.boxCount || FBSData.boxCount === 0} onClick={showFBSBoxesBarcodesWB}>Распечатать шк коробов (FBS)</MenuItem>}
                                {market === "wb" && FBSData && <MenuItem disabled={!FBSData.boxCount || FBSData.boxCount === 0} onClick={FBSToSupplyWB}>Перевести поставку в статус "в доставке" (FBS)</MenuItem>}
                                {market === "wb" && FBSData && <MenuItem disabled={!FBSData.closed} onClick={showFBSBarcodesWB}>Распечатать шк поставки (FBS)</MenuItem>}
                                
                                {/* <MenuItem onClick={ShowShipmentBarcode}>Распечатать ШК поставки</MenuItem> */}
                            </Menu>
                        </div>
                    </div>
                    {loading? <Loading/>:
                    <Scrollbars
                        ref={scrollRef}
                        style={{ height: "85%" }}
                    >
                        <CardContent>
                            {boxes.filter((fel) => fel.type === "pallet").map((parel, 
// @ts-ignore
                            index) => (
                                <>
                                    <ListItemButton onClick={() => handleClick(parel.id)}
                                        disableRipple  
                                        sx={{
                                            borderRadius: '30px',
                                            backgroundColor: parel.open ? '#078476' : "ffffff",
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                            borderColor: parel.open ? '#065f52' : '#aaa8a8',
                                            marginBottom: parel.open? '0px': '10px',    
                                            '&:hover': {
                                                backgroundColor: parel.open ? '#065f52' : '#f1f1f1',
                                            },
                                        }}
                                    >

                                        <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                {/* <ListItemText primary={el.id} /> */}
                                                <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold', color: parel.open ? 'white' : "black"}}>{parel.title}</Typography>
                                                {parel.open ? <ExpandLess style={{color: 'white'}}/> : <ExpandMore style={{color: "black"}}/>}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                {parel.sku === 0 && <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black"}}>Коробов: {parel.box_count} </Typography>}
                                                {parel.box_count == 0?
                                                    <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black"}}>
                                                        SKU: {parel.sku}, Товаров: {parel.count}
                                                    </Typography>
                                                    :
                                                    <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black"}}>
                                                        SKU: {inPalletCount[parel.id]?.sku?.length || 0}, Товаров: {inPalletCount[parel.id]?.count || 0}
                                                    </Typography>
                                                }
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                {parel.sku === 0 && 
                                                    <PalletAddPopover
                                                        parel={parel}
                                                        onAddBox={(palletId, count) => {preventDoubleClick(addBox(count, undefined, "box", palletId))}}
                                                        onAddProduct={(palletId) => {preventDoubleClick(openAddProduct(palletId))}}
                                                        blocked={blocked}
                                                    />
                                                }
                                                {parel.box_count === 0 && parel.sku !==0 && 
                                                    <>
                                                        <Tooltip title={`Добавить товар на паллет${blocked? " (заблокировано в хранении)": ""}`}>
                                                            <IconButton 
                                                                aria-label="menu" 
                                                                onClick={(event) => { event.stopPropagation(); openAddProduct(parel.id) }}
                                                                sx={{ position: 'relative' }}
                                                                disabled={blocked}
                                                                disableRipple
                                                            >
                                                                <AddIcon
                                                                    sx={{
                                                                        transition: 'all 0.3s ease',
                                                                        '&:hover': hoverStyle,
                                                                        position: 'relative',
                                                                        color: parel.open ? 'white' : "black"
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                }
                                                <div
                                                    style={{display: 'flex', flexDirection: 'column'}}
                                                    onClick={(event) => {event.stopPropagation()}}
                                                >
                                                    <DropdownMenu 
                                                        data={addrs} 
                                                        onChange={(e) => {handleInputChangeAddr(parel.id, e)}}  
                                                        startVal={parel.addr}
                                                        defText={"Адрес хранения"}
                                                    />
                                                </div>
                                                <Tooltip title="Другие функции">
                                                    <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); handleClickMenuOpen(event, parel.id) }} disableRipple>
                                                        <MoreVertIcon
                                                            sx={{
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': hoverStyle,
                                                                color: parel.open ? 'white' : "black"
                                                            }}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                                <Menu
                                                    anchorEl={parel.openMenu}
                                                    open={Boolean(parel.openMenu)}
                                                    onClose={() => handleClickMenuClose(parel.id)}
                                                    MenuListProps={{
                                                        'aria-labelledby': 'basic-button',
                                                    }}
                                                >
                                                    <MenuItem onClick={(event) => { event.stopPropagation(); delPallet(parel.id) }} disabled={blocked}>Удалить паллет{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                                    <MenuItem onClick={(event) => { event.stopPropagation(); ShowAllBarcodePallet(parel.id) }}>Распечатать ШК коробов</MenuItem>
                                                    <MenuItem onClick={(event) => { event.stopPropagation(); downloadTransitList(parel.id) }}>Скачать транзитный лист</MenuItem>
                                                    {!FBSData && parel.box_count === 0 && parel.sku !==0 && <MenuItem onClick={(event) => { event.stopPropagation(); setOpenKIZ(parel.id); handleClickMenuClose(parel.id)}}>КИЗы</MenuItem>}
                                                </Menu>
                                            </div>
                                        </div>
                                    </ListItemButton>
                                    <Collapse in={parel.open} timeout="auto" unmountOnExit sx={{margin: "0px 15px 10px 15px"}}>
                                        {parel.sku > 0?
                                            <>
                                                {loading? <Loading/> :
                                                    <>
                                                        {data[parel.id]? 
                                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                {data[parel.id].map((datael) => {return productItem(parel, datael)})}
                                                            </div>    
                                                        :
                                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Паллет пустой</div>
                                                        }
                                                    </>
                                                }
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                                    {!blocked && changed && changed.findIndex((fel) => fel.box === parel.id)>-1?  <Button
                                                        onClick={preventDoubleClick(save, 1000)}
                                                        variant="contained"
                                                        sx={{
                                                            textTransform: 'none',
                                                            backgroundColor: colors.elements,
                                                            fontWeight: 'bold',
                                                            margin: '10px'
                                                        }}
                                                    >
                                                        Применить
                                                    </Button> :null}
                                                </div>
                                            </>
                                            :
                                            <>
                                                {boxes.filter((fel) => fel.type === "box" && fel.parent_id === parel.id).map((el, index) => (
                                                    <>
                                                        <ListItemButton onClick={() => handleClick(el.id)}
                                                            sx={{
                                                                borderBottom: '2px solid #b9b9b9ff', 
                                                                backgroundColor: "ffffff",
                                                                borderRadius: '10px',
                                                                borderBottomRightRadius: '0px',
                                                                borderBottomLeftRadius: '0px'
                                                            }}
                                                        >

                                                            <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                                    {/* <ListItemText primary={el.id} /> */}
                                                                    <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold' }}>{el.title}</Typography>
                                                                    {el.open ? <ExpandLess /> : <ExpandMore />}


                                                                </div>
                                                                <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                                    {avaibleWarehouses.length > 0 &&
                                                                        <Select
                                                                            displayEmpty
                                                                            value={el.subWarehouse}
                                                                            disabled={blocked}
                                                                            onChange={(event) => { event.stopPropagation(); changeBoxWarehouse(el.id, event.target.value) }}
                                                                            sx={{ width: "200px", height: "25px", marginRight: "10px" }}
                                                                        >
                                                                            {avaibleWarehouses.map(sel => { return <MenuItem key={sel} value={sel} style={{ borderRadius: '10px', marginBottom: '5px' }} onClick={(event) => { event.stopPropagation() }}>{sel}</MenuItem> })}
                                                                        </Select>
                                                                    }
                                                                    <Typography variant='subtitle2' align='right' style={{ marginRight: '10px' }}>{el.sku} SKU, {el.count} шт.</Typography>
                                                                    {el.market_code ?
                                                                        <Typography variant='subtitle2' align='right' style={{ width: '150px' }}>{el.market_code}</Typography>
                                                                        :
                                                                        <div style={{ width: '150px' }}></div>
                                                                    }
                                                                    {/* <Button onClick={(event) => {event.stopPropagation(); openAddProduct(el.id)}}
                                                                sx={{ minWidth: 'auto', padding: '8px' }}><AddIcon sx={{fontSize: '1.5rem', fontWeight: 'bold'}} /></Button> */}
                                                                    <Tooltip title={`Добавить товар в короб${blocked? " (заблокировано в хранении)": ""}`}>
                                                                        <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); openAddProduct(el.id) }} disabled={blocked} disableRipple>
                                                                            <AddIcon
                                                                                sx={{
                                                                                    transition: 'all 0.3s ease',
                                                                                    '&:hover': hoverStyle
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    {/* <Tooltip title="Копировать короб">
                                                                        <IconButton aria-label="copy" onClick={(event) => { event.stopPropagation(); copyBox(el.id, parel.id) }}>
                                                                            <ContentCopyIcon
                                                                                sx={{
                                                                                    transition: 'all 0.3s ease',
                                                                                    '&:hover': hoverStyle
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip> */}
                                                                    <CopyBoxWithCounter 
                                                                        el={el.id} 
                                                                        parel={parel.id} 
                                                                        copyBox={copyBox} 
                                                                        hoverStyle={hoverStyle}
                                                                        blocked={blocked}
                                                                    />
                                                                    <Tooltip title="Другие функции">
                                                                        <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); handleClickMenuOpen(event, el.id) }} disableRipple>
                                                                            <MoreVertIcon
                                                                                sx={{
                                                                                    transition: 'all 0.3s ease',
                                                                                    '&:hover': hoverStyle
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Menu
                                                                        anchorEl={el.openMenu}
                                                                        open={Boolean(el.openMenu)}
                                                                        onClose={() => handleClickMenuClose(el.id)}
                                                                        MenuListProps={{
                                                                            'aria-labelledby': 'basic-button',
                                                                        }}
                                                                    >
                                                                        <>
                                                                        {
                                                                            Boolean(el.openSelectPallet)?
                                                                            <>
                                                                            {
                                                                                boxes.filter((fel) => fel.type === "pallet" && fel.id !== el.parent_id && fel.sku === 0).map((mpel) => {
                                                                                return (
                                                                                        <MenuItem onClick={(event) => { event.stopPropagation(); setPallet(el.id, mpel.id) }}>{mpel.title}</MenuItem>
                                                                                ) 
                                                                                })
                                                                            }
                                                                            </>
                                                                            :
                                                                            <>
                                                                            <MenuItem onClick={(event) => { event.stopPropagation(); delBox(el.id, el.parent_id) }} disabled={blocked}>Удалить короб{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                                                            <MenuItem onClick={(event) => { event.stopPropagation(); ShowBarcode(el.title, el.id) }}>Распечатать ШК короба</MenuItem>
                                                                            <MenuItem onClick={(event) => { event.stopPropagation(); handleClickOpenSelectPallet(event, el.id) }} disabled={blocked}>Изменить паллет{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                                                            <MenuItem disabled={!el.market_code} onClick={(event) => { event.stopPropagation(); ShowMarketBarcode(el.market_code, el.title, el.marcket_bc_path) }}>Распечатать ШК маркетплейса</MenuItem>
                                                                            {!FBSData && <MenuItem onClick={(event) => { event.stopPropagation(); setOpenKIZ(el.id); handleClickMenuClose(el.id)}}>КИЗы</MenuItem>}
                                                                            </>
                                                                        }
                                                                        </>
                                                                    </Menu>
                                                                </div>
                                                            </div>
                                                        </ListItemButton>
                                                        <Collapse in={el.open} timeout="auto" unmountOnExit>
                                                            {loading? <Loading/> :
                                                                <>
                                                                {data[el.id]? 
                                                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                        {data[el.id].map((datael) => {return productItem(el, datael)})}
                                                                    </div>    
                                                                :
                                                                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Короб пустой</div>
                                                                }
                                                                </>
                                                            }
                                                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                                                {!blocked && changed && changed.findIndex((fel) => fel.box === el.id)>-1?  <Button
                                                                    onClick={preventDoubleClick(save, 1000)}
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: 'none',
                                                                        backgroundColor: colors.elements,
                                                                        fontWeight: 'bold',
                                                                        margin: '10px'
                                                                    }}
                                                                >
                                                                    Применить
                                                                </Button> :null}
                                                            </div>
                                                        </Collapse>
                                                    </>
                                                ))}
                                            </>
                                        }
                                    </Collapse>
                                </>
                            ))}
                            {/* КООРБА БЕЗ ПАЛЛЕТА */}
                            {boxes.filter((fel) => fel.type === "box" && !fel.parent_id).length > 0 &&
                                <>
                                    <ListItemButton onClick={() => setNoPalletOpen(!noPalletOpen)}
                                        sx={{
                                            borderRadius: '30px',
                                            backgroundColor: noPalletOpen ? '#078476' : "ffffff",
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                            borderColor: noPalletOpen ? '#065f52' : '#aaa8a8',
                                            marginBottom: '10px',
                                            '&:hover': {
                                                backgroundColor: noPalletOpen ? '#065f52' : '#f1f1f1',
                                            },
                                        }}
                                    >

                                        <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                {/* <ListItemText primary={el.id} /> */}
                                                <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold', color: noPalletOpen ? 'white' : "black"}}>Короба без паллета</Typography>
                                                {noPalletOpen ? <ExpandLess sx={{color: 'white'}}/> : <ExpandMore sx={{color: 'black'}}/>}
                                            </div>
                                        </div>
                                    </ListItemButton>
                                    <Collapse in={noPalletOpen} timeout="auto" unmountOnExit sx={{marginLeft: "10px"}}>
                                        {boxes.filter((fel) => fel.type === "box" && !fel.parent_id).map((el) => (
                                            <>
                                                <ListItemButton onClick={() => handleClick(el.id)}
                                                    sx={{
                                                        borderBottom: '2px solid #b9b9b9ff', 
                                                        backgroundColor: "ffffff",
                                                        borderRadius: '10px',
                                                        borderBottomRightRadius: '0px',
                                                        borderBottomLeftRadius: '0px'
                                                    }}
                                                >

                                                    <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                        <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                            {/* <ListItemText primary={el.id} /> */}
                                                            <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold' }}>{el.title}</Typography>
                                                            {el.open ? <ExpandLess /> : <ExpandMore />}


                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                            {avaibleWarehouses.length > 0 &&
                                                                <Select
                                                                    displayEmpty
                                                                    value={el.subWarehouse}
                                                                    disabled={blocked}
                                                                    onChange={(event) => { event.stopPropagation(); changeBoxWarehouse(el.id, event.target.value) }}
                                                                    sx={{ width: "200px", height: "25px", marginRight: "10px" }}
                                                                >
                                                                    {avaibleWarehouses.map(sel => { return <MenuItem key={sel} value={sel} style={{ borderRadius: '10px', marginBottom: '5px' }} onClick={(event) => { event.stopPropagation() }}>{sel}</MenuItem> })}
                                                                </Select>
                                                            }
                                                            <Typography variant='subtitle2' align='right' style={{ marginRight: '10px' }}>{el.sku} SKU, {el.count} шт.</Typography>
                                                            {el.market_code ?
                                                                <Typography variant='subtitle2' align='right' style={{ width: '150px' }}>{el.market_code}</Typography>
                                                                :
                                                                <div style={{ width: '150px' }}></div>
                                                            }
                                                            <Tooltip title={`Добавить товар в короб${blocked? " (заблокировано в хранении)": ""}`}>
                                                                <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); openAddProduct(el.id) }} disabled={blocked} disableRipple>
                                                                    <AddIcon
                                                                        sx={{
                                                                            transition: 'all 0.3s ease',
                                                                            '&:hover': hoverStyle
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                            {/* <Tooltip title="Копировать короб">
                                                                <IconButton aria-label="copy" onClick={(event) => { event.stopPropagation(); copyBox(el.id) }}>
                                                                    <ContentCopyIcon
                                                                        sx={{
                                                                            transition: 'all 0.3s ease',
                                                                            '&:hover': hoverStyle
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip> */}
                                                            <CopyBoxWithCounter 
                                                                el={el.id} 
                                                                parel={undefined} 
                                                                copyBox={copyBox} 
                                                                hoverStyle={hoverStyle}
                                                                blocked={blocked}
                                                            />
                                                            <Tooltip title="Другие функции">
                                                                <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); handleClickMenuOpen(event, el.id) }} disableRipple>
                                                                    <MoreVertIcon
                                                                        sx={{
                                                                            transition: 'all 0.3s ease',
                                                                            '&:hover': hoverStyle
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Menu
                                                                anchorEl={el.openMenu}
                                                                open={Boolean(el.openMenu)}
                                                                onClose={() => handleClickMenuClose(el.id)}
                                                                MenuListProps={{
                                                                    'aria-labelledby': 'basic-button',
                                                                }}
                                                            >
                                                                <>
                                                                {
                                                                    Boolean(el.openSelectPallet)?
                                                                    <>
                                                                    {
                                                                        boxes.filter((fel) => fel.type === "pallet" && fel.sku === 0).map((mpel) => {
                                                                        return (
                                                                                <MenuItem onClick={(event) => { event.stopPropagation(); setPallet(el.id, mpel.id) }}>{mpel.title}</MenuItem>
                                                                        ) 
                                                                        })
                                                                    }
                                                                    </>
                                                                    :
                                                                    <>
                                                                    <MenuItem onClick={(event) => { event.stopPropagation(); delBox(el.id) }} disabled={blocked}>Удалить короб{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                                                    <MenuItem onClick={(event) => { event.stopPropagation(); ShowBarcode(el.title, el.id) }}>Распечатать ШК короба</MenuItem>
                                                                    <MenuItem onClick={(event) => { event.stopPropagation(); handleClickOpenSelectPallet(event, el.id) }} disabled={blocked}>Изменить паллет{blocked? " (заблокировано в хранении)": ""}</MenuItem>
                                                                    <MenuItem disabled={!el.market_code} onClick={(event) => { event.stopPropagation(); ShowMarketBarcode(el.market_code, el.title, el.marcket_bc_path) }}>Распечатать ШК маркетплейса</MenuItem>
                                                                    {!FBSData && <MenuItem onClick={(event) => { event.stopPropagation(); setOpenKIZ(el.id); handleClickMenuClose(el.id)}}>КИЗы</MenuItem>}
                                                                    </>
                                                                }
                                                                </>
                                                            </Menu>
                                                        </div>
                                                    </div>
                                                </ListItemButton>
                                                <Collapse in={el.open} timeout="auto" unmountOnExit>
                                                    {loading? <Loading/> :
                                                        <>
                                                            {data[el.id]? 
                                                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                    {data[el.id].map((datael) => {return productItem(el, datael)})}
                                                                </div>    
                                                            :
                                                                <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Короб пустой</div>
                                                            }
                                                        </>
                                                    }
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                                        {!blocked && changed && changed.findIndex((fel) => fel.box === el.id)>-1?  <Button
                                                            onClick={preventDoubleClick(save, 1000)}
                                                            variant="contained"
                                                            sx={{
                                                                textTransform: 'none',
                                                                backgroundColor: colors.elements,
                                                                fontWeight: 'bold',
                                                                margin: '10px'
                                                            }}
                                                        >
                                                            Применить
                                                        </Button> :null}
                                                    </div>
                                                </Collapse>
                                            </>
                                        ))}
                                    </Collapse>
                                </>
                            }
                        </CardContent>
                    </Scrollbars>
                    }
                </Card>
                <Card sx={{ borderRadius: 3, boxShadow: 0,width: "35%", height: "100%"}}>
                    <CardContent sx={{ height: "100%" }}>
                        <Tabs value={tab} aria-label="basic tabs example" onChange={changeTab}>
                            <Tab label='Нераспределенный товар' value={'main'} />
                            {MW.length > 0  && <Tab label='Распределение по складам' value={'sub'} />}
                        </Tabs>
                        <div style={{display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: 'center'}}>
                            <ClassicSearch 
                                setChecked={setCheckedSub} 
                                setFilter={setFilterSub} 
                                checked={checkedSub}
                                // @ts-ignore
                                fields={tab === 'main'? filterFields: filterFieldsMW}
                                // @ts-ignore
                                setFields={tab === 'main'? setFilterFields: setFilterFieldsMW }
                                // @ts-ignore
                                customWidth={"50%"}
                            />
                            {MW.length > 0 && tab === 'sub' &&
                                <div style={{display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: 'center'}}>
                                    <Select
                                        displayEmpty
                                        value={filterWarehouse}
                                        onChange={(event) => {setFilterWarehouse(event.target.value) }}
                                        sx={{ width: "200px", height: "25px", marginRight: "10px" }}
                                    >
                                        <MenuItem key={'menu_all'} value={undefined} style={{ borderRadius: '10px', marginBottom: '5px' }}>Все</MenuItem>
                                        {avaibleWarehouses.map(sel => { return <MenuItem key={sel} value={sel} style={{ borderRadius: '10px', marginBottom: '5px' }} onClick={(event) => { event.stopPropagation() }}>{sel}</MenuItem> })}
                                    </Select>
                                    <IconButton aria-label="add" onClick={() => {printPickUpListMulti()}} disableRipple> 
                                        <PrintIcon sx={{'&:hover': hoverStyle}}/>
                                    </IconButton>
                                </div>
                            }
                        </div>

                        <TabPanel select={tab} value={'main'}>
                            <Scrollbars
                                style={{ height: "80%" }} autoHide
                            >
                                <ReportTable
                                    ds={nbds}
                                    // data={data["0"] || []}
                                    data={
                                        !checkedSub? data['0']?.filter((el) => el.countProduct > 0) || []:
                                        data["0"]?.filter((el) => {
                                            const tf = filterSub.toLowerCase();
                                            return (
                                                el.countProduct > 0 &&
                                                filterFields.title.active &&
                                                el.data.title &&
                                                String(el.data.title).toLowerCase().includes(tf) ||
                                                filterFields.brand.active &&
                                                el.data.brand &&
                                                String(el.data.brand).toLowerCase().includes(tf) ||
                                                filterFields.vendorCode.active &&
                                                el.data.vendorCode &&
                                                String(el.data.vendorCode).toLowerCase().includes(tf) ||
                                                filterFields.color.active &&
                                                el.data.color &&
                                                el.data.color.join(" ").toLowerCase().includes(tf) ||
                                                filterFields.size.active &&
                                                el.size.ttle &&
                                                String(el.size.title).toLowerCase().includes(tf) ||
                                                filterFields.barcode.active &&
                                                el.size.barcode &&
                                                el.size.barcode.toLowerCase().includes(tf)
                                            )
                                        }) || []
                                    }
                                />
                            </Scrollbars>
                        </TabPanel>
                        <TabPanel select={tab} value={'sub'}>
                            <Scrollbars
                                style={{ height: "80%" }} autoHide
                            >
                                <ReportTable
                                    ds={mwds}
                                    data={
                                        !checkedSub? 
                                            !filterWarehouse? 
                                                MW
                                                : 
                                                MW.filter((fel) => fel.warehouse === filterWarehouse)
                                        :
                                            (!filterWarehouse? MW: MW.filter((fel) => fel.warehouse === filterWarehouse)).filter((el) => {
                                                const tf = filterSub.toLowerCase();
                                                return (
                                                    filterFieldsMW.barcode.active &&
                                                    el.barcode &&
                                                    el.barcode.toLowerCase().includes(tf) ||
                                                    filterFieldsMW.warehouse.active &&
                                                    el.warehouse &&
                                                    el.warehouse.toLowerCase().includes(tf)
                                                )
                                        })
                                    }
                                />
                            </Scrollbars>
                        </TabPanel>
                        {boxes.filter((fel) => fel.type === 'start_pallet').length > 0 && 
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end"}}>    
                                <Tooltip
                                    title={
                                        <div>
                                            <Typography variant='subtitle2' align='left'>
                                                Паллетов/Тюков на приемке {boxes.filter((fel) => fel.type === 'start_pallet').length}
                                            </Typography>
                                            <Typography variant='subtitle2' align='left'>
                                                При нажатии, все паллеты/тюки, которые были созданы пр приёме товара будут удалены
                                            </Typography>
                                        </div>
                                    }
                                >
                                    <Button
                                        onClick={() => {delStartPallets()}}
                                        variant="contained"
                                        size="medium"
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: "bold",
                                            px: 3,
                                        }}
                                    >
                                        Отметить товар как распределенный
                                    </Button>
                                </Tooltip>
                            </div>
                        }
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}


function FBSWBBoxesQRsModal({ data, user, onClose }) {
    //console.log("value", value)
    // состояние для хранения таблицы файлов, выбранных файлов, выбранных страниц, открытого файла и общего количества страниц
    // а также состояния загрузки
    /** @type {[Array<any>, Function]} */
    const [fileBlob, setFileBlob] = useState([]);
    
    /** @type {[any, Function]} */
    const [printTrigger, setPrintTrigger] = useState(undefined);
    /** @type {[Array<any>, Function]} */
    const [selected, setSelected] = useState([]);

    const [tabIdx, setTabIdx] = useState("actual");
    // @ts-ignore
    const handleChangeTab = (event, newValue) => setTabIdx(newValue);

    const [checked, setChecked] = useState(false);
    const [errorSel, setErrorSel] = useState(false);

    const [loading, setLoading] = useState(true);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [delOpen, setDelOpen] = useState(false);
    
    const $ds = useMemo(() => getDataSource('viewIMG'), []);
    const { socket } = useContext(SocketContext);
    const { showNotification } = useLocalNotifications();

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            let result = []
            let files = await get("WBAPI/getSupplyBoxesBarcode", {uid:user, supply_id:data.supply_id})
            if (files.lengt === 0) {
                showNotification({
                    id: 'getSupplyBoxesBarcode', 
                    type: 'warning', 
                    message: `Не найден ни один ШК короба` 
                });
            }
            files.map((el) => {
                result.push({
                    id: el.barcode,
                    render: `data:image/png;base64,${el.file}`
                })
            })
            console.log("files", files)
            setFileBlob(result);
        } catch (error) {
            console.error("Global fetchData error:", error);
        } finally {
            setLoading(false);
        }
    }, [data]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);



    const printSelContainerRef = useRef(null);

    // Исправленный useReactToPrint с правильными настройками
    const startPrint = useReactToPrint({
        contentRef: printSelContainerRef,
        pageStyle: `
            @page { 
                size: 53mm 37mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important; 
                padding: 0 !important;
                -webkit-print-color-adjust: exact; 
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: auto !important;
                overflow: visible !important;
            }
            * {
                box-sizing: border-box;
            }
            .barcode-print-page {
                width: 53mm;
                height: 37mm;
                page-break-after: always;
                break-after: page;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
            }
            .barcode-print-page:last-child {
                page-break-after: auto;
                break-after: auto;
            }
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            setLoadingPrint(false);
            setDelOpen(true);
            setPrintTrigger(undefined);
        }
    });

    // Исправленный обработчик печати
    const handlePrint = () => {

        console.log("selected", selected)
        if (selected.length === 0) {
            setErrorSel(true);
            return;
        } else {
            setErrorSel(false);
        }
        
        // Устанавливаем триггер с данными для печати
        setPrintTrigger(selected);
        setLoadingPrint(true);
    };

    // useEffect для запуска печати при изменении триггера
    useEffect(() => {
        if (!printTrigger) {
            return;
        }

        const runPrint = async () => {
            // Небольшая задержка нужна, чтобы React успел отрендерить все элементы
            await new Promise(resolve => setTimeout(resolve, 100));
            startPrint();
        };

        runPrint();
    }, [printTrigger, startPrint]);

    const onSelectPages = useCallback((indata) => {
        let res = []
        indata.map((el) => {
            let idx = fileBlob.findIndex((fel) => fel.id === el)
            if (idx > -1 ) {res.push(fileBlob[idx])}
        });
        setSelected(res)
    }, [fileBlob, setSelected]);

    if (loading) {
        return (<Loading></Loading>);
    }

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ height: '90%', display: 'flex', flexDirection: 'row' }}>
                <Scrollbars
                    style={{ width: '100%', height: '100%'}} 
                >
                    <ReportTable 
                        ds={$ds} 
                        data={fileBlob}
                        onSelect={(data) => onSelectPages(data)}
                        autoPagination={20}
                    />
                </Scrollbars>
            </div>
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    height: "10%",
                    width: "100%",
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                }}
            >
            
                <CancelButton action={onClose} text={"ЗАКРЫТЬ"}/>
                <OKButton action={handlePrint} text={"ПЕЧАТЬ"} disabled={selected.length === 0}/>
                
            </Box>
            <div style={{ position: 'fixed', left: '-10000px', top: 0, width: '100%', visibility: 'visible', pointerEvents: 'none' }}>
                <div ref={printSelContainerRef}>
                    {printTrigger && printTrigger.map((item, index) => (
                        <div key={`print-${index}`} className="barcode-print-page" style={{ width: '53mm', height: '37mm' }}>
                            <img 
                                src={item.render} 
                                style={{ 
                                    width: '100%', 
                                    height: '100%',
                                    objectFit: 'cover',
                                    display: 'block',
                                    margin: 0,
                                    padding: 0
                                }} 
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function FBSWBSupplyQRsModal({ data, user }) {
    //console.log("value", value)
    // состояние для хранения таблицы файлов, выбранных файлов, выбранных страниц, открытого файла и общего количества страниц
    // а также состояния загрузки
    /** @type {[Array<any>, Function]} */
    const [fileBlob, setFileBlob] = useState([]);
    
    const [printedFiles, setPrintedFiles] = useState([]);
    const [printList, setPrintList] = useState([]);
    const [printCount, setPrintCount] = useState(0);
    const [printMet, setPrintMet] = useState(undefined);
    /** @type {[any, Function]} */
    const [printTrigger, setPrintTrigger] = useState(null);
    /** @type {[Array<any>, Function]} */
    const [selected, setSelected] = useState([]);

    const [tabIdx, setTabIdx] = useState("actual");
    // @ts-ignore
    const handleChangeTab = (event, newValue) => setTabIdx(newValue);

    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState("");

    const [error, setError] = useState(false);
    const [errorSel, setErrorSel] = useState(false);

    const [loading, setLoading] = useState(true);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [delOpen, setDelOpen] = useState(false);
    
    const $ds = useMemo(() => getDataSource('viewIMG'), []);
    const { socket } = useContext(SocketContext);
    const { showNotification } = useLocalNotifications();

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            let result = []

            //FBS_COM
            let files = await get("WBAPI/getSupplyBarcode", {uid:user, supply_id:data.supply_id})
            if (files.lengt === 0) {
                showNotification({
                    id: 'getSupplyBarcode', 
                    type: 'warning', 
                    message: `Не найден шк поставки` 
                });
            }
            files.map((el) => {
                result.push({
                    id: el.barcode,
                    render: `data:image/png;base64,${el.file}`
                })
            })
            console.log("files", files)
            setFileBlob(result);
        } catch (error) {
            console.error("Global fetchData error:", error);
        } finally {
            setLoading(false);
        }
    }, [data]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);



    const printSelContainerRef = useRef(null);


    const startPrint = useReactToPrint({
        contentRef:printSelContainerRef,
        pageStyle: `
            @page { size: auto; margin: 0; }
            body { margin: 0; -webkit-print-color-adjust: exact; }
            html, body { height: auto !important; } 
            `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            setLoadingPrint(false);
            setDelOpen(true);
        }
    });

    
    const handlePrint = () => {
        if (selected.length === 0) {
            setErrorSel(true);
            return; // Не продолжаем, если ошибка
        } else {
            setErrorSel(false);
        }
        // Устанавливаем printMet и триггер печати
        setPrintTrigger(true); // Это запустит useEffect
        setLoadingPrint(true)
    };

    useEffect(() => {
        if (printTrigger) {
            startPrint();
            setPrintTrigger(null); // Сбрасываем триггер после печати
        }
    }, [printTrigger, startPrint]); // Зависимости: триггер и startPrint



    const onSelectPages = useCallback((indata) => {
        let res = []
        indata.map((el) => {
            let idx = fileBlob.findIndex((fel) => fel.id === el)
            if (idx > -1 ) {res.push(fileBlob[idx])}
        });
        setSelected(res)
    }, [fileBlob, setSelected]);

    if (loading) {
        return (<Loading></Loading>);
    }

    return (
        <div style={{ height: '70%', display: 'flex', flexDirection: 'column' }}>
            <Grid container sx={{ height: "90%" }} spacing={1}>
                <Grid item xs={5.95}>
                    <ClassicSearch setChecked={setChecked} setFilter={setFilter} checked={checked}/>
                    <Box
                        display="flex"
                        flexDirection='column'

                    >
                        <Box sx={{
                            width: "100%", display: 'flex',
                            flexDirection: 'column',
                            height: '49vh',
                            boxSizing: 'border-box'
                        }}>
                            {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: "700px" }}><Loading></Loading></div> :
                                <Box sx={{ overflow: 'auto', flex: 1 }}>
                                    <ReportTable 
                                        ds={$ds} 
                                        data={fileBlob}
                                        onSelect={(data) => onSelectPages(data)}
                                        autoPagination={20}
                                    />
                                </Box>}
                        </Box>
                        <Box display="flex" flexDirection="column" gap={4}>
                            <Typography>
                                Элементов: {fileBlob?.
                                    // @ts-ignore
                                    length || 0}
                            </Typography>
                        </Box>

                    </Box>
                </Grid>
                <Grid item xs={0.1}>
                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Divider orientation="vertical" sx={{ borderRightWidth: "4px" }} />
                    </div>
                </Grid>
                <Grid item xs={5.95}>
                    <div style={{
                        display: 'flex', flexDirection: 'column',
                    }}>

                        <div style={{ marginTop: '10px', width: '100%' }}>
                            {errorSel === true ? <Typography variant='subtitle2' color='error'>{`Ни один элемент не выбран`}</Typography> : <></>}
                            <Button onClick={() => handlePrint()} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать выделенные</Button>
                            {tabIdx === "printed" ? <Typography variant='subtitle2' color='error'>{`Внимание! Эти QR-коды уже были распечатанны, печатайте их снова только если знаете, что делаете`}</Typography> : <></>}
                        </div>
                    </div>
                </Grid>
            </Grid>
            <div style={{ position: 'absolute', right: '9999px', top: 0 }}>
                <div ref={printSelContainerRef} >
                    <div>
                        {selected.map((item, index) => (
                            <img key={`print-${index}`} src={item.render} style={{ width: '53mm', height: '37mm', margin:"0.5mm", pageBreakAfter: index < selected.length - 1 ? 'always' : 'auto' }} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}


const CopyBoxWithCounter = ({ el, parel, copyBox, hoverStyle, blocked}) => {
    const [copyCount, setCopyCount] = useState(1);
    const [copyOpen, setCopyOpen] = useState(false)
    const [anchorTPBP, setAnchorTPBP] = useState(null);

    const handleOpen = (event) => {
        event.stopPropagation();
        setAnchorTPBP(event.currentTarget);
        setCopyOpen(true);
    };

    const handleClose = () => {
        setCopyOpen(false);
        setAnchorTPBP(null);
        setCopyCount(1);
    };


  const handleCopy = (event) => {
    event.stopPropagation();
    // Выполняем copyBox указанное количество раз
    copyBox(el, parel, copyCount);
  };

  const preventDoubleClick = usePreventDoubleClick();

  const size = 10

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
      <Tooltip title={`Копировать короб ${blocked? " (заблокировано в хранении)": ""}`}>
        <IconButton 
          aria-label="copy" 
          onClick={handleOpen}
          disabled={blocked}
          disableRipple
          sx={{
            transition: 'all 0.3s ease',
            '&:hover': hoverStyle
          }}
        >
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
      <Popover
            open={copyOpen}
            anchorEl={anchorTPBP}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{ sx: { mt: 1, p: 1 } }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 160, alignItems: 'center' }}>
                <MuiInput
                    sx={{
                    ':after': { borderBottomColor: '#005b52' },
                    width: '120px',
                    fontSize: '12px',
                    textAlign: 'center',
                    '& input': { textAlign: 'center' }
                    }}
                    value={copyCount}
                    size="medium"
                    onClick={(e) => {e.stopPropagation();}}
                    onChange={(event) => {
                        const val = event.target.value;
                        if (!val || val === '') setCopyCount(1);
                        else {
                            const num = parseInt(val, 10);
                            if (!isNaN(num)) setCopyCount(num);
                        }
                    }}
                    inputProps={{ 'aria-labelledby': 'input-count' }}
                />
                <Button variant='text' onClick={preventDoubleClick(handleCopy, 1000, true)} sx={{ fontSize: '12px', borderRadius: '10px', height: '20px' }}>
                    Копировать
                </Button>
            </Box>
        </Popover>
    </Box>
  );
};

function AddProductToBox({data, cancel, onSave, float = false}) {
    /** @type {[Array<any>, Function]} */
    const [$data, setData] = useState([])
    /** @type {[Array<any>, Function]} */;
    const [selected, setSelected] = useState([]);
    // загрузка дескриптора
    const ds = useMemo(() => getDataSource(float? 'BindProductsSelectedFloat': 'BindProductsSelected'), []);
    
    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            color: {name: "Цвет", active: true},
            size: {name: "Размер", active: true}
        }
    );

    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    
    const onSelect = (select) => {
        console.log("onSelect", select)
        setSelected(select);
    };

    const onChangeCount = (idata) => {
        let tmp = [...$data]
        let idx = tmp.findIndex((el) => el.id === idata.row.id)
        let idx2 = data.findIndex((el) => el.id === idata.row.id)
        if (idx > -1) {
            if (idx > -1 && data[idx2].countProduct >= idata.count) {
                tmp[idx].countProduct = idata.count
            }else {tmp[idx].countProduct = data[idx2].countProduct}
        }
        setData(tmp)
    }

    const goBind = async () => {
        if (selected.length>0) {
            let res = []
            for (let sel of selected) {
                let idx = $data.findIndex((el) => el.id === sel)
                if (idx > -1 ) {
                    if ($data[idx].countProduct > 0) {
                        res.push({...$data[idx]})
                    }
                    else {
                        showNotification({
                            id: 'binderr', 
                            type: 'error', 
                            message: 'У товара не указано количество' 
                        });        
                        return 1
                    }
                }
                
            }
            onSave(res)
            cancel(false);
        }
        else {
            showNotification({
                id: 'binderr', 
                type: 'error', 
                message: 'Ни один товар не выбран' 
            });
        }
    }

    useEffect(() => {
        setData(data.map((el) => {return {...el}}))
    }, [data]);

    console.log("data", $data)

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
            }}
        >
            {/* Заголовок */}

            <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "text.primary",

                }}
            >
                {`${ds.descr.title}`}
            </Typography>


            {/* Поле поиска */}
            <Box sx={{ width: "50%" }}>
                <ClassicSearch 
                    setChecked={setChecked} 
                    setFilter={setFilter} 
                    checked={checked}
                    // @ts-ignore
                    fields={filterFields}
                    // @ts-ignore
                    setFields={setFilterFields}
                />
            </Box>

            {/* Таблица с прокруткой */}
            <Box
                sx={{
                    flex: 1,
                    overflow: "auto",
                    borderRadius: 2,
                }}
            >
                <ReportTable
                    ds={ds}
                    data={!checked? data: data.filter((el) => {const tf = filter.toLowerCase(); 
                        return (
                            filterFields.title.active && 
                                el.data.title &&
                                String(el.data.title).toLowerCase().includes(tf) || 
                            filterFields.brand.active && 
                                el.data.brand &&
                                String(el.data.brand).toLowerCase().includes(tf) || 
                            filterFields.vendorCode.active && 
                                el.data.vendorCode &&
                                String(el.data.vendorCode).toLowerCase().includes(tf) ||
                            filterFields.color.active &&
                                el.data.color &&
                                el.data.color.join(" ").toLowerCase().includes(tf) ||
                            filterFields.size.active &&
                                el.size.ttle &&
                                String(el.size.title).toLowerCase().includes(tf) ||
                            filterFields.barcode.active && 
                                el.size.barcode &&
                                String(el.size.barcode).toLowerCase().includes(tf)
                        )
                    })}
                    onSelect={onSelect}
                    onFormatterChange={(data) => onChangeCount(data)}
                    // filterSettings={{active: checked, filter: filter.toLowerCase(), checkList: ["data.title", "data.brand", "data.vendorCode", "data.barcode"]}}
                />
            </Box>

            {/* Нижняя панель с кнопками и полем ввода */}
            <Box

                sx={{
                    mt: 'auto',
                    p: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    borderRadius: 2,
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "auto",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        onClick={preventDoubleClick(goBind, 1000)}
                        variant="contained"
                        size="medium"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                        }}
                    >
                        Добавить
                    </Button>
                    <Button
                        onClick={() => cancel(false)}
                        variant="contained"
                        size="medium"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                            backgroundColor: "grey.500",
                            "&:hover": { backgroundColor: "grey.600" },
                        }}
                    >
                        Отмена
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}


// @ts-ignore
function BoxBarCode({D, C, B, id, deal_id, user_id, WH}) {
    const printRef = useRef(null)

    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        // pageStyle: `
        //     @page { size: auto; margin: 0; }
        //     body { margin: 0; -webkit-print-color-adjust: exact; }
        //     html, body { height: auto !important; }
        // `,
        pageStyle: `
            @page { 
                size: 58mm 40mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important;
                padding: 0 !important;
                width: 58mm;
                height: 40mm;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: 100% !important;
                overflow: hidden;
            }
            * {
                box-sizing: border-box;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_box_barcode",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                <Card ref={printRef} sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                    <CardContent sx={{marginTop:"3mm", marginLeft:"2mm"}}>   
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <div style={{display:"flex", flexDirection:"row", width: "48mm", height: "7mm", marginTop:"10mm", alignItems: 'center'}}>
                                <div style={{width: "65%"}}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start"}}>
                                        {/* <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "6mm", fontSize: "6mm"}}>{String(10000 + parseInt(C)).slice(1,5)}</Typography> */}
                                        <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "4mm"}}>Сделка: {String(10000 + parseInt(D)).slice(1,5)}</Typography>
                                        <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "4mm"}}>{WH}</Typography>
                                    </div>
                                    <Typography align={'center'} sx={{ fontWeight: 'bold', fontSize: "14mm"}}>{B}</Typography>
                                </div>
                                <div style={{width: "30%"}}>
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", width: "20mm", height: "20mm", transform: 'rotate(-90deg)'}}>
                                        <Barcode format='CODE128' value={`${B}-${String(10000 + parseInt(D)).slice(1,5)}-${String(10000 + parseInt(C)).slice(1,5)}`} width={1.05} height={48} fontSize={20} textMargin={0} />
                                    </div>
                                </div>
                                
                            </div>
                        </div>               
                    </CardContent>
                    {/* <CardContent sx={{marginTop:"1mm"}}>   
                        <div style={{ display: 'flex', flexDirection: 'row', marginLeft:"2mm"}}>
                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "10mm", fontSize: "10mm"}}>{B}</Typography>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "4mm", fontSize: "5mm"}}>{String(10000 + parseInt(C)).slice(1,5)}</Typography>
                                <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "4mm", fontSize: "5mm"}}>{String(10000 + parseInt(D)).slice(1,5)}</Typography>
                            </div>
                        </div>
                        <Barcode format='CODE128' value={`${String(10000 + parseInt(C)).slice(1,5)}-${String(10000 + parseInt(D)).slice(1,5)}-${B}`} width={1.15} height={48} fontSize={0} textMargin={0} />
                    </CardContent> */}
                </Card>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Button onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}


function MarketBarCode({code, BOX, DEAL, CLI, deal_id, user_id}) {
    const printRef = useRef(null)

    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        // pageStyle: `
        //     @page { size: auto; margin: 0; }
        //     body { margin: 0; -webkit-print-color-adjust: exact; }
        //     html, body { height: auto !important; }
        // `,
        pageStyle: `
            @page { 
                size: 58mm 40mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important;
                padding: 0 !important;
                width: 58mm;
                height: 40mm;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: 100% !important;
                overflow: hidden;
            }
            * {
                box-sizing: border-box;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_market_barcode",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                <Card ref={printRef} sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                    <CardContent sx={{marginTop:"1mm", marginLeft:"4mm"}}>
                        <div style={{ display: 'flex', flexDirection: 'row', marginLeft:"2mm"}}>
                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "10mm", fontSize: "10mm"}}>{BOX}</Typography>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "5mm"}}>{String(10000 + parseInt(CLI)).slice(1,5)}</Typography>
                                <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "5mm"}}>{String(10000 + parseInt(DEAL)).slice(1,5)}</Typography>
                            </div>
                        </div>
                        <Barcode format='CODE128' value={code} width={1.0} height={48} fontSize={18} textMargin={0} />
                    </CardContent>
                </Card>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Button onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}


function CustomMarketBarCode({path, BOX, DEAL, CLI, deal_id, user_id}) {
    const printRef = useRef(null)

    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        // pageStyle: `
        //     @page { size: auto; margin: 0; }
        //     body { margin: 0; -webkit-print-color-adjust: exact; }
        //     html, body { height: auto !important; }
        // `,
        pageStyle: `
            @page { 
                size: 58mm 40mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important;
                padding: 0 !important;
                width: 58mm;
                height: 40mm;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: 100% !important;
                overflow: hidden;
            }
            * {
                box-sizing: border-box;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_market_barcode",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }
    /** @type {[any, Function]} */
    const [image, setImage] = useState(undefined)
    const [customBCLoad, setCustomBCLoad] = useState(true)
    const [isPortrait, setIsPortrait] = useState(false)
    const [imageLoaded, setImageLoaded] = useState(false)

    // Эффект для определения ориентации изображения после загрузки
    useEffect(() => {
        if (image) {
            const img = new Image();
            img.onload = () => {
                setIsPortrait(img.height > img.width);
                setImageLoaded(true);
            };
            img.src = image;
        }
    }, [image]);

    useEffect(() => {
        if (path) {
            const checkPhoto = async () => {
                console.log("path", path)
                try {
                    setCustomBCLoad(true);
                    setImageLoaded(false); // Сбрасываем флаг загрузки
                    let tmp = await getFile("png", { path:path });
                    if (typeof tmp === "string") {
                        setImage(tmp);
                    }
                }
                catch (err) {
                    console.error("Error loading image:", err);
                }
                finally {
                    setCustomBCLoad(false);
                }
            }

            checkPhoto();
        }
    }, [path]);

    const scale = 1

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                {customBCLoad ? <Loading></Loading> :
                    <>
                    {image && imageLoaded &&
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            transform: `scale(${scale})`, 
                            transformOrigin: '0 0', 
                            width: `${100 / scale}%`, 
                            height: `${100 / scale}%`,
                            alignItems: "center",
                            pageBreakAfter: 'always'
                        }}>
                            <Card 
                                ref={printRef}
                                sx={{ 
                                    borderRadius: 0, 
                                    padding: "0px",
                                    width: isPortrait ? "40mm" : "58mm",
                                    height: isPortrait ? "58mm" : "40mm",
                                    position: "relative" // Добавляем relative для позиционирования дочерних элементов
                                }}
                            >
                                <CardContent sx={{ 
                                    width: "100%",
                                    height: "100%",
                                    padding: "0px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "space-evenly",
                                    position: "relative" // Добавляем relative
                                }}>   
                                    <img 
                                        src={image} 
                                        style={{
                                            width: "100%",
                                            height: "110%",
                                            marginTop: "12px",
                                            objectFit: "fill",
                                            display: "block"
                                        }}
                                        alt="Штрих-код"
                                    />
                                    
                                    {/* Текст поверх изображения */}
                                    <div style={{
                                        position: "absolute",
                                        top: "12mm",
                                        left: "27mm",
                                        // transform: "translate(-50%, -50%)",
                                        padding: "4px 8px",
                                        borderRadius: "4px",
                                        fontSize: "2mm",
                                        fontWeight: "bold",
                                    }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', marginLeft:"2mm"}}>
                                            <Typography sx={{fontWeight: 'bold', lineHeight: "3mm", fontSize: "3mm"}}>{BOX}</Typography>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography sx={{fontWeight: 'bold', lineHeight: "1.5mm", fontSize: "1.5mm"}}>{String(10000 + parseInt(CLI)).slice(1,5)}</Typography>
                                                <Typography sx={{fontWeight: 'bold', lineHeight: "1.5mm", fontSize: "1.5mm"}}>{String(10000 + parseInt(DEAL)).slice(1,5)}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    }
                    </>
                }
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Button onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}


function ShipmentBarCode({code, deal_id, user_id, warehouse, shipmentNumber}) {
    const printRef = useRef(null)

    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        // pageStyle: `
        //     @page { size: auto; margin: 0; }
        //     body { margin: 0; -webkit-print-color-adjust: exact; }
        //     html, body { height: auto !important; }
        // `,
        pageStyle: `
            @page { 
                size: 58mm 40mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important;
                padding: 0 !important;
                width: 58mm;
                height: 40mm;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: 100% !important;
                overflow: hidden;
            }
            * {
                box-sizing: border-box;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_shipment_barcode",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                <Card ref={printRef} sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                    <CardContent sx={{marginTop:"3mm", marginLeft:"2mm"}}>
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                            <Typography sx={{fontWeight: 'bold', lineHeight: "3mm", fontSize: "3mm", marginRight: '1mm'}}>{warehouse}</Typography>
                            <Typography sx={{fontWeight: 'bold', lineHeight: "3mm", fontSize: "3mm"}}>№ {shipmentNumber}</Typography>
                        </div>
                        <Barcode format='CODE128' value={code}  width={0.9} height={48} fontSize={18} textMargin={0} />
                    </CardContent>
                </Card>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Button onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function BoxAllBarCode({boxes, deal_id, user_id, WH}) {
    const printRef = useRef(null)
    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        pageStyle: `
            @page { size: auto; margin: 0; }
            body { margin: 0; -webkit-print-color-adjust: exact; }
            html, body { height: auto !important; }
        `,
        // pageStyle: `
        //     @page { 
        //         size: 58mm 40mm; 
        //         margin: 0 !important; 
        //         padding: 0 !important;
        //         marks: none;
        //     }
        //     body { 
        //         margin: 0 !important;
        //         padding: 0 !important;
        //         width: 58mm;
        //         height: 40mm;
        //         display: flex;
        //         align-items: center;
        //         justify-content: center;
        //         -webkit-print-color-adjust: exact;
        //         print-color-adjust: exact;
        //         background: white;
        //     }
        //     html, body { 
        //         height: 100% !important;
        //         overflow: hidden;
        //     }
        //     * {
        //         box-sizing: border-box;
        //     }
        // `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_box_barcode_all",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: "500px", width: "500px", justifyContent: "space-between"}}>
            <Scrollbars style={{height: "95%"}} autoHide>
                <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <div ref={printRef}>
                        {boxes.map((item, index) => (
                            <div 
                                key={`print-${index}`}
                                style={{
                                    pageBreakAfter: index < boxes.length - 1 ? 'always' : 'auto',
                                    // backgroundColor: '#ffffff',
                                    height: '40mm',
                                    marginBottom: "10px",
                                    boxSizing: 'border-box'
                                }}
                                >
                                    <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                                        <CardContent sx={{marginTop:"3mm", marginLeft:"2mm"}}>   
                                            <div style={{display:"flex", flexDirection:"column"}}>
                                                <div style={{display:"flex", flexDirection:"row", width: "48mm", height: "7mm", marginTop:"10mm", alignItems: 'center'}}>
                                                    <div style={{width: "65%"}}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start"}}>
                                                            {/* <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "6mm", fontSize: "6mm"}}>{String(10000 + parseInt(item.C)).slice(1,5)}</Typography>
                                                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "6mm", fontSize: "6mm"}}>{String(10000 + parseInt(item.D)).slice(1,5)}</Typography> */}
                                                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "4mm"}}>Сделка: {String(10000 + parseInt(item.D)).slice(1,5)}</Typography>
                                                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "4mm"}}>{WH}</Typography>
                                                        </div>
                                                        <Typography align={'center'} sx={{ fontWeight: 'bold', fontSize: "14mm"}}>{item.B}</Typography>
                                                    </div>
                                                    <div style={{width: "30%"}}>
                                                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", width: "20mm", height: "20mm", transform: 'rotate(-90deg)'}}>
                                                            <Barcode format='CODE128' value={`${item.B}-${String(10000 + parseInt(item.D)).slice(1,5)}-${String(10000 + parseInt(item.C)).slice(1,5)}`}  width={1.05}height={48} fontSize={20} textMargin={0} />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>               
                                        </CardContent>
                                    </Card>
                            </div>
                        ))}
                    </div>
                </div>
            </Scrollbars>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Button onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function BoxNBarCode({DEAL, CLI, deal_id, user_id}) {
    const printRef = useRef(null)
    const [count, setCount] = useState(1)
    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        pageStyle: `
            @page { size: auto; margin: 0; }
            body { margin: 0; -webkit-print-color-adjust: exact; }
            html, body { height: auto !important; }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_box_barcode_all",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }

    

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: "500px", width: "500px", justifyContent: "space-between"}}>
            <Scrollbars style={{height: "95%"}} autoHide>
                <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <div ref={printRef}>
                        {Array.from({ length: count }).map((_, index) => (
                            <div 
                                key={`print-${index}`}
                                style={{
                                    pageBreakAfter: index < count - 1 ? 'always' : 'auto',
                                    // backgroundColor: '#ffffff',
                                    height: '40mm',
                                    marginBottom: "10px",
                                    boxSizing: 'border-box'
                                }}
                                >
                                    <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                                        <CardContent sx={{marginTop:"3mm", marginLeft:"2mm"}}>   
                                            <div style={{display:"flex", flexDirection:"column"}}>
                                                <div style={{display:"flex", flexDirection:"row", width: "48mm", height: "7mm", marginTop:"10mm", alignItems: 'center'}}>
                                                    <div style={{width: "65%"}}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-end"}}>
                                                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "6mm", fontSize: "6mm"}}>{String(10000 + parseInt(CLI)).slice(1,5)}</Typography>
                                                            <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "6mm", fontSize: "6mm"}}>{String(10000 + parseInt(DEAL)).slice(1,5)}</Typography>
                                                        </div>
                                                        <Typography align={'center'} sx={{ fontWeight: 'bold', fontSize: "14mm"}}>{index+1}</Typography>
                                                    </div>
                                                    <div style={{width: "30%"}}>
                                                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", width: "20mm", height: "20mm", transform: 'rotate(-90deg)'}}>
                                                            <Barcode format='CODE128' value={`${index+1}-${String(10000 + parseInt(DEAL)).slice(1,5)}-${String(10000 + parseInt(CLI)).slice(1,5)}`}  width={1.1} height={48} fontSize={20} textMargin={0} />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>               
                                        </CardContent>
                                    </Card>
                            </div>
                        ))}
                    </div>
                </div>
            </Scrollbars>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{ marginTop: '10px', width: '100%',display: 'flex', flexDirection: 'column',}}>
                    <NumInput title={"Сколько будет распечатано"} val={count} onChange={(v) => setCount(v)}/>
                    {/* <TextField
                        label="Сколько будет распечатано"
                        type="number"
                        value={count}
                        onClick={() => console.log('TextField clicked')}
                        onMouseDown={() => console.log('MouseDown on TextField')}
                        onChange={(e) => valCheck(Number(e.target.value))}
                        variant="outlined"
                        size="small"
                        sx={{ width: '200px', marginTop: "5px", zIndex: 99999}}
                        InputProps={{ inputProps: { min: 1 } }} 
                    /> */}
                    <Button disabled={count<1} onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                </div>
            </div>
        </div>
    )
}

function MarketAllBarCode({boxes, deal_id, user_id}) {
    const printRef = useRef(null)
    
    const startPrint = useReactToPrint({
        contentRef:printRef,
        pageStyle: `
            @page { size: auto; margin: 0; }
            body { margin: 0; -webkit-print-color-adjust: exact; }
            html, body { height: auto !important; }
        `,
        // pageStyle: `
        //     @page { 
        //         size: 58mm 40mm; 
        //         margin: 0 !important; 
        //         padding: 0 !important;
        //         marks: none;
        //     }
        //     body { 
        //         margin: 0 !important;
        //         padding: 0 !important;
        //         width: 58mm;
        //         height: 40mm;
        //         display: flex;
        //         align-items: center;
        //         justify-content: center;
        //         -webkit-print-color-adjust: exact;
        //         print-color-adjust: exact;
        //         background: white;
        //     }
        //     html, body { 
        //         height: 100% !important;
        //         overflow: hidden;
        //     }
        //     * {
        //         box-sizing: border-box;
        //     }
        // `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            post("Logs/create", {
                deal_id:deal_id,
                user_type:"ful",
                user_id,
                type: "print_market_barcode_all",
                data: {}
            })
        }
    });

    const handlePrint = () => {
        startPrint()
    }

    const [customBCLoad, setCustomBCLoad] = useState(true)
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([])

    console.log("data", data)

    useEffect(() => {
        if (boxes) {
            const checkPhoto = async (tmpboxes) => {
                    setCustomBCLoad(true);
                    await Promise.all(tmpboxes.map(async (el, index) => {
                        try {

                            if (el.cbc) {
                                let tmp = await getFile("png", { path:el.cbc });
                                if (typeof tmp === "string") {
                                    el.img = tmp
                                    console.log(index)
                                }                        
                            }
                            else {el.img = undefined}
                        }
                        catch (err) {
                            console.error("Error loading image:", err);
                            el.img = undefined
                        }
                    }))
                    setData(tmpboxes)
                    setCustomBCLoad(false);
            }
            let tmpboxes = JSON.parse(JSON.stringify(boxes))
            checkPhoto(tmpboxes);
        }
    }, [boxes]);

    const scale=1

    if (customBCLoad) return (<Loading></Loading>);

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: "500px", width: "500px", justifyContent: "space-between"}}>
            <Scrollbars style={{height: "95%"}} autoHide>
                <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <div ref={printRef}>
                        {data.map((item, index) => (
                            <>
                            {item.img? 
                                <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                transform: `scale(${scale})`, 
                                transformOrigin: '0 0', 
                                width: `${100 / scale}%`, 
                                height: `${100 / scale}%`,
                                alignItems: "center",
                                marginBottom: "10px",
                                pageBreakAfter: index < boxes.length - 1 ? 'always' : 'auto',
                            }}>
                                <Card 
                                    ref={printRef}
                                    sx={{ 
                                        borderRadius: 0, 
                                        padding: "0px",
                                        width: "58mm",
                                        height: "40mm",
                                        position: "relative" // Добавляем relative для позиционирования дочерних элементов
                                    }}
                                >
                                    <CardContent sx={{ 
                                        width: "100%",
                                        height: "100%",
                                        padding: "0px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "space-evenly",
                                        position: "relative" // Добавляем relative
                                    }}>   
                                        <img 
                                            src={item.img} 
                                            style={{
                                                marginTop: "12px",
                                                width: "100%",
                                                height: "110%",
                                                objectFit: "fill",
                                                display: "block",
                                            }}
                                            alt="Штрих-код"
                                        />
                                        
                                        {/* Текст поверх изображения */}
                                        <div style={{
                                            position: "absolute",
                                            top: "12mm",
                                            left: "27mm",
                                            // transform: "translate(-50%, -50%)",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            fontSize: "2mm",
                                            fontWeight: "bold",
                                        }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', marginLeft:"2mm"}}>
                                                <Typography sx={{fontWeight: 'bold', lineHeight: "6mm", fontSize: "6mm"}}>{item.BOX}</Typography>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <Typography sx={{fontWeight: 'bold', lineHeight: "3mm", fontSize: "3mm"}}>{String(10000 + parseInt(item.CLI)).slice(1,5)}</Typography>
                                                    <Typography sx={{fontWeight: 'bold', lineHeight: "3mm", fontSize: "3mm"}}>{String(10000 + parseInt(item.DEAL)).slice(1,5)}</Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                                :
                                <div 
                                    key={`print-${index}`}
                                    style={{
                                        pageBreakAfter: index < boxes.length - 1 ? 'always' : 'auto',
                                        // backgroundColor: '#ffffff',
                                        height: '40mm',
                                        marginBottom: "10px",
                                        boxSizing: 'border-box',
                                        alignItems: "center",
                                        display:'flex',
                                        flexDirection: 'column',
                                    }}
                                    >
                                        <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                                            <CardContent sx={{marginTop:"1mm", marginLeft:"4mm"}}>
                                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft:"2mm"}}>
                                                    <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "10mm", fontSize: "10mm"}}>{item.BOX}</Typography>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "5mm"}}>{String(10000 + parseInt(item.CLI)).slice(1,5)}</Typography>
                                                        <Typography sx={{ marginLeft:"2mm", fontWeight: 'bold', lineHeight: "5mm", fontSize: "5mm"}}>{String(10000 + parseInt(item.DEAL)).slice(1,5)}</Typography>
                                                    </div>
                                                </div>
                                                <Barcode format='CODE128' value={item.code} width={1.0} height={48} fontSize={18} textMargin={0} />
                                            </CardContent>
                                        </Card>
                                </div>
                            }
                            </>
                        ))}
                    </div>
                </div>
            </Scrollbars>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Button onClick={handlePrint} startIcon={<PrintIcon />} variant="contained" sx={{ ":hover": { bgcolor: "#005b52", color: "white" }, width: '100%', textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >Распечатать</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}



// @ts-ignore
const ItemPay = ({ data }) => {
    let [open, setOpen] = useState(false);
    const [sum, setSum] = useState(0)
    console.log("ItemPay", data)
    

    useEffect(() => {
        let tmp = 0
        data.map((el) => {tmp += el.price})
        setSum(tmp)
    }, [data])

    return (
        <>
            <ListItemButton onClick={() => setOpen(JSON.parse(JSON.stringify(!open)))}>
                <ListItemText primary={<div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Typography variant="h4">{data.service}</Typography>
                <Typography variant="h4">{`${sum} р.`}</Typography></div>} />
                {/* {open === true ? <ExpandLess /> : <ExpandMore />} */}
            </ListItemButton>
            {/* Закоментирована часть которая позволяет выводить подробную информацию о услуге и тп, потом когда-нибудь доработаем */}
            {/* <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {data.subActions.map((value)=>
                    <div style={{display:'flex', justifyContent:'space-between', margin: '0.5% 2% 0.5% 4%'}}>
                        <Typography variant="subtitle1">{Object.keys(value)[0]}</Typography>
                        <Typography variant="subtitle1">{`${Object.values(value)[0]} р.`}</Typography>
                    </div>
                    )}
                </List>
            </Collapse> */}
        </>
    );
}

function PayDeal({ $data, setInfo, setSearch, inUse}) {
    const [open, setOpen] = useState(false)
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([])
    /** @type {[any, Function]} */
    const [docDate, setDocDate] = useState(undefined)
    /** @type {[any, Function]} */
    const [rekv, setRekv] = useState(undefined)
    const [sum, setSum] = useState(0)
    const [loading, setLoading] = useState(false)
    const [allPay, setAllPay] = useState("noPay")
    const ds = useMemo(() => getDataSource('DealPay'), []);
    const { showNotification } = useLocalNotifications();
    const [dealNumber, setDealNumber] = useState(null);
    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)
    const [allEtimated, setAllEtimated] = useState(0)
    const [allDefect, setAllDefect] = useState(0)
    const [price, setPrice] = useState({
        working: 0,
        pickup: 0,
        shipment: 0,
        storage: 0,
    })
    /** @type {[any, Function]} */
    const [state, setState] = useState({
        right: false,
        id: 0
    });
    /** @type {[any, Function]} */
    const [docObj, setDocObj] = useState(undefined)

    // Состояние для всплывающего меню
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    useEffect(() => {
        const getInfo = () => {
            return (
                <>
                    <Typography sx={{ 
                            fontSize: '14pt', 
                            fontWeight: 'bold', 
                            margin: '5px 15px 5px 10px',
                            color: '#078376'
                        }}>
                        Номер сделки: {dealNumber}
                    </Typography>

                    <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'  }}>
                        SKU: {allSKU} шт.
                    </Typography>

                    {allEtimated > 0 &&
                        <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                            Заявлено: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated ? 'red' : 'inherit' }}>{allEtimated} шт.</Typography>
                        </Typography>
                    }
                    <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap', margin: '5px 15px 5px 0px'  }}>
                        Фактически: <Typography component="span" sx={{ fontSize: '12pt', color: allProduct !== allEtimated && allEtimated > 0? 'red' : 'inherit' }}>{allProduct} шт.</Typography>
                    </Typography>
                </>
            )
        }
        if (inUse) {
            setInfo(getInfo())
        }
    }, [dealNumber, allSKU, allProduct, allEtimated, allDefect, inUse]);

    useEffect(() => {
        if (inUse) {
            setSearch(undefined)
        }
    }, [inUse]);

    const toggleDrawer = (anchor, open, idcard = null) => (event) => {
        if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if (!open) {
            idcard = null;
        }
        setState(prev => ({
            ...prev,
            [anchor]: open,
            id: idcard
        }));
    };
    
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await get("Deal/get", {did:$data})
            let elData = JSON.parse(res.message.data)
            let tmp = []
            let c = 0

            if (elData.pricing) {setPrice(elData.pricing)}

            const dealId = await get('Deal/getHeader', {did:$data})
            if (dealId && dealId.cdn) {
                setDealNumber(dealId.cdn);
            }

            if (res && res.message.pay_info) {
                res.message.pay_info.map((el, index) => {
                    tmp.push({
                        ...el, 
                        id:index, 
                        status: {value:el.status, id:index},
                        count: el.count || 1,
                        sum: el.count? el.count*el.price: el.price
                    })
                    if (el.status === "Pay") {c+=1}
                })
                const responseDataCli = await get('Clients/get', {cid:res.message.client_id});
                console.log("responseDataCli", responseDataCli)
                let cliphone = responseDataCli?.message? responseDataCli.message.mobile_number: undefined
                console.log("cliphone", cliphone)
                const responseData = await get('UserRekv/get', {uid:res.message.client_id});
                if (responseData?.message) {
                    let obj = {
                        id:responseData.message.id,
                        data: JSON.parse(responseData.message.data) || {},
                        deal: elData.cdn,
                        cliphone
                    }
                    setRekv(obj)
                }
                if (elData.docDate) {
                    setDocDate(elData.docDate)
                }

                if (tmp.length !== 0 && tmp.length === c) {setAllPay("Pay")}
                setData(tmp)
            }
        }
        catch {}
        finally {setLoading(false);}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        let tmp = 0
        data.map((el) => {tmp += el.sum})
        setSum(tmp)
    }, [data])

    const { user_id } = useSelector(loginSelector);

    const onAddService = async (service, price) => {
        let tmp = JSON.parse(JSON.stringify(data))
        tmp.push({service, price, type: "hand", count: 1, sum: price, status:{value: "noPay", id:tmp.length}})
        await post("Deal/update", {id:$data, pay_info:tmp.map((el) => {return({status:el.status.value, type:el.type, service:el.service, price:el.price})}), status_pay: "noPay"})
        post("Logs/create", {
            deal_id:$data,
            user_type:"ful",
            user_id,
            type: "add_pay_service",
            data: {
                service
            }
        })
        setData(tmp)
    }

    const onChangeStatus = async (indata) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((el) => el.id === indata.row.id)
        if (idx > -1) {
            tmp[idx].status.value = indata.data
        }
        setData(tmp)
        let f = true
        await post("Deal/update", {id:$data, pay_info:tmp.map((el) => {if (el.status.value === "noPay") {f = false}return({status:el.status.value, type:el.type, service:el.service, price:el.price})}), status_pay: f? "Pay": "noPay"})
        if (f) {setAllPay("Pay")} else {setAllPay("noPay")}
    }

    const del = async (item) => {
        let serv = data.find((el) => el.id === item.id)
        post("Logs/create", {
            deal_id:$data,
            user_type:"ful",
            user_id,
            type: "del_pay_service",
            data: {
                service:serv.service
            }
        })
        let tmp = JSON.parse(JSON.stringify(data)).filter((el) => el.id !== item.id)
        setData(tmp)
        let f = true
        await post("Deal/update", {id:$data, pay_info:tmp.map((el) => {if (el.status.value === "noPay") {f = false}return({status:el.status.value, type:el.type, service:el.service, price:el.price})}), status_pay: f? "Pay": "noPay"})
        if (f) {setAllPay("Pay")} else {setAllPay("noPay")}
    }

    const handleClickDelService = (item) => {
        ShowModal('Удалить услугу', 
        <div>Вы уверены, что хотите удалить услугу?</div>, 
        async () => {
            try {
                del(item)
            }
            catch (err) {}
            finally {}
        });
    }

    const massChange = async (v) => {
        setAllPay(v.data)
        let tmp = JSON.parse(JSON.stringify(data))
        tmp.map((el) => {
          el.status.value = v.data  
        })
        setData(tmp)
        await post("Deal/update", {id:$data, pay_info:tmp.map((el) => {return({status:el.status.value, type:el.type, service:el.service, price:el.price})}), status_pay: v.data})
        post("Logs/create", {
            deal_id:$data,
            user_type:"ful",
            user_id,
            type: "set_pay",
            data: {
                statusPay: v.data
            }
        })
    }

    const formatPrice = (value) => {
        return Number(value).toFixed(2).replace('.', ',');
    }

    const goToGenFile = (template, res) => {
        Object.keys(res).map((k) => {
            res[k] = res[k].value
        })
        genDoc(template, res)
    }

    const showDocFeatures = (template, obj) => {
        setDocObj({teplate: template, obj})
    }

    const generateSchet = async () => {
        if (rekv && rekv.data && rekv.data.INN && rekv.data.ADDR && rekv.data.type && rekv.data.name) {
            let date = undefined
            if (docDate) {
                date = docDate
            } else {
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                date = `${day}.${month}.${year}`
                post("Deal/update", {id:$data, data: {docCreate: date}})
                setDocDate(date)
            }
            
            let items = []
            let all_sum = 0.0
            data.map((el, index) => {
                let count = el.count || 1
                items.push({
                    index: String(index + 1),
                    service: el.service,
                    count: String(count),
                    price: formatPrice(el.price),
                    ed: "Ед.",
                    sum: formatPrice(el.price * count)
                })
                all_sum += parseFloat(el.price)*count
            })

            let ndsProc = 0.07
            let user_info = `${rekv.data.type} ${rekv.data.name}, ИНН ${rekv.data.INN}, КПП ${rekv.data.KPP}, ${rekv.data.ADDR}`
            let obj = {
                number: {value: rekv.deal, title: "Номер договора"},
                date: {value: date, title: "Дата"},
                user: {value: user_info, title: "Информация о клиенте"},
                items: {value: items, noShow:true},
                item_count: {value: items.length - 1, noShow:true},
                all_sum: {value: formatPrice(all_sum), noShow:true},
                all_sum_text: {
                    value: numberToWordsRu.convert(all_sum, {
                        currency: 'rub',
                        convertNumbertToWords: {
                            integer: true,
                            fractional: true,
                        },
                    }),
                    noShow:true
                },
                nds_sum: {value: formatPrice(all_sum*ndsProc), noShow:true},
                nds_sum_text: {
                    value: numberToWordsRu.convert(all_sum*ndsProc, {
                        currency: 'rub',
                        convertNumbertToWords: {
                            integer: true,
                            fractional: true,
                        },
                    }),
                    noShow:true
                },
            }
            showDocFeatures("template_schet", obj)
        } else {
            showNotification({
                id: 'noRekv', 
                type: 'error', 
                message: 'Клиент не указал свои реквизиты' 
            });
        }
    };

    
    const generateAct = async () => {
        if (rekv && rekv.data && rekv.data.INN && rekv.data.ADDR && rekv.data.type && rekv.data.name) {
            let date = undefined
            if (docDate) {
                date = docDate
            } else {
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                date = `${day}.${month}.${year}`
                post("Deal/update", {id:$data, data: {docCreate: date}})
                setDocDate(date)
            }
            
            let items = []
            let all_sum = 0.0
            data.map((el, index) => {
                let count = el.count || 1
                items.push({
                    index: String(index + 1),
                    service: el.service,
                    count: String(count),
                    price: formatPrice(el.price),
                    ed: "Ед.",
                    sum: formatPrice(el.price * count)
                })
                all_sum += parseFloat(el.price)*count
            })

            let ndsProc = 0.07
            let user_info = `${rekv.data.type} ${rekv.data.name}, ИНН ${rekv.data.INN}, КПП ${rekv.data.KPP}, ${rekv.data.ADDR}`
            let obj = {
                number: {value: rekv.deal, title: "Номер договора"},
                date: {value: date, title: "Дата"},
                user: {value: user_info, title: "Информация о клиенте"},
                user_name: {value: rekv.data.name, title: "Имя клиента"},
                user_inn: {value: rekv.data.INN, title: "ИНН клиента"},
                user_kpp: {value: rekv.data.KPP, title: "КПП клиента"},
                user_type: {value: rekv.data.type, title: "Вид клиента"},
                user_addr: {value: rekv.data.ADDR, title: "Адрес клиента"},
                items: {value: items, noShow:true},
                item_count: {value: items.length - 1, noShow:true},
                all_sum: {value: formatPrice(all_sum), noShow:true},
                all_sum_text: {
                    value: numberToWordsRu.convert(all_sum, {
                        currency: 'rub',
                        convertNumbertToWords: {
                            integer: true,
                            fractional: true,
                        },
                    }),
                    noShow:true
                },
                nds_sum: {value: formatPrice(all_sum*ndsProc), noShow:true},
                nds_sum_text: {
                    value: numberToWordsRu.convert(all_sum*ndsProc, {
                        currency: 'rub',
                        convertNumbertToWords: {
                            integer: true,
                            fractional: true,
                        },
                    }),
                    noShow:true
                },
            }
            showDocFeatures("template_act", obj);
        } else {
            showNotification({
                id: 'noRekvAct',
                type: 'error',
                message: 'Клиент не указал свои реквизиты'
            });
        }
    };

    const generateUPD = async () => {
        if (rekv && rekv.data && rekv.data.INN && rekv.data.ADDR && rekv.data.type && rekv.data.name) {
            let date = undefined
            if (docDate) {
                date = docDate
            } else {
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                date = `${day}.${month}.${year}`
                post("Deal/update", {id:$data, data: {docCreate: date}})
                setDocDate(date)
            }

            let ndsProc = 0.07
            let items = []
            let all_sum = 0.0
            data.map((el, index) => {
                let count = el.count || 1
                items.push({
                    index: String(index + 1),
                    service: el.service,
                    count: String(count),
                    price: formatPrice(el.price*(1-ndsProc)),
                    ed: "Ед.",
                    sum: formatPrice(el.price * count),
                    nds_sum: formatPrice((el.price * count)*ndsProc),
                    sum_without_nds: formatPrice((el.price * count)*(1-ndsProc))
                })
                all_sum += parseFloat(el.price)*count
            })

            let user_info = `${rekv.data.type} ${rekv.data.name}, ИНН ${rekv.data.INN}, КПП ${rekv.data.KPP}, ${rekv.data.ADDR}`
            let obj = {
                number: {value: rekv.deal, title: "Номер договора"},
                date: {value: date, title: "Дата"},
                user: {value: user_info, title: "Информация о клиенте"},
                user_name: {value: rekv.data.name, title: "Имя клиента"},
                user_inn: {value: rekv.data.INN, title: "ИНН клиента"},
                user_kpp: {value: rekv.data.KPP, title: "КПП клиента"},
                user_type: {value: rekv.data.type, title: "Вид клиента"},
                user_addr: {value: rekv.data.ADDR, title: "Адрес клиента"},
                items: {value: items, noShow:true},
                item_count: {value: items.length - 1, noShow:true},
                all_sum: {value: formatPrice(all_sum), noShow:true},
                nds_sum: {value: formatPrice(all_sum*ndsProc), noShow:true},
                sum_without_nds: {value: formatPrice(all_sum*(1-ndsProc)), noShow:true},
            }
            showDocFeatures("template_upd", obj);
        } else {
            showNotification({
                id: 'noRekvUPD',
                type: 'error',
                message: 'Клиент не указал свои реквизиты'
            });
        }
    };

    const generateSchetFactura = async () => {
        if (rekv && rekv.data && rekv.data.INN && rekv.data.ADDR && rekv.data.type && rekv.data.name) {
            let date = undefined
            if (docDate) {
                date = docDate
            } else {
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                date = `${day}.${month}.${year}`
                post("Deal/update", {id:$data, data: {docCreate: date}})
                setDocDate(date)
            }

            let ndsProc = 0.07
            let items = []
            let all_sum = 0.0
            data.map((el, index) => {
                let count = el.count || 1
                items.push({
                    index: String(index + 1),
                    service: el.service,
                    count: String(count),
                    price: formatPrice(el.price*(1-ndsProc)),
                    ed: "Ед.",
                    sum: formatPrice(el.price * count),
                    nds_sum: formatPrice((el.price * count)*ndsProc),
                    sum_without_nds: formatPrice((el.price * count)*(1-ndsProc))
                })
                all_sum += parseFloat(el.price)*count
            })

            let obj = {
                number: {value: rekv.deal, title: "Номер договора"},
                date: {value: date, title: "Дата"},
                user_name: {value: rekv.data.name, title: "Имя клиента"},
                user_inn: {value: rekv.data.INN, title: "ИНН клиента"},
                user_kpp: {value: rekv.data.KPP, title: "КПП клиента"},
                user_type: {value: rekv.data.type, title: "Вид клиента"},
                user_addr: {value: rekv.data.ADDR, title: "Адрес клиента"},
                items: {value: items, noShow:true},
                item_count: {value: items.length - 1, noShow:true},
                all_sum: {value: formatPrice(all_sum), noShow:true},
                nds_sum: {value: formatPrice(all_sum*ndsProc), noShow:true},
                sum_without_nds: {value: formatPrice(all_sum*(1-ndsProc)), noShow:true},
            }
            showDocFeatures("template_schet_faktura", obj);
        } else {
            showNotification({
                id: 'noRekvSchetFactura',
                type: 'error',
                message: 'Клиент не указал свои реквизиты'
            });
        }
    };

    return (
        <div style={{display: "flex", flexDirection: "column", height: "calc(94% - 50px )", width: "98%", margin: "0% 1% 1% 1%"}}>

            <Dialog
                open={docObj}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setDocObj(undefined) }}
            >
                <div style={{ height: '620px', width: '500px', padding: '12px', }}>
                    <DocFeaturePreview obj={docObj?.obj || undefined} save={(s) => {goToGenFile(docObj?.teplate || undefined, s); setDocObj(undefined)}}/>
                </div>
            </Dialog>
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '350px', width: '300px', padding: '12px' }}>
                    <AddServiceToPay cancel={setOpen} onSave={onAddService} />
                </div>
            </Dialog>
            <div style={{
                width: '100%', 
                height: '100%', 
                overflow: 'hidden',
                borderRadius: "10px",
                backgroundColor: 'white'
            }}>
                {loading? <Loading/>:
                <Scrollbars style={{ height: "89%" }} autoHide>
                    <ReportTable
                        ds={ds}
                        data={data}
                        onFormatterChange={onChangeStatus}
                        aditionalAction={[
                            {
                                action: (item) => { handleClickDelService(item) },
                                ui: () => (
                                    <DeleteForeverIcon sx={{ 
                                        transition: 'all 0.3s ease', 
                                        '&:hover': hoverStyle 
                                    }} />
                                )
                            }
                        ]}
                    />
                </Scrollbars>
                }

                {/* Нижняя панель с итогами */}
                <div style={{ 
                    borderLeft: '4px solid ' + colors.elements, 
                    display: 'flex', 
                    flexDirection: 'row', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    height: "8%",
                    margin: '1% 1% 1% 1%'
                }}>
                    <div style={{ marginLeft: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Typography variant="h2">Итоговая стоимость: {sum}</Typography>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Button variant="contained" onClick={() => setOpen(true)} sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }}>
                            Добавить услугу
                        </Button>
                        {/* Единая кнопка для генерации документов */}
                        <Button 
                            variant="contained" 
                            onClick={handleMenuOpen} 
                            sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }}
                        >
                            Сгенерировать документ
                        </Button>
                        <Menu
                            anchorEl={menuAnchorEl}
                            open={menuOpen}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={() => { generateSchet(); handleMenuClose(); }}>
                                Счёт на оплату
                            </MenuItem>
                            <MenuItem onClick={() => { generateAct(); handleMenuClose(); }}>
                                Акт работ
                            </MenuItem>
                            <MenuItem onClick={() => { generateUPD(); handleMenuClose(); }}>
                                УПД
                            </MenuItem>
                            <MenuItem onClick={() => { generateSchetFactura(); handleMenuClose(); }}>
                                Счет-фактура
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
            </div>
        </div>
    );
}

function DocFeaturePreview({obj, save}) {
    const [data, setData] = useState({})

    useEffect(() => {
        if (obj) {
            setData(obj)
        }
    }, [obj]);

    const setFeature = (k, v) => {
        let tmp = JSON.parse(JSON.stringify(data))
        _.set(tmp,`${k}.value`,v)
        setData(tmp)
    }

    return (
        <div style={{ height: '100%' }}>
        <Scrollbars autoHide style={{ height: '100%' }}>
            {/* Контейнер для вертикального расположения карточек */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}>
            {Object.keys(data).map((k) => (
                <>
                    {!data[k].noShow &&
                        <TextInput title={data[k].title} val={data[k].value} onChange={(v) => {setFeature(k, v)}}/>
                    }
                </>
            ))}
            <Button variant="contained" onClick={() => {save(data)}} sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }}>
                Сгенерировать документ
            </Button>
            </Box>
        </Scrollbars>
        </div>
    );
    
}

function AddServiceToPay({cancel, onSave}) {
    const [service, setService] = useState("");
    const [price, setPrice] = useState(0);  

    const changeValue = (text) => {
        setService(text);
    }

    const changeNumValue = (val) => {
        let num = parseInt(val)
        if (!isNaN(num)) {
            setPrice(num)
        }
    }

    const preventDoubleClick = usePreventDoubleClick();
    const { showNotification } = useLocalNotifications();

    const addService = async () => {
        if (service && price >= 0) {
            if (onSave) {onSave(service, price)}
            cancel(false)
        }
        else {
            showNotification({
                id: 'erraddservice', 
                type: 'error', 
                message: 'Параметры введены неверно' 
            });
        }
    }

    return (
        <div style={{display: "flex", flexDirection:"column", alignItems: "center", width: "100%", height:"100%", justifyContent:"space-between"}}>
            <div style={{display: "flex", flexDirection:"column", alignItems: "center"}}>
                <TextField
                    label={"Название услуги"}
                    value={service}
                    variant="standard"
                    onChange={(event) => changeValue(event.target.value)}
                    style={{marginTop:"10px"}}
                />
                <TextField
                    label={"Стоимость услуги"}
                    value={price}
                    variant="standard"
                    onChange={(event) => changeNumValue(event.target.value)}
                    style={{marginTop:"10px"}}
                />
            </div>
            <div style={{display: "flex", flexDirection:"row", justifyContent: "space-between", alignItems: "center", marginTop:"10px"}}>
                <Button
                    onClick={preventDoubleClick(addService, 1000)}
                    variant="contained"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        width: "100px",
                        marginRight: "10px"
                    }}
                >
                    Добавить
                </Button>
                <Button
                    onClick={() => cancel(false)}
                    variant="contained"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        backgroundColor: "grey.500",
                        "&:hover": { backgroundColor: "grey.600" },
                        width: "100px"
                    }}
                >
                    Отмена
                </Button>
            </div>
        </div>
    );
}


// @ts-ignore
export function Deal($data) {
    const [tab, setTab] = useState(undefined);
    const [loading, setLoading] = useState(true)
    const [isFBS, setIsFBS] = useState(false)

    const [info, setInfo] = useState(undefined)
    const [search, setSearch] = useState(undefined)

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [resetKey, setResetKey] = useState(0);
    
    // Храним информацию о том, какие вкладки уже были загружены
    /** @type {[any, Function]} */
    const [loadedTabs, setLoadedTabs] = useState({}); // первая вкладка загружается сразу

    /** @type {[any, Function]} */
    const [state, setState] = useState({
        right: false,
        id: 0
    });

    const { rules } = useSelector(
        loginSelector
    );

    // const { DealTab } = useSelector(DealTabSelector);
    const { dealId } = useParams();

    const handleChange = (event, newTab) => {

        if (!loadedTabs[newTab]) {
            setLoadedTabs((prev) => ({ ...prev, [newTab]: true }));
        }
        setInfo(undefined)
        setSearch(undefined)
        setTab(newTab);
        sessionStorage.setItem(`DEALTAB_admin_${dealId}`, newTab)
    };

    useEffect(() => {
        handleChange(undefined, Number(sessionStorage.getItem(`DEALTAB_admin_${dealId}`)) || 0)
    }, []);
    


    

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            if (dealId) {
                let resp = await get("Deal/isFBS", {did: dealId})
                setIsFBS(resp.fbs)
                setLoading(false);
            }
        }
        catch {}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, [dealId]);

    const toggleDrawer = (anchor, open, idcard = null) => (event) => {
        console.log("idcard", idcard)
        if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        const changeToggle = () => {
            if (!open) {
                idcard = null;
            }

            setState(prev => ({
                ...prev,
                [anchor]: open,
                id: idcard
            }));
        }


        if (!open && unsavedChanges) {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть шторку?</div>,
                async () => {
                    changeUnsaved(false)
                    changeToggle();
                }
            );
            return;
        }
        changeToggle()
    };
    console.log("state", state)

    const dropLoading = (inds, tab) => {
        var tmp = JSON.parse(JSON.stringify(loadedTabs))
        for (let i of inds) {
            delete tmp[i]
        }
        setLoadedTabs(tmp)
        setResetKey(prev => prev + 1);
        setLoadedTabs({ [tab]: true });
    }

    const changeUnsaved = (v) => {
        console.log("changeUnsaved", v)
        if (unsavedChanges && !v) {
            // Увеличиваем ключ, чтобы все вкладки пересоздались
            setResetKey(prev => prev + 1);
            // Опционально: сбросить loadedTabs, если нужно, чтобы вкладки считались незагруженными
            // setLoadedTabs({}); // но тогда нужно будет заново загрузить текущую вкладку
            // Можно совместить: сбросить loadedTabs и сразу установить текущую как загруженную
            // @ts-ignore
            setLoadedTabs({ [tab]: true });
        }
        setUnsavedChanges(v)
    }

    return (

        <Box sx={{ width: '100%', height: '100%'}}>
            {/* <FindTextField styleAround={{ padding: '1% 10% 1% 1%' }}></FindTextField>    */}
            <Drawer
                anchor='right'
                open={state['right']}
                PaperProps={{
                    sx: { width: '35%' }
                }}
                onClose={toggleDrawer('right', false)}
            >
                <ElementInfo 
                    ds={isFBS? getDataSource('EIDealFBS'): getDataSource('EIDeal')} 
                    data = {dealId}
                    // @ts-ignore
                    setChanged={changeUnsaved}
                    // @ts-ignore
                    reload={() => {dropLoading([0,1,2], tab)}}
                />
            </Drawer>

            {!loading && <IconButton
                aria-label="toggle"
                onClick={
                    state['right']
                        ? toggleDrawer('right', false)
                        // @ts-ignore
                        : toggleDrawer('right', true, dealId)
                }
                size='small'
                sx={{
                    position: 'fixed',
                    top: '15%',
                    right: state['right'] ? '35%' : 0,
                    transition: 'right 0.3s ease',
                    zIndex: 1300,
                    backgroundColor: '#dbdbdb',
                    borderRadius: '8px 0 0 8px',
                    '&:hover': {
                        backgroundColor: '#c4c4c4'
                    }
                }}
            >
                {state['right'] ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>}
            <div style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    justifyContent: "space-between", 
                    alignItems: "center", 
                    height: "5%", 
                    margin: "10px 1% 10px 1%"
                }}
            >
                <div key={`search_${tab}`}>{search || <div></div>}</div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '10px',
                    }}>
                        {!info? 
                            <Loading/>
                        :
                            info
                        }
                    </Box>
                </div>
            </div>
            <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                margin: '0% 0% 0% 1%',
                height: "30px",
                minHeight: "30px"
            }}>

                <DealTab label="ТАБЛИЦА" />
                {(rules.includes("deal.inner.linker") || rules.includes("admin")) && <DealTab label="ПРИВЯЗКА" /> }
                {(rules.includes("deal.inner.pay") || rules.includes("admin")) && <DealTab label="OПЛАТА" /> }
            </Tabs>
            {/* Вкладка 0 - Таблица */}
            {loadedTabs[0] && (
                <div style={{ display: tab === 0 ? 'block' : 'none', height: 'calc( 100% - 5px)' }} key={`tab-0-${resetKey}`}>
                <TableDeal $data={dealId} setMainInfo={setInfo} setSearch={setSearch} inUse={tab === 0} dropLoad={dropLoading}/>
                </div>
            )}

            {/* Вкладка 1 - Привязка */}
            {(rules.includes("deal.inner.linker") || rules.includes("admin")) && loadedTabs[1] && (
                <div style={{ display: tab === 1 ? 'block' : 'none', height: 'calc( 100% - 5px)' }} key={`tab-1-${resetKey}`}>
                <BindDeal $data={dealId} setInfo={setInfo} setSearch={setSearch} inUse={tab === 1}/>
                </div>
            )}

            {/* Вкладка 2 - Оплата */}
            {(rules.includes("deal.inner.pay") || rules.includes("admin")) && loadedTabs[2] && (
                <div style={{ display: tab === 2 ? 'block' : 'none', height: 'calc( 100% - 5px)' }} key={`tab-2-${resetKey}`}>
                <PayDeal $data={dealId} setInfo={setInfo} setSearch={setSearch} inUse={tab === 2}/>
                </div>
            )}
        </Box>
    );
}